// Auto-generated from mobile/locales/*.json
// Provides all translation keys with their existing translations per locale

export const DEFAULT_TRANSLATION_KEYS: Record<string, Record<string, string>> = {
  "es": {
    "tabs.home": "Home",
    "tabs.ritual": "Ritual",
    "tabs.shop": "Tienda",
    "tabs.garden": "Jardín",
    "tabs.rewards": "Regalos",
    "common.back": "Volver",
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.delete": "Eliminar",
    "common.retry": "Reintentar",
    "common.close": "Cerrar",
    "common.confirm": "Confirmar",
    "common.loading": "Cargando...",
    "common.error": "Error",
    "common.ok": "OK",
    "common.seeAll": "Ver todas →",
    "common.days": "días",
    "common.day": "día",
    "common.points": "puntos",
    "common.pts": "pts",
    "common.noResults": "Sin resultados",
    "date.sunday": "Domingo",
    "date.monday": "Lunes",
    "date.tuesday": "Martes",
    "date.wednesday": "Miércoles",
    "date.thursday": "Jueves",
    "date.friday": "Viernes",
    "date.saturday": "Sábado",
    "date.january": "enero",
    "date.february": "febrero",
    "date.march": "marzo",
    "date.april": "abril",
    "date.may": "mayo",
    "date.june": "junio",
    "date.july": "julio",
    "date.august": "agosto",
    "date.september": "septiembre",
    "date.october": "octubre",
    "date.november": "noviembre",
    "date.december": "diciembre",
    "date.dateFormat": "{{day}}, {{date}} de {{month}}",
    "home.reorderTitle": "Repetir mi último pedido",
    "home.reorderSubtitle": "Pide de nuevo en un clic",
    "home.reorderBtn": "Pedir",
    "home.oneClickTitle": "Repetir pedido",
    "home.oneClickBtn": "Pedir",
    "home.oneClickConfirmTitle": "¿Repetir pedido?",
    "home.oneClickConfirmTotal": "Total: {{total}} €",
    "home.oneClickConfirmCard": "Se cobrará a tu tarjeta ····{{digits}}",
    "home.oneClickConfirmBtn": "Confirmar pedido",
    "home.oneClickSuccess": "¡Pedido realizado! Recibirás un email de confirmación.",
    "home.streakDays": "🔥 {{count}} días de racha",
    "home.wildcardAvailable": "🛡️ 1 día de gracia disponible",
    "home.nextMilestone": "⭐ {{days}}d → +{{points}}pts",
    "home.treesCount_one": "🌳 {{count}} árbol en tu jardín",
    "home.treesCount_other": "🌳 {{count}} árboles en tu jardín",
    "home.yourRitualToday": "Tu ritual de hoy",
    "home.savedRecipes": "Mis recetas guardadas",
    "home.matchaFinished": "Tu matcha ya se ha terminado",
    "home.matchaRunningOut": "Tu matcha se acaba en ~{{days}} días",
    "home.dontLoseStreak": "¡No pierdas tu racha!",
    "home.oneClick": "1 clic",
    "home.restock": "Reponer",
    "home.orderInProgress": "Pedido en curso",
    "home.lastOrder": "Tu último pedido",
    "home.seeAllOrders": "Ver todos mis pedidos →",
    "home.dailyRitual": "Tu ritual diario",
    "home.nextStep": "SIGUIENTE PASO",
    "home.ritualBonus": "Completa los 5 hoy y gana +5 pts bonus",
    "home.ritualCta.start": "Empezar mi ritual →",
    "home.ritualCta.continue": "Continuar ritual →",
    "home.ritualCta.completed": "Ver resumen →",
    "home.linkAccount": "Vincula tu cuenta",
    "home.linkAccountDesc": "Sincroniza tus pedidos y puntos vinculando tu email",
    "home.stat.streakLabel": "DÍAS\nDE RACHA",
    "home.stat.pointsLabel": "PUNTOS\nGANADOS",
    "home.stat.levelLabel": "NIVEL\nACTUAL",
    "home.statModal.streakTitle": "Días de racha",
    "home.statModal.streakBody": "Tu racha cuenta los días consecutivos que completas al menos un paso de tu ritual diario.\n\nMantener la racha desbloquea bonificaciones de puntos en los hitos de 7, 14 y 30 días.\n\nSi un día no puedes, tienes un día de gracia que protege tu racha una vez.",
    "home.statModal.pointsTitle": "Puntos ganados",
    "home.statModal.pointsBody": "Los puntos son tu moneda dentro de Matcha & CO. Los ganas completando tu ritual diario, encuestas y otras actividades.\n\nPuedes canjearlos por recompensas exclusivas como productos gratis, descuentos y regalos especiales.\n\nEste contador muestra tus puntos disponibles para canjear.",
    "home.statModal.levelTitle": "Nivel actual",
    "home.statModal.levelIntro": "Tu nivel refleja tu compromiso acumulado con Matcha & CO. Sube de nivel ganando puntos a lo largo del tiempo.",
    "home.statModal.levelNeverDrops": "A diferencia de los puntos canjeables, el nivel nunca baja.",
    "home.greetingMorning": "BUENOS DÍAS",
    "home.greetingAfternoon": "BUENAS TARDES",
    "home.greetingEvening": "BUENAS NOCHES",
    "home.greetingFallback": "¡Hola!",
    "home.today": "HOY",
    "home.understood": "Entendido",
    "home.rewardsTitle": "RECOMPENSAS",
    "home.rewardsSubtitle": "Regalos exclusivos",
    "home.seeAllRewards": "Ver todos los regalos  →",
    "home.recipeOfDay": "RECETA DEL DÍA",
    "home.motivational_0": "Cada taza es un paso hacia tu bienestar 🍵",
    "home.motivational_1": "Tu cuerpo te lo agradece 🌿",
    "home.motivational_2": "Un ritual pequeño, un cambio enorme ✨",
    "home.motivational_3": "Hoy elegiste cuidarte 💚",
    "home.motivational_4": "Tu constancia es tu superpoder 🌱",
    "home.motivational_5": "Respira, bebe, sonríe. Repite mañana ☀️",
    "home.greetingHello": "¡Hola, {{name}}!",
    "home.paymentBannerTitle": "Añade tu tarjeta y haz tu próxima compra en un clic",
    "home.paymentBannerSubtitle": "Guarda tu método de pago para hacer tu próximo pedido más fácil y gana {{points}} puntos.",
    "home.paymentBannerBtn": "Añadir",
    "home.paymentMethodBonusSuccess": "¡Has ganado {{points}} puntos por añadir tu método de pago!",
    "ritual.emotionalCheckin": "Check-in emocional",
    "ritual.recommendedRecipe": "Receta recomendada",
    "ritual.meditation": "Meditación",
    "ritual.registerMatcha": "Registrar matcha",
    "ritual.journaling": "Journaling",
    "ritual.howDoYouFeel": "¿Cómo te sientes hoy?",
    "ritual.chooseMood": "Elige la emoción que mejor te represente",
    "ritual.whatRecipe": "¿Qué tipo de receta te apetece?",
    "ritual.yourState": "Tu estado: {{emoji}} {{label}}",
    "ritual.illusion": "Alegre",
    "ritual.calm": "Calma",
    "ritual.apathy": "Apatía",
    "ritual.anxiety": "Ansiedad",
    "ritual.sadness": "Tristeza",
    "ritual.allCategories": "Todas",
    "ritual.drinks": "Bebidas",
    "ritual.breakfast": "Desayuno",
    "ritual.desserts": "Postres",
    "ritual.mains": "Principales",
    "ritual.snacks": "Snacks",
    "ritual.doCheckinFirst": "Haz tu check-in emocional primero para que podamos recomendarte la receta perfecta para ti.",
    "ritual.doCheckinBtn": "Hacer check-in emocional 🫶",
    "ritual.noRecipes": "Sin recetas disponibles",
    "ritual.noRecipesDesc": "No hay recetas para este filtro. ¡Prueba otra categoría!",
    "ritual.completeAnyway": "Completar de todas formas ✓",
    "ritual.basedOnState": "Basada en tu estado: {{mood}}",
    "ritual.servings": "{{count}} porciones",
    "ritual.ingredients": "Ingredientes:",
    "ritual.preparation": "Preparación:",
    "ritual.complete": "Completar ✓",
    "ritual.guidedMeditation": "Meditación guiada",
    "ritual.minutesSingular": "{{count}} minuto",
    "ritual.minutesPlural": "{{count}} minutos",
    "ritual.startMeditation": "▶  Empezar meditación",
    "ritual.meditating": "Meditando... 🧘",
    "ritual.skip": "Saltar →",
    "ritual.alreadyDrankMatcha": "Ya tomé mi matcha",
    "ritual.whatMatchaToday": "¿Qué matcha tomaste hoy?",
    "ritual.selectMatchaType": "Selecciona el tipo de matcha",
    "ritual.matchaType_solo": "Matcha solo",
    "ritual.matchaType_latte": "Matcha con leche",
    "ritual.matchaType_protein": "Matcha proteína",
    "ritual.matchaType_collagen": "Matcha colágeno",
    "ritual.matchaType_creatine": "Matcha creatina",
    "ritual.matchaType_golden_milk": "Golden milk",
    "ritual.matchaType_iced": "Matcha frío",
    "ritual.matchaType_recipe": "En receta",
    "ritual.matchaType_other": "Otros",
    "ritual.streakLabel": "🔥 Racha: {{count}} días",
    "ritual.plantEvolved": "🌱 ¡Tu planta ha evolucionado!",
    "ritual.newTree": "🌳 ¡Has completado un árbol!",
    "ritual.journalingTitle": "Journaling 📝",
    "ritual.writeHere": "Escribe aquí...",
    "ritual.ritualComplete": "🎉 ¡Ritual completo!",
    "ritual.yourRitualToday": "Tu ritual de hoy",
    "ritual.bonusPoints": "+5 pts bonus. Tu planta te lo agradece 🌱",
    "ritual.completed": "✓ Completado",
    "ritual.completeFiveSteps": "✨ Completa los 5 pasos para ganar +5 pts bonus",
    "ritual.journalPrompt1": "¿Qué fue lo mejor de hoy?",
    "ritual.journalPrompt2": "¿Qué agradeces hoy?",
    "ritual.journalPrompt3": "¿Cómo quieres sentirte mañana?",
    "ritual.journalPrompt4": "¿Qué te ha hecho sonreír?",
    "ritual.meditationSubtitle_illusion": "Potencia esa alegría con gratitud y visualización",
    "ritual.meditationSubtitle_calm": "Profundiza en tu calma con respiración consciente",
    "ritual.meditationSubtitle_apathy": "Recupera tu energía y reconecta contigo",
    "ritual.meditationSubtitle_anxiety": "Libera la tensión y encuentra tu centro",
    "ritual.meditationSubtitle_sadness": "Abraza tus emociones con compasión y cariño",
    "ritual.moodLabel_illusion": "alegre",
    "ritual.moodLabel_calm": "calma",
    "ritual.moodLabel_apathy": "apatía",
    "ritual.moodLabel_anxiety": "ansiedad",
    "ritual.moodLabel_sadness": "tristeza",
    "ritual.checkin": "Check-in",
    "ritual.recipe": "Receta",
    "ritual.meditate": "Meditar",
    "ritual.matcha": "Matcha",
    "ritual.journal": "Journal",
    "shop.topSellers": "Top ventas",
    "shop.buy": "+ Añadir",
    "shop.all": "Todo",
    "shop.couldNotLoadProducts": "No se pudieron cargar los productos",
    "shop.noProductsInCategory": "No hay productos en esta categoría",
    "cart.title": "Carrito ({{count}})",
    "cart.myCart": "Mi cesta ({{count}})",
    "cart.myCartLabel": "Mi cesta",
    "cart.viewCartLabel": "Ver mi cesta",
    "cart.empty": "Vaciar",
    "cart.emptyCart": "Vaciar carrito",
    "cart.emptyCartConfirm": "¿Seguro?",
    "cart.cartIsEmpty": "Tu carrito está vacío",
    "cart.exploreShop": "Explora la tienda y añade productos",
    "cart.addFromShop": "Añade productos desde la tienda",
    "cart.goToShop": "Ir a la tienda",
    "cart.total": "Total",
    "cart.checkout": "Finalizar compra",
    "cart.checkoutError": "No se pudo crear el pedido. Inténtalo de nuevo.",
    "cart.freeShipping": "Envío gratis",
    "cart.subtotal": "Subtotal",
    "cart.shipping": "Envío",
    "cart.free": "Gratis",
    "cart.freeShippingAt": "Envío gratis a partir de {{amount}}",
    "cart.remove": "Eliminar",
    "cart.removeConfirm": "¿Quitar \"{{title}}\" del carrito?",
    "cart.clear": "Vaciar carrito",
    "cart.clearConfirm": "¿Seguro?",
    "cart.clearBtn": "Vaciar",
    "cart.emptyDesc": "Explora la tienda y añade productos",
    "cart.earnPoints": "⭐ Ganarás {{points}} puntos con esta compra",
    "cart.shippingAtCheckout": "Se calculará al pagar",
    "offers.addMore": "Añade <bold>{{amount}}€</bold> más para un <bold>{{percent}}% de descuento</bold>",
    "offers.maxUnlocked": "<bold>¡Máximo descuento desbloqueado!</bold> 🎉",
    "garden.dayLabel": "Día {{day}}",
    "garden.daysToNext": "{{days}} días para {{name}}",
    "garden.treeComplete": "¡Árbol completo! 🎉",
    "garden.consecutiveDays": "Días seguidos",
    "garden.totalWaterings": "Riegos totales",
    "garden.currentLevel": "Nivel actual",
    "garden.consecutiveDaysHelp": "Tu racha actual de días consecutivos haciendo check-in de matcha. ¡Si fallas un día, vuelve a cero!",
    "garden.totalWateringsHelp": "El número total de días que has hecho tu check-in de matcha. Cada check-in riega tu planta y la ayuda a crecer.",
    "garden.currentLevelHelp": "El nivel de tu planta. Crece a medida que acumulas días de check-in consecutivos. Al llegar al nivel máximo, se convierte en un árbol para tu jardín.",
    "garden.understood": "Entendido",
    "garden.badgesTitle": "Medallas y logros",
    "garden.badge_primer_brote": "Primer Brote",
    "garden.badge_racha_5": "Racha de 5",
    "garden.badge_racha_10": "Racha de 10",
    "garden.badge_racha_30": "Racha de 30",
    "garden.badge_primer_arbol": "Primer Árbol",
    "garden.badgeDesc_primer_brote": "Primer check-in",
    "garden.badgeDesc_racha_5": "5 días consecutivos",
    "garden.badgeDesc_racha_10": "10 días consecutivos",
    "garden.badgeDesc_racha_30": "30 días consecutivos",
    "garden.badgeDesc_primer_arbol": "30 días completados",
    "rewards.yourPoints": "Tus puntos",
    "rewards.level": "Nivel: {{current}}",
    "rewards.levelNext": "{{current}} → {{next}}",
    "rewards.availableRewards": "Regalos disponibles",
    "rewards.exclusiveApp": "Exclusivos de la app — no disponibles en la tienda",
    "rewards.comingSoon": "Próximamente",
    "rewards.comingSoonDesc": "Estamos preparando regalos exclusivos para ti. ¡Sigue acumulando puntos!",
    "rewards.merchandise": "Merchandising",
    "rewards.exclusiveProduct": "Producto exclusivo",
    "rewards.experience": "Experiencia",
    "rewards.outOfStock": "Agotado",
    "rewards.redeem": "Canjear",
    "rewards.missingPoints": "Faltan {{count}} pts",
    "rewards.linkAccountForRewards": "Necesitas vincular tu email para canjear regalos.",
    "rewards.insufficientPoints": "Puntos insuficientes",
    "rewards.insufficientPointsDesc": "Te faltan {{count}} puntos para canjear \"{{name}}\". ¡Sigue con tu ritual diario!",
    "rewards.redeemConfirm": "Canjear regalo",
    "rewards.redeemConfirmDesc": "¿Quieres canjear \"{{name}}\" por {{points}} puntos?",
    "rewards.redeemed": "¡Regalo canjeado! 🎉",
    "rewards.redeemedDesc": "Recibirás más información por email.",
    "rewards.redeemError": "Error al canjear",
    "rewards.myRedemptions": "Mis canjes",
    "rewards.statusPending": "⏳ Pendiente",
    "rewards.statusProcessing": "📦 Preparando",
    "rewards.statusShipped": "🚚 Enviado",
    "rewards.statusDelivered": "✅ Entregado",
    "rewards.howItWorks": "¿Cómo funciona?",
    "rewards.howStep1": "Completa tu ritual diario para ganar puntos",
    "rewards.howStep2": "Acumula puntos con rachas, compras y referidos",
    "rewards.howStep3": "Canjea tus puntos por regalos exclusivos",
    "rewards.morePointsNeeded": "{{count}} pts más para {{level}}",
    "rewards.rewardsTitle": "Recompensas",
    "rewards.pointsAvailable": "puntos disponibles",
    "rewards.howToEarnPoints": "¿Cómo ganar puntos?",
    "rewards.earn_purchases": "Compras: +1 pt por cada 1€ gastado",
    "rewards.earn_ritualStep": "Cada paso del Ritual diario: +1 pt",
    "rewards.earn_ritualComplete": "Completar el Ritual diario: +5 pts bonus",
    "rewards.earn_referralRegister": "Invitar amigos/as: +50 pts por registro",
    "rewards.earn_referralPurchase": "Compra de tu invitado/a: +150 pts",
    "rewards.earn_survey": "Completar encuestas: puntos variables",
    "rewards.earn_review": "Escribir una opinión de tu compra: +50 pts",
    "orders.myOrders": "Mis pedidos",
    "orders.processing": "Procesando",
    "orders.delivered": "Entregado",
    "orders.inTransit": "En camino",
    "orders.shipped": "Enviado",
    "orders.partiallySent": "Parcialmente enviado",
    "orders.inPreparation": "En preparación",
    "orders.cancelled": "Cancelado",
    "orders.outForDelivery": "En reparto",
    "orders.exception": "Incidencia",
    "orders.returned": "Devuelto",
    "orders.login": "Inicia sesión",
    "orders.loginDesc": "Vincula tu cuenta para ver tus pedidos",
    "orders.linkAccount": "Vincular cuenta",
    "orders.loadingOrders": "Cargando pedidos...",
    "orders.loadError": "Error al cargar",
    "orders.noOrders": "Sin pedidos",
    "orders.noOrdersDesc": "Aún no has realizado ningún pedido",
    "orders.goToShop": "Ir a la tienda",
    "orders.viewDetail": "Ver detalle",
    "orders.loadMore": "Cargar más pedidos",
    "orders.refunded": "Reembolsado",
    "surveys.title": "Novedades",
    "surveys.subtitle": "Descubre las últimas novedades, encuestas y contenido exclusivo",
    "surveys.noSurveys": "No hay novedades disponibles",
    "surveys.noSurveysDesc": "Te avisaremos cuando haya nuevas novedades. ¡Sigue con tu ritual diario!",
    "surveys.question": "Pregunta {{number}}",
    "surveys.required": "Obligatoria",
    "surveys.answered": "{{answered}} de {{total}} respondidas",
    "surveys.writeAnswer": "Escribe tu respuesta...",
    "surveys.completeSurvey": "Completar encuesta",
    "surveys.thanks": "¡Gracias!",
    "surveys.pointsEarned": "Has ganado ⭐ {{points}} puntos",
    "surveys.answersHelp": "Tus respuestas nos ayudan a mejorar tu experiencia matcha 🍵",
    "surveys.surveyNotFound": "Encuesta no encontrada",
    "surveys.loadError": "No se pudo cargar la encuesta.",
    "surveys.submitError": "Error al enviar la encuesta",
    "surveys.questions_one": "{{count}} pregunta",
    "surveys.questions_other": "{{count}} preguntas",
    "surveys.survey": "Encuesta",
    "profile.myProfile": "Mi perfil",
    "profile.matchaPoints": "⭐ {{count}} Matcha Points",
    "profile.orders": "Pedidos",
    "profile.points": "Puntos",
    "profile.streak": "Racha",
    "profile.badges": "Medallas",
    "profile.shippingAddress": "Dirección de envío",
    "profile.edit": "Editar",
    "profile.add": "Añadir",
    "profile.firstName": "Nombre",
    "profile.lastName": "Apellidos",
    "profile.phone": "Teléfono",
    "profile.address": "Dirección",
    "profile.addressPlaceholder": "Calle, número, piso...",
    "profile.addressLine2": "Dirección (línea 2)",
    "profile.optional": "Opcional",
    "profile.city": "Ciudad",
    "profile.zip": "C.P.",
    "profile.province": "Provincia",
    "profile.country": "País",
    "profile.invalidPhone": "Número de teléfono no válido",
    "profile.addressUpdated": "Dirección actualizada",
    "profile.addressSaved": "Tu dirección de envío se ha guardado correctamente.",
    "profile.saveError": "Error al guardar la dirección",
    "profile.saving": "Guardando...",
    "profile.saveAddress": "Guardar dirección",
    "profile.addShippingAddress": "Añadir dirección de envío",
    "profile.inviteFriend": "Invita a un amigo",
    "profile.inviteReward": "Gana 50 pts por registro + 150 pts por compra",
    "profile.shareLink": "Compartir enlace",
    "profile.shareMessage": "¡Prueba Matcha & CO! Usa mi código para obtener un descuento en tu primer pedido. https://matchaandco.com",
    "profile.shareMessageWithLink": "¡Prueba Matcha & CO! Descarga la app y gana 25 puntos de bienvenida 🍵 {{link}}",
    "profile.referralInvited": "Invitados",
    "profile.referralConverted": "Registrados",
    "profile.referralPointsEarned": "Pts ganados",
    "profile.yourReferralCode": "Tu código de referido",
    "profile.referralCodePlaceholder": "Ej: ABC123",
    "profile.applyCode": "Aplicar código",
    "profile.referralCodeTitle": "¿Tienes un código de referido?",
    "profile.referralCodeHint": "Introduce el código de un amigo para ganar 25 puntos",
    "profile.referralApplied": "¡Código aplicado!",
    "profile.referralError": "Error al aplicar el código",
    "profile.notifications": "Notificaciones",
    "profile.myOrdersMenu": "Mis pedidos",
    "profile.quickReorder": "Recompra rápida",
    "profile.helpSupport": "Ayuda y soporte",
    "profile.terms": "Términos y condiciones",
    "profile.signOut": "Cerrar sesión",
    "profile.signOutConfirm": "¿Estás seguro?",
    "profile.language": "Idioma",
    "profile.selectLanguage": "Selecciona tu idioma",
    "profile.selectProvince": "Seleccionar provincia",
    "profile.searchProvince": "Buscar provincia...",
    "profile.selectCountry": "Seleccionar país",
    "profile.referralAlready": "Ya has aplicado un código de referido",
    "profile.referralSelf": "No puedes usar tu propio código",
    "profile.referralNotFound": "Código no encontrado",
    "profile.referralExpired": "Este código ha expirado",
    "profile.paymentMethod": "Método de pago",
    "profile.paymentMethodHint": "Guarda tu método de pago para comprar en un clic",
    "profile.paymentMethodUpdated": "Método de pago actualizado",
    "profile.paymentMethodUpdatedDesc": "Tu método de pago se ha guardado correctamente.",
    "auth.linkAccount": "Vincula tu cuenta",
    "orderStatus.processing": "Procesando",
    "orderStatus.delivered": "Entregado",
    "orderStatus.inTransit": "En camino",
    "orderStatus.shipped": "Enviado",
    "orderStatus.partiallySent": "Parcialmente enviado",
    "language.es": "Español",
    "language.en": "English",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.it": "Italiano",
    "language.nl": "Nederlands",
    "language.de": "Deutsch",
    "language.pl": "Polski",
    "product.notFound": "Producto no encontrado",
    "product.back": "Volver",
    "product.variant": "Variante",
    "product.quantity": "Cantidad",
    "product.description": "Descripción",
    "product.addToCart": "Añadir al carrito",
    "product.addedToCart": "Añadido al carrito",
    "product.continueShopping": "Seguir comprando",
    "product.viewCart": "Ver carrito",
    "product.unit_one": "unidad",
    "product.unit_other": "unidades",
    "product.ingredients": "Ingredientes",
    "checkout.confirmOrder": "Confirmar pedido",
    "checkout.cartEmpty": "Tu carrito está vacío",
    "checkout.products": "Productos",
    "checkout.shippingAddress": "Dirección de envío",
    "checkout.changeAddress": "Cambiar dirección",
    "checkout.addAddress": "Añadir dirección",
    "checkout.couldNotLoadAddress": "No se pudo cargar la dirección",
    "checkout.paymentMethod": "Método de pago",
    "checkout.changePayment": "Cambiar método de pago",
    "checkout.useStandardCheckout": "Usar checkout estándar",
    "checkout.couldNotLoadPayment": "No se pudo cargar el método de pago",
    "checkout.noPaymentMethod": "No hay método de pago guardado",
    "checkout.addPaymentMethod": "Añadir tarjeta",
    "checkout.subtotal": "Subtotal",
    "checkout.shipping": "Envío",
    "checkout.tax": "Impuestos",
    "checkout.free": "Gratis",
    "checkout.total": "Total",
    "checkout.securePayment": "Pago seguro",
    "checkout.placeOrder": "Finalizar pedido",
    "checkout.quantity": "Cantidad: {{count}}",
    "checkout.requiredFields": "Campos obligatorios",
    "checkout.requiredFieldsDesc": "Rellena al menos nombre, dirección, ciudad y código postal.",
    "checkout.addressError": "No se pudo actualizar la dirección. Inténtalo de nuevo.",
    "checkout.orderSuccess": "¡Pedido realizado! 🎉",
    "checkout.orderSuccessDesc": "Tu pedido se ha procesado correctamente. Recibirás un email de confirmación.",
    "checkout.orderSuccessBtn": "Perfecto",
    "checkout.orderError": "No se pudo procesar el pedido. Inténtalo de nuevo.",
    "checkout.unexpectedError": "Ocurrió un error inesperado. Inténtalo de nuevo.",
    "checkout.checkoutError": "No se pudo crear el pedido. Inténtalo de nuevo.",
    "checkout.card": "Tarjeta",
    "checkout.freeShipping": "Envío gratis",
    "checkout.freeShippingAt": "Envío gratis a partir de {{amount}}",
    "checkout.firstName": "Nombre *",
    "checkout.lastName": "Apellidos *",
    "checkout.phone": "Teléfono *",
    "checkout.address": "Dirección *",
    "checkout.floor": "Piso / Puerta",
    "checkout.zip": "Código postal *",
    "checkout.city": "Ciudad *",
    "checkout.optional": "Opcional",
    "checkout.streetNumber": "Calle y número",
    "checkout.urlNotAvailable": "URL de checkout no disponible",
    "checkout.secureCheckout": "Checkout seguro",
    "checkout.loading": "Cargando checkout...",
    "checkout.paymentDeclined": "El pago ha sido rechazado. Verifica tu tarjeta e inténtalo de nuevo.",
    "checkout.paymentError_INSUFFICIENT_FUNDS": "Fondos insuficientes. Verifica el saldo de tu tarjeta.",
    "checkout.paymentError_PAYMENT_DECLINED": "El pago ha sido rechazado por tu banco.",
    "checkout.paymentError_INVALID_PAYMENT_METHOD": "El método de pago no es válido. Actualízalo en tu perfil.",
    "checkout.paymentError_EXPIRED_PAYMENT_METHOD": "Tu tarjeta ha expirado. Actualiza el método de pago.",
    "checkout.paymentError_AUTHENTICATION_ERROR": "Se requiere autenticación. Inténtalo de nuevo.",
    "checkout.paymentError_PAYMENT_PROCESSING": "El pago se está procesando. Por favor espera unos minutos y revisa tus pedidos.",
    "checkout.email": "Email",
    "checkout.emailPlaceholder": "tu@email.com",
    "checkout.continue": "Continuar",
    "checkout.loginForAddress": "Introduce tu email para añadir dirección",
    "checkout.loginForPayment": "Introduce tu email para añadir método de pago",
    "checkout.emailError": "No se pudo vincular el email. Inténtalo de nuevo.",
    "checkout.verifyCode": "Verificar código",
    "checkout.invalidCode": "Código inválido o expirado. Inténtalo de nuevo.",
    "checkout.codeSent": "Código enviado a {{email}}",
    "checkout.pickupPoint": "Punto de recogida",
    "checkout.noServicePoints": "No se encontraron puntos de recogida cercanos",
    "reorder.repeatOrder": "Repite tu pedido",
    "reorder.adjustQuantities": "Ajusta las cantidades si quieres y confirma con un toque",
    "reorder.products": "Productos",
    "reorder.shippingAddress": "Dirección de envío",
    "reorder.loadingAddress": "Cargando dirección...",
    "reorder.change": "Cambiar",
    "reorder.add": "Añadir",
    "reorder.total": "Total",
    "reorder.changesNote": "* Cantidades modificadas respecto a tu último pedido",
    "reorder.repeatBtn": "Repetir pedido",
    "reorder.loadingOrder": "Cargando tu pedido...",
    "reorder.noPreviousOrder": "Sin pedido anterior",
    "reorder.noPreviousOrderDesc": "No se encontró un contrato de recompra activo. Realiza tu primer pedido en la tienda.",
    "reorder.goToShop": "Ir a la tienda",
    "reorder.noProducts": "Sin productos",
    "reorder.noProductsDesc": "Añade al menos un producto para repetir tu pedido.",
    "reorder.orderSuccess": "¡Pedido realizado! 🎉",
    "reorder.orderSuccessDesc": "Tu pedido se ha procesado correctamente. Recibirás un email de confirmación.",
    "reorder.orderSuccessBtn": "Perfecto",
    "reorder.orderError": "No se pudo procesar el pedido. Inténtalo de nuevo.",
    "reorder.unexpectedError": "Ocurrió un error inesperado. Inténtalo de nuevo.",
    "reorder.addressError": "No se pudo actualizar la dirección.",
    "reorder.requiredFields": "Campos obligatorios",
    "reorder.requiredFieldsDesc": "Rellena al menos nombre, dirección, ciudad y código postal.",
    "reorder.product": "Producto",
    "orderDetail.order": "Pedido",
    "orderDetail.orders": "Pedidos",
    "orderDetail.loadingOrder": "Cargando pedido...",
    "orderDetail.loadError": "Error al cargar",
    "orderDetail.orderNotFound": "Pedido no encontrado",
    "orderDetail.retry": "Reintentar",
    "orderDetail.shippingStatus": "Estado del envío",
    "orderDetail.confirmed": "Pedido confirmado",
    "orderDetail.confirmedDesc": "Tu pedido ha sido recibido",
    "orderDetail.preparing": "En preparación",
    "orderDetail.preparingDesc": "Estamos preparando tu matcha",
    "orderDetail.shipped": "Enviado",
    "orderDetail.shippedDesc": "En camino hacia ti",
    "orderDetail.delivered": "Entregado",
    "orderDetail.deliveredDesc": "¡Disfruta tu matcha!",
    "orderDetail.cancelled": "Cancelado",
    "orderDetail.products": "Productos",
    "orderDetail.quantity": "Cantidad: {{count}}",
    "orderDetail.summary": "Resumen",
    "orderDetail.shippingAddress": "Dirección de envío",
    "orderDetail.paymentStatus": "Estado del pago",
    "orderDetail.total": "Total",
    "orderDetail.repeatThisOrder": "Repetir este pedido",
    "orderDetail.repeatConfirm": "Repetir pedido",
    "orderDetail.repeatConfirmDesc": "¿Quieres repetir este pedido de matcha?",
    "orderDetail.repeatSuccess": "¡Pedido realizado! 🎉",
    "orderDetail.repeatSuccessDesc": "Tu matcha va en camino.",
    "orderDetail.repeatError": "No se pudo procesar la recompra",
    "orderDetail.needHelp": "¿Necesitas ayuda?",
    "orderDetail.needHelpDesc": "Contacta con soporte si tienes alguna pregunta sobre tu pedido",
    "orderDetail.contactSupport": "Contactar soporte",
    "orderDetail.inTransit": "En camino",
    "orderDetail.outForDelivery": "En reparto",
    "orderDetail.outForDeliveryDesc": "¡Tu pedido llega hoy!",
    "orderDetail.exception": "Incidencia",
    "orderDetail.exceptionDesc": "Ha habido una incidencia con tu envío",
    "orderDetail.returned": "Devuelto",
    "orderDetail.returnedDesc": "Tu paquete ha sido devuelto al remitente",
    "orderDetail.inTransitDesc": "Tu pedido está en tránsito",
    "orderDetail.trackShipment": "Seguir envío",
    "orderDetail.trackingEvents": "Historial de envío",
    "redeem.rewardNotFound": "Regalo no encontrado",
    "redeem.couldNotLoadReward": "No se pudo cargar el regalo.",
    "redeem.rewardRedeemed": "¡Regalo canjeado!",
    "redeem.experienceInfo": "Recibirás más información por email.",
    "redeem.physicalInfo": "Te lo enviaremos pronto a tu dirección.",
    "redeem.pointsSpent": "−{{cost}} puntos • Saldo: ⭐ {{balance}}",
    "redeem.backToRewards": "Volver a regalos",
    "redeem.cost": "Coste",
    "redeem.yourBalance": "Tu saldo",
    "redeem.missingPoints": "Te faltan {{count}} puntos",
    "redeem.addressNeeded": "Dirección necesaria",
    "redeem.addressNeededDesc": "Añade una dirección de envío para recibir tu regalo.",
    "redeem.noAddressSaved": "No tienes una dirección guardada",
    "redeem.addAddress": "Añadir dirección",
    "redeem.changeAddress": "Cambiar dirección",
    "redeem.confirmRedeem": "Confirmar canje",
    "redeem.redeemError": "Error al canjear el regalo",
    "redeem.insufficientPoints": "Puntos insuficientes",
    "redeem.insufficientPointsDesc": "Te faltan {{count}} puntos para canjear \"{{name}}\".",
    "savedRecipes.title": "Mis recetas guardadas",
    "savedRecipes.deleteRecipe": "Eliminar receta",
    "savedRecipes.deleteConfirm": "¿Quieres quitar esta receta de tus guardadas?",
    "savedRecipes.noRecipes": "Sin recetas guardadas",
    "savedRecipes.noRecipesDesc": "Guarda las recetas que te gusten durante tu ritual diario para encontrarlas aquí.",
    "recipeDetail.notFound": "Receta no encontrada",
    "recipeDetail.ingredients": "Ingredientes",
    "recipeDetail.preparation": "Preparación",
    "recipeDetail.servings": "{{count}} porciones",
    "recipeDetail.viewSource": "Ver en matchaandco.com",
    "notifications.title": "Notificaciones",
    "notifications.profile": "Perfil",
    "notifications.disabled": "Notificaciones desactivadas",
    "notifications.disabledDesc": "Activa las notificaciones para no perderte tu ritual diario",
    "notifications.enable": "Activar notificaciones",
    "notifications.enabled": "¡Listo!",
    "notifications.enabledDesc": "Las notificaciones están activadas",
    "notifications.permissionsNeeded": "Permisos necesarios",
    "notifications.permissionsNeededDesc": "Para recibir notificaciones, actívalas en la configuración de tu dispositivo.",
    "notifications.couldNotLoad": "No se pudieron cargar las preferencias",
    "notifications.couldNotSave": "No se pudo guardar la preferencia",
    "notifications.saving": "Guardando...",
    "notifications.quietHours": "Horario silencioso",
    "notifications.quietHoursDesc": "No recibirás notificaciones entre las {{start}} y las {{end}}",
    "notifications.dailyReminder": "Recordatorio diario",
    "notifications.dailyReminderDesc": "Te recordamos tu ritual matutino",
    "notifications.streakWarning": "Alerta de racha",
    "notifications.streakWarningDesc": "Aviso antes de perder tu racha",
    "notifications.orderStatus": "Estado de pedidos",
    "notifications.orderStatusDesc": "Actualizaciones de envío y entrega",
    "notifications.restockReminder": "Recordatorio de restock",
    "notifications.restockReminderDesc": "Cuando tu matcha se esté acabando",
    "notifications.rewardsAvailable": "Recompensas disponibles",
    "notifications.rewardsAvailableDesc": "Cuando puedas canjear puntos",
    "notifications.contentNew": "Contenido nuevo",
    "notifications.contentNewDesc": "Nuevas recetas y meditaciones",
    "notifications.announcements": "Comunicados",
    "notifications.announcementsDesc": "Novedades de Matcha & CO",
    "notifications.subscriptionInfo": "Info de suscripción",
    "notifications.subscriptionInfoDesc": "Renovaciones y cambios",
    "onboarding.skip": "Saltar",
    "onboarding.next": "Siguiente →",
    "onboarding.linkAccount": "Vincular cuenta",
    "onboarding.exploreWithoutAccount": "Explorar sin cuenta",
    "onboarding.welcomeTitle": "Bienvenido a Matcha & CO",
    "onboarding.welcomeDesc": "Tu tienda de matcha con recompra en un clic. Pero también una herramienta de Mindfulness para cuidar tu bienestar cada día.",
    "onboarding.ritualTitle": "¿Qué es el Ritual?",
    "onboarding.ritualDesc": "Un ejercicio diario para ser más consciente de cómo te sientes e incorporar buenos hábitos a tu rutina.",
    "onboarding.ritualStep1Name": "Check-in emocional",
    "onboarding.ritualStep1Desc": "¿Cómo te sientes hoy?",
    "onboarding.ritualStep2Name": "Receta del día",
    "onboarding.ritualStep2Desc": "Una receta de matcha personalizada",
    "onboarding.ritualStep3Name": "Meditación",
    "onboarding.ritualStep3Desc": "Un momento de calma y mindfulness",
    "onboarding.ritualStep4Name": "Matcha",
    "onboarding.ritualStep4Desc": "Registra tu momento matcha del día",
    "onboarding.ritualStep5Name": "Diario",
    "onboarding.ritualStep5Desc": "Reflexiona sobre tu día",
    "onboarding.pointsTitle": "Matcha Points ⭐",
    "onboarding.pointsDesc": "Gana puntos completando tu ritual, con compras, referidos y rachas. Canjéalos por regalos exclusivos que no encontrarás en la tienda.",
    "onboarding.streaksTitle": "Rachas 🔥",
    "onboarding.streaksDesc": "Cada día que completes tu check-in de matcha, tu racha crece. Alcanza hitos (5, 10, 30 días) para ganar puntos bonus. ¡Si fallas un día, vuelve a cero!",
    "onboarding.letsGoTitle": "¡A empezar!",
    "onboarding.letsGoDesc": "Vincula tu email para sincronizar tus pedidos, puntos y desbloquear la experiencia completa. O explora primero.",
    "linkAccount.title": "Vincula tu cuenta",
    "linkAccount.subtitle": "Introduce tu email y te enviaremos un enlace mágico para vincular tu dispositivo.",
    "linkAccount.sendMagicLink": "Enviar enlace mágico",
    "linkAccount.enterCode": "Introduce el código",
    "linkAccount.codeSent": "Hemos enviado un código de 6 dígitos a",
    "linkAccount.verifyCode": "Verificar código",
    "linkAccount.resendCode": "Reenviar código",
    "linkAccount.accountLinked": "Cuenta vinculada",
    "linkAccount.deviceLinked": "Tu dispositivo está vinculado a",
    "linkAccount.backToProfile": "Volver al perfil",
    "linkAccount.sendError": "Error al enviar el enlace",
    "linkAccount.codeError": "Código inválido",
    "linkAccount.haveReferralCode": "Tengo código de un amigo",
    "linkAccount.validateEmail": "Validar email",
    "completeProfile.title": "Completa tu perfil",
    "completeProfile.subtitle": "Para personalizar tu experiencia necesitamos algunos datos",
    "completeProfile.firstName": "Nombre",
    "completeProfile.lastName": "Apellidos",
    "completeProfile.phone": "Teléfono",
    "completeProfile.save": "Guardar perfil",
    "completeProfile.error": "Error al completar el perfil",
    "completeProfile.firstNamePlaceholder": "Nombre",
    "completeProfile.lastNamePlaceholder": "Apellidos",
    "suggestedProducts.title": "También te puede gustar",
    "suggestedProducts.add": "Añadir"
  },
  "en": {
    "tabs.home": "Home",
    "tabs.ritual": "Ritual",
    "tabs.shop": "Shop",
    "tabs.garden": "Garden",
    "tabs.rewards": "Rewards",
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.retry": "Retry",
    "common.close": "Close",
    "common.confirm": "Confirm",
    "common.loading": "Loading...",
    "common.error": "Error",
    "common.ok": "OK",
    "common.seeAll": "See all →",
    "common.days": "days",
    "common.day": "day",
    "common.points": "points",
    "common.pts": "pts",
    "common.noResults": "No results",
    "date.sunday": "Sunday",
    "date.monday": "Monday",
    "date.tuesday": "Tuesday",
    "date.wednesday": "Wednesday",
    "date.thursday": "Thursday",
    "date.friday": "Friday",
    "date.saturday": "Saturday",
    "date.january": "January",
    "date.february": "February",
    "date.march": "March",
    "date.april": "April",
    "date.may": "May",
    "date.june": "June",
    "date.july": "July",
    "date.august": "August",
    "date.september": "September",
    "date.october": "October",
    "date.november": "November",
    "date.december": "December",
    "date.dateFormat": "{{day}}, {{month}} {{date}}",
    "home.reorderTitle": "Repeat my last order",
    "home.reorderSubtitle": "Reorder in one click",
    "home.reorderBtn": "Order",
    "home.oneClickTitle": "Repeat order",
    "home.oneClickBtn": "Order",
    "home.oneClickConfirmTitle": "Repeat order?",
    "home.oneClickConfirmTotal": "Total: {{total}} €",
    "home.oneClickConfirmCard": "Charging card ····{{digits}}",
    "home.oneClickConfirmBtn": "Confirm order",
    "home.oneClickSuccess": "Order placed! You will receive a confirmation email.",
    "home.streakDays": "🔥 {{count}} day streak",
    "home.wildcardAvailable": "🛡️ 1 grace day available",
    "home.nextMilestone": "⭐ {{days}}d → +{{points}}pts",
    "home.treesCount_one": "🌳 {{count}} tree in your garden",
    "home.treesCount_other": "🌳 {{count}} trees in your garden",
    "home.yourRitualToday": "Your ritual today",
    "home.savedRecipes": "My saved recipes",
    "home.matchaFinished": "Your matcha has run out",
    "home.matchaRunningOut": "Your matcha runs out in ~{{days}} days",
    "home.dontLoseStreak": "Don't lose your streak!",
    "home.oneClick": "1 click",
    "home.restock": "Restock",
    "home.orderInProgress": "Order in progress",
    "home.lastOrder": "Your last order",
    "home.seeAllOrders": "See all my orders →",
    "home.dailyRitual": "Your daily ritual",
    "home.nextStep": "NEXT STEP",
    "home.ritualBonus": "Complete all 5 today and earn +5 pts bonus",
    "home.ritualCta.start": "Start my ritual →",
    "home.ritualCta.continue": "Continue ritual →",
    "home.ritualCta.completed": "View summary →",
    "home.linkAccount": "Link your account",
    "home.linkAccountDesc": "Sync your orders and points by linking your email",
    "home.stat.streakLabel": "STREAK\nDAYS",
    "home.stat.pointsLabel": "POINTS\nEARNED",
    "home.stat.levelLabel": "CURRENT\nLEVEL",
    "home.statModal.streakTitle": "Streak days",
    "home.statModal.streakBody": "Your streak counts the consecutive days you complete at least one step of your daily ritual.\n\nKeeping your streak unlocks point bonuses at the 7, 14, and 30-day milestones.\n\nIf you miss a day, you have one grace day that protects your streak.",
    "home.statModal.pointsTitle": "Points earned",
    "home.statModal.pointsBody": "Points are your currency within Matcha & CO. Earn them by completing your daily ritual, surveys, and other activities.\n\nRedeem them for exclusive rewards like free products, discounts, and special gifts.\n\nThis counter shows your available points to redeem.",
    "home.statModal.levelTitle": "Current level",
    "home.statModal.levelIntro": "Your level reflects your accumulated commitment to Matcha & CO. Level up by earning points over time.",
    "home.statModal.levelNeverDrops": "Unlike redeemable points, your level never drops.",
    "home.greetingMorning": "GOOD MORNING",
    "home.greetingAfternoon": "GOOD AFTERNOON",
    "home.greetingEvening": "GOOD EVENING",
    "home.greetingFallback": "Hello!",
    "home.today": "TODAY",
    "home.understood": "Got it",
    "home.rewardsTitle": "REWARDS",
    "home.rewardsSubtitle": "Exclusive gifts",
    "home.seeAllRewards": "See all gifts  →",
    "home.recipeOfDay": "RECIPE OF THE DAY",
    "home.motivational_0": "Every cup is a step towards your wellbeing 🍵",
    "home.motivational_1": "Your body thanks you 🌿",
    "home.motivational_2": "A small ritual, a huge change ✨",
    "home.motivational_3": "Today you chose to take care of yourself 💚",
    "home.motivational_4": "Your consistency is your superpower 🌱",
    "home.motivational_5": "Breathe, drink, smile. Repeat tomorrow ☀️",
    "home.greetingHello": "Hello, {{name}}!",
    "home.paymentBannerTitle": "Add your card and buy with one click",
    "home.paymentBannerSubtitle": "Save your payment method to make your next order easier and earn {{points}} points.",
    "home.paymentBannerBtn": "Add",
    "home.paymentMethodBonusSuccess": "You earned {{points}} points for adding your payment method!",
    "ritual.emotionalCheckin": "Emotional check-in",
    "ritual.recommendedRecipe": "Recommended recipe",
    "ritual.meditation": "Meditation",
    "ritual.registerMatcha": "Register matcha",
    "ritual.journaling": "Journaling",
    "ritual.howDoYouFeel": "How are you feeling today?",
    "ritual.chooseMood": "Choose the emotion that best represents you",
    "ritual.whatRecipe": "What type of recipe do you feel like?",
    "ritual.yourState": "Your state: {{emoji}} {{label}}",
    "ritual.illusion": "Excitement",
    "ritual.calm": "Calm",
    "ritual.apathy": "Apathy",
    "ritual.anxiety": "Anxiety",
    "ritual.sadness": "Sadness",
    "ritual.allCategories": "All",
    "ritual.drinks": "Drinks",
    "ritual.breakfast": "Breakfast",
    "ritual.desserts": "Desserts",
    "ritual.mains": "Mains",
    "ritual.snacks": "Snacks",
    "ritual.doCheckinFirst": "Do your emotional check-in first so we can recommend the perfect recipe for you.",
    "ritual.doCheckinBtn": "Do emotional check-in 🫶",
    "ritual.noRecipes": "No recipes available",
    "ritual.noRecipesDesc": "No recipes for this filter. Try another category!",
    "ritual.completeAnyway": "Complete anyway ✓",
    "ritual.basedOnState": "Based on your state: {{mood}}",
    "ritual.servings": "{{count}} servings",
    "ritual.ingredients": "Ingredients:",
    "ritual.preparation": "Preparation:",
    "ritual.complete": "Complete ✓",
    "ritual.guidedMeditation": "Guided meditation",
    "ritual.minutesSingular": "{{count}} minute",
    "ritual.minutesPlural": "{{count}} minutes",
    "ritual.startMeditation": "▶  Start meditation",
    "ritual.meditating": "Meditating... 🧘",
    "ritual.skip": "Skip →",
    "ritual.alreadyDrankMatcha": "I already had my matcha",
    "ritual.whatMatchaToday": "What matcha did you have today?",
    "ritual.selectMatchaType": "Select your matcha type",
    "ritual.matchaType_solo": "Pure matcha",
    "ritual.matchaType_latte": "Matcha latte",
    "ritual.matchaType_protein": "Matcha protein",
    "ritual.matchaType_collagen": "Matcha collagen",
    "ritual.matchaType_creatine": "Matcha creatine",
    "ritual.matchaType_golden_milk": "Golden milk",
    "ritual.matchaType_iced": "Iced matcha",
    "ritual.matchaType_recipe": "In a recipe",
    "ritual.matchaType_other": "Other",
    "ritual.streakLabel": "🔥 Streak: {{count}} days",
    "ritual.plantEvolved": "🌱 Your plant has evolved!",
    "ritual.newTree": "🌳 You've completed a tree!",
    "ritual.journalingTitle": "Journaling 📝",
    "ritual.writeHere": "Write here...",
    "ritual.ritualComplete": "🎉 Ritual complete!",
    "ritual.yourRitualToday": "Your ritual today",
    "ritual.bonusPoints": "+5 pts bonus. Your plant thanks you 🌱",
    "ritual.completed": "✓ Completed",
    "ritual.completeFiveSteps": "✨ Complete all 5 steps to earn +5 pts bonus",
    "ritual.journalPrompt1": "What was the best thing about today?",
    "ritual.journalPrompt2": "What are you grateful for today?",
    "ritual.journalPrompt3": "How do you want to feel tomorrow?",
    "ritual.journalPrompt4": "What made you smile?",
    "ritual.meditationSubtitle_illusion": "Boost that excitement with gratitude and visualization",
    "ritual.meditationSubtitle_calm": "Deepen your calm with conscious breathing",
    "ritual.meditationSubtitle_apathy": "Recover your energy and reconnect with yourself",
    "ritual.meditationSubtitle_anxiety": "Release the tension and find your center",
    "ritual.meditationSubtitle_sadness": "Embrace your emotions with compassion and care",
    "ritual.moodLabel_illusion": "excitement",
    "ritual.moodLabel_calm": "calm",
    "ritual.moodLabel_apathy": "apathy",
    "ritual.moodLabel_anxiety": "anxiety",
    "ritual.moodLabel_sadness": "sadness",
    "ritual.checkin": "Check-in",
    "ritual.recipe": "Recipe",
    "ritual.meditate": "Meditate",
    "ritual.matcha": "Matcha",
    "ritual.journal": "Journal",
    "shop.topSellers": "Top sellers",
    "shop.buy": "+ Add",
    "shop.all": "All",
    "shop.couldNotLoadProducts": "Could not load products",
    "shop.noProductsInCategory": "No products in this category",
    "cart.title": "Cart ({{count}})",
    "cart.myCart": "My basket ({{count}})",
    "cart.myCartLabel": "My basket",
    "cart.viewCartLabel": "View my basket",
    "cart.empty": "Clear",
    "cart.emptyCart": "Clear cart",
    "cart.emptyCartConfirm": "Are you sure?",
    "cart.cartIsEmpty": "Your cart is empty",
    "cart.exploreShop": "Explore the shop and add products",
    "cart.addFromShop": "Add products from the shop",
    "cart.goToShop": "Go to shop",
    "cart.total": "Total",
    "cart.checkout": "Checkout",
    "cart.checkoutError": "Could not create the order. Please try again.",
    "cart.freeShipping": "Free shipping",
    "cart.subtotal": "Subtotal",
    "cart.shipping": "Shipping",
    "cart.free": "Free",
    "cart.freeShippingAt": "Free shipping from {{amount}}",
    "cart.remove": "Remove",
    "cart.removeConfirm": "Remove \"{{title}}\" from cart?",
    "cart.clear": "Clear cart",
    "cart.clearConfirm": "Are you sure?",
    "cart.clearBtn": "Clear",
    "cart.emptyDesc": "Browse the shop and add products",
    "cart.earnPoints": "⭐ You'll earn {{points}} points with this purchase",
    "cart.shippingAtCheckout": "Calculated at checkout",
    "offers.addMore": "Add <bold>{{amount}}€</bold> more for a <bold>{{percent}}% discount</bold>",
    "offers.maxUnlocked": "<bold>Maximum discount unlocked!</bold> 🎉",
    "garden.dayLabel": "Day {{day}}",
    "garden.daysToNext": "{{days}} days to {{name}}",
    "garden.treeComplete": "Tree complete! 🎉",
    "garden.consecutiveDays": "Consecutive days",
    "garden.totalWaterings": "Total waterings",
    "garden.currentLevel": "Current level",
    "garden.consecutiveDaysHelp": "Your current streak of consecutive matcha check-in days. If you miss a day, it resets to zero!",
    "garden.totalWateringsHelp": "The total number of days you've done your matcha check-in. Each check-in waters your plant and helps it grow.",
    "garden.currentLevelHelp": "Your plant's level. It grows as you accumulate consecutive check-in days. When it reaches max level, it becomes a tree for your garden.",
    "garden.understood": "Got it",
    "garden.badgesTitle": "Badges & achievements",
    "garden.badge_primer_brote": "First Sprout",
    "garden.badge_racha_5": "5-Day Streak",
    "garden.badge_racha_10": "10-Day Streak",
    "garden.badge_racha_30": "30-Day Streak",
    "garden.badge_primer_arbol": "First Tree",
    "garden.badgeDesc_primer_brote": "First check-in",
    "garden.badgeDesc_racha_5": "5 consecutive days",
    "garden.badgeDesc_racha_10": "10 consecutive days",
    "garden.badgeDesc_racha_30": "30 consecutive days",
    "garden.badgeDesc_primer_arbol": "30 days completed",
    "rewards.yourPoints": "Your points",
    "rewards.level": "Level: {{current}}",
    "rewards.levelNext": "{{current}} → {{next}}",
    "rewards.availableRewards": "Available rewards",
    "rewards.exclusiveApp": "App exclusives — not available in the store",
    "rewards.comingSoon": "Coming soon",
    "rewards.comingSoonDesc": "We're preparing exclusive rewards for you. Keep earning points!",
    "rewards.merchandise": "Merchandise",
    "rewards.exclusiveProduct": "Exclusive product",
    "rewards.experience": "Experience",
    "rewards.outOfStock": "Out of stock",
    "rewards.redeem": "Redeem",
    "rewards.missingPoints": "Need {{count}} pts",
    "rewards.linkAccountForRewards": "You need to link your email to redeem rewards.",
    "rewards.insufficientPoints": "Insufficient points",
    "rewards.insufficientPointsDesc": "You need {{count}} more points to redeem \"{{name}}\". Keep up with your daily ritual!",
    "rewards.redeemConfirm": "Redeem reward",
    "rewards.redeemConfirmDesc": "Do you want to redeem \"{{name}}\" for {{points}} points?",
    "rewards.redeemed": "Reward redeemed! 🎉",
    "rewards.redeemedDesc": "You will receive more information by email.",
    "rewards.redeemError": "Error redeeming",
    "rewards.myRedemptions": "My redemptions",
    "rewards.statusPending": "⏳ Pending",
    "rewards.statusProcessing": "📦 Processing",
    "rewards.statusShipped": "🚚 Shipped",
    "rewards.statusDelivered": "✅ Delivered",
    "rewards.howItWorks": "How does it work?",
    "rewards.howStep1": "Complete your daily ritual to earn points",
    "rewards.howStep2": "Earn points through streaks, purchases, and referrals",
    "rewards.howStep3": "Redeem your points for exclusive rewards",
    "rewards.morePointsNeeded": "{{count}} pts more for {{level}}",
    "rewards.rewardsTitle": "Rewards",
    "rewards.pointsAvailable": "points available",
    "rewards.howToEarnPoints": "How to earn points?",
    "rewards.earn_purchases": "Purchases: +1 pt per €1 spent",
    "rewards.earn_ritualStep": "Each daily Ritual step: +1 pt",
    "rewards.earn_ritualComplete": "Complete daily Ritual: +5 pts bonus",
    "rewards.earn_referralRegister": "Invite friends: +50 pts per signup",
    "rewards.earn_referralPurchase": "Friend's purchase: +150 pts",
    "rewards.earn_survey": "Complete surveys: variable points",
    "rewards.earn_review": "Write a purchase review: +50 pts",
    "orders.myOrders": "My orders",
    "orders.processing": "Processing",
    "orders.delivered": "Delivered",
    "orders.inTransit": "In transit",
    "orders.shipped": "Shipped",
    "orders.partiallySent": "Partially shipped",
    "orders.inPreparation": "In preparation",
    "orders.cancelled": "Cancelled",
    "orders.login": "Log in",
    "orders.loginDesc": "Link your account to see your orders",
    "orders.linkAccount": "Link account",
    "orders.loadingOrders": "Loading orders...",
    "orders.loadError": "Error loading",
    "orders.noOrders": "No orders",
    "orders.noOrdersDesc": "You haven't placed any orders yet",
    "orders.goToShop": "Go to shop",
    "orders.viewDetail": "View detail",
    "orders.loadMore": "Load more orders",
    "orders.exception": "Exception",
    "orders.outForDelivery": "Out for delivery",
    "orders.returned": "Returned",
    "orders.refunded": "Refunded",
    "surveys.title": "What's New",
    "surveys.subtitle": "Discover the latest news, surveys and exclusive content",
    "surveys.noSurveys": "No news available",
    "surveys.noSurveysDesc": "We'll notify you when there's something new. Keep up with your daily ritual!",
    "surveys.question": "Question {{number}}",
    "surveys.required": "Required",
    "surveys.answered": "{{answered}} of {{total}} answered",
    "surveys.writeAnswer": "Write your answer...",
    "surveys.completeSurvey": "Complete survey",
    "surveys.thanks": "Thank you!",
    "surveys.pointsEarned": "You earned ⭐ {{points}} points",
    "surveys.answersHelp": "Your answers help us improve your matcha experience 🍵",
    "surveys.surveyNotFound": "Survey not found",
    "surveys.loadError": "Could not load the survey.",
    "surveys.submitError": "Error submitting the survey",
    "surveys.questions_one": "{{count}} question",
    "surveys.questions_other": "{{count}} questions",
    "surveys.survey": "Survey",
    "profile.myProfile": "My profile",
    "profile.matchaPoints": "⭐ {{count}} Matcha Points",
    "profile.orders": "Orders",
    "profile.points": "Points",
    "profile.streak": "Streak",
    "profile.badges": "Badges",
    "profile.shippingAddress": "Shipping address",
    "profile.edit": "Edit",
    "profile.add": "Add",
    "profile.firstName": "First name",
    "profile.lastName": "Last name",
    "profile.phone": "Phone",
    "profile.address": "Address",
    "profile.addressPlaceholder": "Street, number, floor...",
    "profile.addressLine2": "Address (line 2)",
    "profile.optional": "Optional",
    "profile.city": "City",
    "profile.zip": "ZIP code",
    "profile.province": "Province",
    "profile.country": "Country",
    "profile.invalidPhone": "Invalid phone number",
    "profile.addressUpdated": "Address updated",
    "profile.addressSaved": "Your shipping address has been saved.",
    "profile.saveError": "Error saving the address",
    "profile.saving": "Saving...",
    "profile.saveAddress": "Save address",
    "profile.addShippingAddress": "Add shipping address",
    "profile.inviteFriend": "Invite a friend",
    "profile.inviteReward": "Earn 50 pts per signup + 150 pts per purchase",
    "profile.shareLink": "Share link",
    "profile.shareMessage": "Try Matcha & CO! Use my code to get a discount on your first order. https://matchaandco.com",
    "profile.shareMessageWithLink": "Try Matcha & CO! Download the app and earn 25 welcome points 🍵 {{link}}",
    "profile.referralInvited": "Invited",
    "profile.referralConverted": "Registered",
    "profile.referralPointsEarned": "Pts earned",
    "profile.yourReferralCode": "Your referral code",
    "profile.referralCodePlaceholder": "E.g: ABC123",
    "profile.applyCode": "Apply code",
    "profile.referralCodeTitle": "Have a referral code?",
    "profile.referralCodeHint": "Enter a friend's code to earn 25 points",
    "profile.referralApplied": "Code applied!",
    "profile.referralError": "Error applying code",
    "profile.notifications": "Notifications",
    "profile.myOrdersMenu": "My orders",
    "profile.quickReorder": "Quick reorder",
    "profile.helpSupport": "Help & support",
    "profile.terms": "Terms & conditions",
    "profile.signOut": "Sign out",
    "profile.signOutConfirm": "Are you sure?",
    "profile.language": "Language",
    "profile.selectLanguage": "Select your language",
    "profile.selectProvince": "Select province",
    "profile.searchProvince": "Search province...",
    "profile.selectCountry": "Select country",
    "profile.referralAlready": "You have already applied a referral code",
    "profile.referralSelf": "You can't use your own code",
    "profile.referralNotFound": "Code not found",
    "profile.referralExpired": "This code has expired",
    "profile.paymentMethod": "Payment method",
    "profile.paymentMethodHint": "Save your payment method to buy with one click",
    "profile.paymentMethodUpdated": "Payment method updated",
    "profile.paymentMethodUpdatedDesc": "Your payment method has been saved successfully.",
    "auth.linkAccount": "Link your account",
    "orderStatus.processing": "Processing",
    "orderStatus.delivered": "Delivered",
    "orderStatus.inTransit": "In transit",
    "orderStatus.shipped": "Shipped",
    "orderStatus.partiallySent": "Partially shipped",
    "language.es": "Español",
    "language.en": "English",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.it": "Italiano",
    "language.nl": "Nederlands",
    "language.de": "Deutsch",
    "language.pl": "Polski",
    "product.notFound": "Product not found",
    "product.back": "Back",
    "product.variant": "Variant",
    "product.quantity": "Quantity",
    "product.description": "Description",
    "product.addToCart": "Add to cart",
    "product.addedToCart": "Added to cart",
    "product.continueShopping": "Continue shopping",
    "product.viewCart": "View cart",
    "product.unit_one": "unit",
    "product.unit_other": "units",
    "product.ingredients": "Ingredients",
    "checkout.confirmOrder": "Confirm order",
    "checkout.cartEmpty": "Your cart is empty",
    "checkout.products": "Products",
    "checkout.shippingAddress": "Shipping address",
    "checkout.changeAddress": "Change address",
    "checkout.addAddress": "Add address",
    "checkout.couldNotLoadAddress": "Could not load the address",
    "checkout.paymentMethod": "Payment method",
    "checkout.changePayment": "Change payment method",
    "checkout.useStandardCheckout": "Use standard checkout",
    "checkout.couldNotLoadPayment": "Could not load the payment method",
    "checkout.noPaymentMethod": "No saved payment method",
    "checkout.addPaymentMethod": "Add card",
    "checkout.subtotal": "Subtotal",
    "checkout.shipping": "Shipping",
    "checkout.tax": "Tax",
    "checkout.free": "Free",
    "checkout.total": "Total",
    "checkout.securePayment": "Secure payment",
    "checkout.placeOrder": "Place order",
    "checkout.quantity": "Quantity: {{count}}",
    "checkout.requiredFields": "Required fields",
    "checkout.requiredFieldsDesc": "Fill in at least name, address, city, and zip code.",
    "checkout.addressError": "Could not update the address. Please try again.",
    "checkout.orderSuccess": "Order placed! 🎉",
    "checkout.orderSuccessDesc": "Your order has been processed. You'll receive a confirmation email.",
    "checkout.orderSuccessBtn": "Great",
    "checkout.orderError": "Could not process the order. Please try again.",
    "checkout.unexpectedError": "An unexpected error occurred. Please try again.",
    "checkout.checkoutError": "Could not create the order. Please try again.",
    "checkout.card": "Card",
    "checkout.freeShipping": "Free shipping",
    "checkout.freeShippingAt": "Free shipping from {{amount}}",
    "checkout.firstName": "First name *",
    "checkout.lastName": "Last name *",
    "checkout.phone": "Phone *",
    "checkout.address": "Address *",
    "checkout.floor": "Floor / Door",
    "checkout.zip": "Zip code *",
    "checkout.city": "City *",
    "checkout.optional": "Optional",
    "checkout.streetNumber": "Street and number",
    "checkout.urlNotAvailable": "Checkout URL not available",
    "checkout.secureCheckout": "Secure checkout",
    "checkout.loading": "Loading checkout...",
    "checkout.paymentDeclined": "Payment was declined. Please check your card and try again.",
    "checkout.paymentError_INSUFFICIENT_FUNDS": "Insufficient funds. Please check your card balance.",
    "checkout.paymentError_PAYMENT_DECLINED": "Payment was declined by your bank.",
    "checkout.paymentError_INVALID_PAYMENT_METHOD": "Payment method is invalid. Please update it in your profile.",
    "checkout.paymentError_EXPIRED_PAYMENT_METHOD": "Your card has expired. Please update your payment method.",
    "checkout.paymentError_AUTHENTICATION_ERROR": "Authentication required. Please try again.",
    "checkout.paymentError_PAYMENT_PROCESSING": "Payment is processing. Please wait a few minutes and check your orders.",
    "checkout.email": "Email",
    "checkout.emailPlaceholder": "your@email.com",
    "checkout.continue": "Continue",
    "checkout.loginForAddress": "Enter your email to add an address",
    "checkout.loginForPayment": "Enter your email to add a payment method",
    "checkout.emailError": "Could not link email. Please try again.",
    "checkout.verifyCode": "Verify code",
    "checkout.invalidCode": "Invalid or expired code. Please try again.",
    "checkout.codeSent": "Code sent to {{email}}",
    "checkout.pickupPoint": "Pickup point",
    "checkout.noServicePoints": "No pickup points found nearby",
    "reorder.repeatOrder": "Repeat your order",
    "reorder.adjustQuantities": "Adjust quantities if you want and confirm with one tap",
    "reorder.products": "Products",
    "reorder.shippingAddress": "Shipping address",
    "reorder.loadingAddress": "Loading address...",
    "reorder.change": "Change",
    "reorder.add": "Add",
    "reorder.total": "Total",
    "reorder.changesNote": "* Quantities modified from your last order",
    "reorder.repeatBtn": "Repeat order",
    "reorder.loadingOrder": "Loading your order...",
    "reorder.noPreviousOrder": "No previous order",
    "reorder.noPreviousOrderDesc": "No active reorder contract found. Place your first order in the shop.",
    "reorder.goToShop": "Go to shop",
    "reorder.noProducts": "No products",
    "reorder.noProductsDesc": "Add at least one product to repeat your order.",
    "reorder.orderSuccess": "Order placed! 🎉",
    "reorder.orderSuccessDesc": "Your order has been processed. You'll receive a confirmation email.",
    "reorder.orderSuccessBtn": "Great",
    "reorder.orderError": "Could not process the order. Please try again.",
    "reorder.unexpectedError": "An unexpected error occurred. Please try again.",
    "reorder.addressError": "Could not update the address.",
    "reorder.requiredFields": "Required fields",
    "reorder.requiredFieldsDesc": "Fill in at least name, address, city, and zip code.",
    "reorder.product": "Product",
    "orderDetail.order": "Order",
    "orderDetail.orders": "Orders",
    "orderDetail.loadingOrder": "Loading order...",
    "orderDetail.loadError": "Error loading",
    "orderDetail.orderNotFound": "Order not found",
    "orderDetail.retry": "Retry",
    "orderDetail.shippingStatus": "Shipping status",
    "orderDetail.confirmed": "Order confirmed",
    "orderDetail.confirmedDesc": "Your order has been received",
    "orderDetail.preparing": "In preparation",
    "orderDetail.preparingDesc": "We're preparing your matcha",
    "orderDetail.shipped": "Shipped",
    "orderDetail.shippedDesc": "On its way to you",
    "orderDetail.delivered": "Delivered",
    "orderDetail.deliveredDesc": "Enjoy your matcha!",
    "orderDetail.cancelled": "Cancelled",
    "orderDetail.products": "Products",
    "orderDetail.quantity": "Quantity: {{count}}",
    "orderDetail.summary": "Summary",
    "orderDetail.shippingAddress": "Shipping address",
    "orderDetail.paymentStatus": "Payment status",
    "orderDetail.total": "Total",
    "orderDetail.repeatThisOrder": "Repeat this order",
    "orderDetail.repeatConfirm": "Repeat order",
    "orderDetail.repeatConfirmDesc": "Do you want to repeat this matcha order?",
    "orderDetail.repeatSuccess": "Order placed! 🎉",
    "orderDetail.repeatSuccessDesc": "Your matcha is on its way.",
    "orderDetail.repeatError": "Could not process the reorder",
    "orderDetail.needHelp": "Need help?",
    "orderDetail.needHelpDesc": "Contact support if you have any questions about your order",
    "orderDetail.contactSupport": "Contact support",
    "orderDetail.inTransit": "In transit",
    "orderDetail.outForDelivery": "Out for delivery",
    "orderDetail.outForDeliveryDesc": "Your order arrives today!",
    "orderDetail.exception": "Issue",
    "orderDetail.exceptionDesc": "There was an issue with your shipment",
    "orderDetail.returned": "Returned",
    "orderDetail.returnedDesc": "Your package has been returned to sender",
    "orderDetail.inTransitDesc": "Your order is in transit",
    "orderDetail.trackShipment": "Track shipment",
    "orderDetail.trackingEvents": "Shipping history",
    "redeem.rewardNotFound": "Reward not found",
    "redeem.couldNotLoadReward": "Could not load the reward.",
    "redeem.rewardRedeemed": "Reward redeemed!",
    "redeem.experienceInfo": "You'll receive more information by email.",
    "redeem.physicalInfo": "We'll send it to your address soon.",
    "redeem.pointsSpent": "−{{cost}} points • Balance: ⭐ {{balance}}",
    "redeem.backToRewards": "Back to rewards",
    "redeem.cost": "Cost",
    "redeem.yourBalance": "Your balance",
    "redeem.missingPoints": "You need {{count}} more points",
    "redeem.addressNeeded": "Address needed",
    "redeem.addressNeededDesc": "Add a shipping address to receive your reward.",
    "redeem.noAddressSaved": "You don't have a saved address",
    "redeem.addAddress": "Add address",
    "redeem.changeAddress": "Change address",
    "redeem.confirmRedeem": "Confirm redemption",
    "redeem.redeemError": "Error redeeming the reward",
    "redeem.insufficientPoints": "Insufficient points",
    "redeem.insufficientPointsDesc": "You need {{count}} more points to redeem \"{{name}}\".",
    "savedRecipes.title": "My saved recipes",
    "savedRecipes.deleteRecipe": "Delete recipe",
    "savedRecipes.deleteConfirm": "Do you want to remove this recipe from your saved ones?",
    "savedRecipes.noRecipes": "No saved recipes",
    "savedRecipes.noRecipesDesc": "Save the recipes you like during your daily ritual to find them here.",
    "recipeDetail.notFound": "Recipe not found",
    "recipeDetail.ingredients": "Ingredients",
    "recipeDetail.preparation": "Preparation",
    "recipeDetail.servings": "{{count}} servings",
    "recipeDetail.viewSource": "View on matchaandco.com",
    "notifications.title": "Notifications",
    "notifications.profile": "Profile",
    "notifications.disabled": "Notifications disabled",
    "notifications.disabledDesc": "Enable notifications so you don't miss your daily ritual",
    "notifications.enable": "Enable notifications",
    "notifications.enabled": "Done!",
    "notifications.enabledDesc": "Notifications are enabled",
    "notifications.permissionsNeeded": "Permissions needed",
    "notifications.permissionsNeededDesc": "To receive notifications, enable them in your device settings.",
    "notifications.couldNotLoad": "Could not load preferences",
    "notifications.couldNotSave": "Could not save the preference",
    "notifications.saving": "Saving...",
    "notifications.quietHours": "Quiet hours",
    "notifications.quietHoursDesc": "You won't receive notifications between {{start}} and {{end}}",
    "notifications.dailyReminder": "Daily reminder",
    "notifications.dailyReminderDesc": "We remind you of your morning ritual",
    "notifications.streakWarning": "Streak warning",
    "notifications.streakWarningDesc": "Warning before losing your streak",
    "notifications.orderStatus": "Order status",
    "notifications.orderStatusDesc": "Shipping and delivery updates",
    "notifications.restockReminder": "Restock reminder",
    "notifications.restockReminderDesc": "When your matcha is running low",
    "notifications.rewardsAvailable": "Rewards available",
    "notifications.rewardsAvailableDesc": "When you can redeem points",
    "notifications.contentNew": "New content",
    "notifications.contentNewDesc": "New recipes and meditations",
    "notifications.announcements": "Announcements",
    "notifications.announcementsDesc": "Matcha & CO news",
    "notifications.subscriptionInfo": "Subscription info",
    "notifications.subscriptionInfoDesc": "Renewals and changes",
    "onboarding.skip": "Skip",
    "onboarding.next": "Next →",
    "onboarding.linkAccount": "Link account",
    "onboarding.exploreWithoutAccount": "Explore without account",
    "onboarding.welcomeTitle": "Welcome to Matcha & CO",
    "onboarding.welcomeDesc": "Your matcha shop with one-click reorders. But also a Mindfulness tool to take care of your wellbeing every day.",
    "onboarding.ritualTitle": "What is the Ritual?",
    "onboarding.ritualDesc": "A daily exercise to be more aware of how you feel and build healthy habits into your routine.",
    "onboarding.ritualStep1Name": "Emotional check-in",
    "onboarding.ritualStep1Desc": "How are you feeling today?",
    "onboarding.ritualStep2Name": "Recipe of the day",
    "onboarding.ritualStep2Desc": "A personalized matcha recipe",
    "onboarding.ritualStep3Name": "Meditation",
    "onboarding.ritualStep3Desc": "A moment of calm and mindfulness",
    "onboarding.ritualStep4Name": "Matcha",
    "onboarding.ritualStep4Desc": "Log your matcha moment of the day",
    "onboarding.ritualStep5Name": "Journal",
    "onboarding.ritualStep5Desc": "Reflect on your day",
    "onboarding.pointsTitle": "Matcha Points ⭐",
    "onboarding.pointsDesc": "Earn points by completing your ritual, with purchases, referrals, and streaks. Redeem them for exclusive rewards you won't find in the shop.",
    "onboarding.streaksTitle": "Streaks 🔥",
    "onboarding.streaksDesc": "Every day you complete your matcha check-in, your streak grows. Reach milestones (5, 10, 30 days) for bonus points. Miss a day and it resets to zero!",
    "onboarding.letsGoTitle": "Let's go!",
    "onboarding.letsGoDesc": "Link your email to sync your orders, points, and unlock the full experience. Or explore first.",
    "linkAccount.title": "Link your account",
    "linkAccount.subtitle": "Enter your email and we'll send you a magic link to connect your device.",
    "linkAccount.sendMagicLink": "Send magic link",
    "linkAccount.enterCode": "Enter the code",
    "linkAccount.codeSent": "We've sent a 6-digit code to",
    "linkAccount.verifyCode": "Verify code",
    "linkAccount.resendCode": "Resend code",
    "linkAccount.accountLinked": "Account linked",
    "linkAccount.deviceLinked": "Your device is linked to",
    "linkAccount.backToProfile": "Back to profile",
    "linkAccount.sendError": "Error sending the link",
    "linkAccount.codeError": "Invalid code",
    "linkAccount.haveReferralCode": "I have a friend's code",
    "linkAccount.validateEmail": "Validate email",
    "completeProfile.title": "Complete your profile",
    "completeProfile.subtitle": "To personalize your experience we need some details",
    "completeProfile.firstName": "First name",
    "completeProfile.lastName": "Last name",
    "completeProfile.phone": "Phone",
    "completeProfile.save": "Save profile",
    "completeProfile.error": "Error completing the profile",
    "completeProfile.firstNamePlaceholder": "First name",
    "completeProfile.lastNamePlaceholder": "Last name",
    "suggestedProducts.title": "You might also like",
    "suggestedProducts.add": "Add"
  },
  "fr": {
    "tabs.home": "Accueil",
    "tabs.ritual": "Rituel",
    "tabs.shop": "Boutique",
    "tabs.garden": "Jardin",
    "tabs.rewards": "Cadeaux",
    "common.back": "Retour",
    "common.cancel": "Annuler",
    "common.save": "Enregistrer",
    "common.delete": "Supprimer",
    "common.retry": "Réessayer",
    "common.close": "Fermer",
    "common.confirm": "Confirmer",
    "common.loading": "Chargement...",
    "common.error": "Erreur",
    "common.ok": "OK",
    "common.seeAll": "Voir tout →",
    "common.days": "jours",
    "common.day": "jour",
    "common.points": "points",
    "common.pts": "pts",
    "common.noResults": "Aucun résultat",
    "date.sunday": "Dimanche",
    "date.monday": "Lundi",
    "date.tuesday": "Mardi",
    "date.wednesday": "Mercredi",
    "date.thursday": "Jeudi",
    "date.friday": "Vendredi",
    "date.saturday": "Samedi",
    "date.january": "janvier",
    "date.february": "février",
    "date.march": "mars",
    "date.april": "avril",
    "date.may": "mai",
    "date.june": "juin",
    "date.july": "juillet",
    "date.august": "août",
    "date.september": "septembre",
    "date.october": "octobre",
    "date.november": "novembre",
    "date.december": "décembre",
    "date.dateFormat": "{{day}} {{date}} {{month}}",
    "home.reorderTitle": "Répéter ma dernière commande",
    "home.reorderSubtitle": "Commandez à nouveau en un clic",
    "home.reorderBtn": "Commander",
    "home.oneClickTitle": "Répéter la commande",
    "home.oneClickBtn": "Commander",
    "home.oneClickConfirmTitle": "Répéter la commande ?",
    "home.oneClickConfirmTotal": "Total : {{total}} €",
    "home.oneClickConfirmCard": "Carte ····{{digits}}",
    "home.oneClickConfirmBtn": "Confirmer",
    "home.oneClickSuccess": "Commande passée ! Vous recevrez un email de confirmation.",
    "home.streakDays": "🔥 {{count}} jours de série",
    "home.wildcardAvailable": "🛡️ 1 jour de grâce disponible",
    "home.nextMilestone": "⭐ {{days}}j → +{{points}}pts",
    "home.treesCount_one": "🌳 {{count}} arbre dans votre jardin",
    "home.treesCount_other": "🌳 {{count}} arbres dans votre jardin",
    "home.yourRitualToday": "Votre rituel du jour",
    "home.savedRecipes": "Mes recettes sauvegardées",
    "home.matchaFinished": "Votre matcha est terminé",
    "home.matchaRunningOut": "Votre matcha s'épuise dans ~{{days}} jours",
    "home.dontLoseStreak": "Ne perdez pas votre série !",
    "home.oneClick": "1 clic",
    "home.restock": "Réapprovisionner",
    "home.orderInProgress": "Commande en cours",
    "home.lastOrder": "Votre dernière commande",
    "home.seeAllOrders": "Voir toutes mes commandes →",
    "home.dailyRitual": "Votre rituel quotidien",
    "home.nextStep": "ÉTAPE SUIVANTE",
    "home.ritualBonus": "Complétez les 5 aujourd'hui et gagnez +5 pts bonus",
    "home.ritualCta.start": "Commencer mon rituel →",
    "home.ritualCta.continue": "Continuer le rituel →",
    "home.ritualCta.completed": "Voir le résumé →",
    "home.linkAccount": "Liez votre compte",
    "home.linkAccountDesc": "Synchronisez vos commandes et points en liant votre email",
    "home.stat.streakLabel": "JOURS\nDE SUITE",
    "home.stat.pointsLabel": "POINTS\nGAGNÉS",
    "home.stat.levelLabel": "NIVEAU\nACTUEL",
    "home.statModal.streakTitle": "Jours de suite",
    "home.statModal.streakBody": "Ta série compte les jours consécutifs où tu complètes au moins une étape de ton rituel quotidien.\n\nMaintenir ta série débloque des bonus de points aux étapes de 7, 14 et 30 jours.\n\nSi tu manques un jour, tu as un jour de grâce qui protège ta série.",
    "home.statModal.pointsTitle": "Points gagnés",
    "home.statModal.pointsBody": "Les points sont ta monnaie chez Matcha & CO. Gagne-les en complétant ton rituel quotidien, des sondages et autres activités.\n\nÉchange-les contre des récompenses exclusives comme des produits gratuits, des réductions et des cadeaux spéciaux.\n\nCe compteur montre tes points disponibles.",
    "home.statModal.levelTitle": "Niveau actuel",
    "home.statModal.levelIntro": "Ton niveau reflète ton engagement accumulé avec Matcha & CO. Monte de niveau en gagnant des points.",
    "home.statModal.levelNeverDrops": "Contrairement aux points échangeables, ton niveau ne baisse jamais.",
    "home.greetingMorning": "BONJOUR",
    "home.greetingAfternoon": "BON APRÈS-MIDI",
    "home.greetingEvening": "BONSOIR",
    "home.greetingFallback": "Bonjour !",
    "home.today": "AUJOURD'HUI",
    "home.understood": "Compris",
    "home.rewardsTitle": "RÉCOMPENSES",
    "home.rewardsSubtitle": "Cadeaux exclusifs",
    "home.seeAllRewards": "Voir tous les cadeaux  →",
    "home.recipeOfDay": "RECETTE DU JOUR",
    "home.motivational_0": "Chaque tasse est un pas vers ton bien-être 🍵",
    "home.motivational_1": "Ton corps te remercie 🌿",
    "home.motivational_2": "Un petit rituel, un grand changement ✨",
    "home.motivational_3": "Aujourd'hui tu as choisi de prendre soin de toi 💚",
    "home.motivational_4": "Ta constance est ton superpouvoir 🌱",
    "home.motivational_5": "Respire, bois, souris. Recommence demain ☀️",
    "home.greetingHello": "Bonjour, {{name}} !",
    "home.paymentBannerTitle": "Ajoutez votre carte et achetez en un clic",
    "home.paymentBannerSubtitle": "Enregistrez votre moyen de paiement pour faciliter votre prochaine commande et gagnez {{points}} points.",
    "home.paymentBannerBtn": "Ajouter",
    "home.paymentMethodBonusSuccess": "Vous avez gagné {{points}} points en ajoutant votre moyen de paiement !",
    "ritual.emotionalCheckin": "Check-in émotionnel",
    "ritual.recommendedRecipe": "Recette recommandée",
    "ritual.meditation": "Méditation",
    "ritual.registerMatcha": "Enregistrer le matcha",
    "ritual.journaling": "Journaling",
    "ritual.howDoYouFeel": "Comment vous sentez-vous aujourd'hui ?",
    "ritual.chooseMood": "Choisissez l'émotion qui vous représente le mieux",
    "ritual.whatRecipe": "Quel type de recette vous fait envie ?",
    "ritual.yourState": "Votre état : {{emoji}} {{label}}",
    "ritual.illusion": "Enthousiasme",
    "ritual.calm": "Calme",
    "ritual.apathy": "Apathie",
    "ritual.anxiety": "Anxiété",
    "ritual.sadness": "Tristesse",
    "ritual.allCategories": "Toutes",
    "ritual.drinks": "Boissons",
    "ritual.breakfast": "Petit-déjeuner",
    "ritual.desserts": "Desserts",
    "ritual.mains": "Plats principaux",
    "ritual.snacks": "Snacks",
    "ritual.doCheckinFirst": "Faites d'abord votre check-in émotionnel pour que nous puissions vous recommander la recette parfaite.",
    "ritual.doCheckinBtn": "Faire le check-in émotionnel 🫶",
    "ritual.noRecipes": "Aucune recette disponible",
    "ritual.noRecipesDesc": "Pas de recettes pour ce filtre. Essayez une autre catégorie !",
    "ritual.completeAnyway": "Compléter quand même ✓",
    "ritual.basedOnState": "Basée sur votre état : {{mood}}",
    "ritual.servings": "{{count}} portions",
    "ritual.ingredients": "Ingrédients :",
    "ritual.preparation": "Préparation :",
    "ritual.complete": "Compléter ✓",
    "ritual.guidedMeditation": "Méditation guidée",
    "ritual.minutesSingular": "{{count}} minute",
    "ritual.minutesPlural": "{{count}} minutes",
    "ritual.startMeditation": "▶  Commencer la méditation",
    "ritual.meditating": "En méditation... 🧘",
    "ritual.skip": "Passer →",
    "ritual.alreadyDrankMatcha": "J'ai déjà pris mon matcha",
    "ritual.whatMatchaToday": "Quel matcha as-tu pris aujourd'hui ?",
    "ritual.selectMatchaType": "Sélectionne le type de matcha",
    "ritual.matchaType_solo": "Matcha pur",
    "ritual.matchaType_latte": "Matcha latte",
    "ritual.matchaType_protein": "Matcha protéine",
    "ritual.matchaType_collagen": "Matcha collagène",
    "ritual.matchaType_creatine": "Matcha créatine",
    "ritual.matchaType_golden_milk": "Golden milk",
    "ritual.matchaType_iced": "Matcha glacé",
    "ritual.matchaType_recipe": "En recette",
    "ritual.matchaType_other": "Autre",
    "ritual.streakLabel": "🔥 Série : {{count}} jours",
    "ritual.plantEvolved": "🌱 Votre plante a évolué !",
    "ritual.newTree": "🌳 Vous avez complété un arbre !",
    "ritual.journalingTitle": "Journaling 📝",
    "ritual.writeHere": "Écrivez ici...",
    "ritual.ritualComplete": "🎉 Rituel terminé !",
    "ritual.yourRitualToday": "Votre rituel du jour",
    "ritual.bonusPoints": "+5 pts bonus. Votre plante vous remercie 🌱",
    "ritual.completed": "✓ Terminé",
    "ritual.completeFiveSteps": "✨ Complétez les 5 étapes pour gagner +5 pts bonus",
    "ritual.journalPrompt1": "Quel a été le meilleur moment d'aujourd'hui ?",
    "ritual.journalPrompt2": "Pour quoi êtes-vous reconnaissant aujourd'hui ?",
    "ritual.journalPrompt3": "Comment voulez-vous vous sentir demain ?",
    "ritual.journalPrompt4": "Qu'est-ce qui vous a fait sourire ?",
    "ritual.meditationSubtitle_illusion": "Renforcez cet enthousiasme avec gratitude et visualisation",
    "ritual.meditationSubtitle_calm": "Approfondissez votre calme avec une respiration consciente",
    "ritual.meditationSubtitle_apathy": "Retrouvez votre énergie et reconnectez-vous avec vous-même",
    "ritual.meditationSubtitle_anxiety": "Libérez la tension et trouvez votre centre",
    "ritual.meditationSubtitle_sadness": "Embrassez vos émotions avec compassion et tendresse",
    "ritual.moodLabel_illusion": "enthousiasme",
    "ritual.moodLabel_calm": "calme",
    "ritual.moodLabel_apathy": "apathie",
    "ritual.moodLabel_anxiety": "anxiété",
    "ritual.moodLabel_sadness": "tristesse",
    "ritual.checkin": "Check-in",
    "ritual.recipe": "Recette",
    "ritual.meditate": "Méditer",
    "ritual.matcha": "Matcha",
    "ritual.journal": "Journal",
    "shop.topSellers": "Meilleures ventes",
    "shop.buy": "+ Ajouter",
    "shop.all": "Tout",
    "shop.couldNotLoadProducts": "Impossible de charger les produits",
    "shop.noProductsInCategory": "Aucun produit dans cette catégorie",
    "cart.title": "Panier ({{count}})",
    "cart.myCart": "Mon panier ({{count}})",
    "cart.myCartLabel": "Mon panier",
    "cart.viewCartLabel": "Voir mon panier",
    "cart.empty": "Vider",
    "cart.emptyCart": "Vider le panier",
    "cart.emptyCartConfirm": "Êtes-vous sûr ?",
    "cart.cartIsEmpty": "Votre panier est vide",
    "cart.exploreShop": "Explorez la boutique et ajoutez des produits",
    "cart.addFromShop": "Ajoutez des produits depuis la boutique",
    "cart.goToShop": "Aller à la boutique",
    "cart.total": "Total",
    "cart.checkout": "Finaliser la commande",
    "cart.checkoutError": "Impossible de créer la commande. Veuillez réessayer.",
    "cart.freeShipping": "Livraison gratuite",
    "cart.subtotal": "Sous-total",
    "cart.shipping": "Livraison",
    "cart.free": "Gratuit",
    "cart.freeShippingAt": "Livraison gratuite dès {{amount}}",
    "cart.remove": "Supprimer",
    "cart.removeConfirm": "Retirer \"{{title}}\" du panier ?",
    "cart.clear": "Vider le panier",
    "cart.clearConfirm": "Êtes-vous sûr ?",
    "cart.clearBtn": "Vider",
    "cart.emptyDesc": "Explorez la boutique et ajoutez des produits",
    "cart.earnPoints": "⭐ Tu gagneras {{points}} points avec cet achat",
    "cart.shippingAtCheckout": "Calculé au paiement",
    "offers.addMore": "Ajoutez <bold>{{amount}}€</bold> de plus pour une <bold>réduction de {{percent}}%</bold>",
    "offers.maxUnlocked": "<bold>Réduction maximale débloquée !</bold> 🎉",
    "garden.dayLabel": "Jour {{day}}",
    "garden.daysToNext": "{{days}} jours jusqu'à {{name}}",
    "garden.treeComplete": "Arbre terminé ! 🎉",
    "garden.consecutiveDays": "Jours consécutifs",
    "garden.totalWaterings": "Arrosages totaux",
    "garden.currentLevel": "Niveau actuel",
    "garden.consecutiveDaysHelp": "Votre série actuelle de jours consécutifs de check-in matcha. Si vous manquez un jour, ça repart à zéro !",
    "garden.totalWateringsHelp": "Le nombre total de jours où vous avez fait votre check-in matcha. Chaque check-in arrose votre plante et l'aide à pousser.",
    "garden.currentLevelHelp": "Le niveau de votre plante. Elle pousse au fur et à mesure que vous accumulez des jours de check-in consécutifs. Au niveau maximum, elle devient un arbre pour votre jardin.",
    "garden.understood": "Compris",
    "garden.badgesTitle": "Médailles et réussites",
    "garden.badge_primer_brote": "Première Pousse",
    "garden.badge_racha_5": "Série de 5",
    "garden.badge_racha_10": "Série de 10",
    "garden.badge_racha_30": "Série de 30",
    "garden.badge_primer_arbol": "Premier Arbre",
    "garden.badgeDesc_primer_brote": "Premier check-in",
    "garden.badgeDesc_racha_5": "5 jours consécutifs",
    "garden.badgeDesc_racha_10": "10 jours consécutifs",
    "garden.badgeDesc_racha_30": "30 jours consécutifs",
    "garden.badgeDesc_primer_arbol": "30 jours complétés",
    "rewards.yourPoints": "Vos points",
    "rewards.level": "Niveau : {{current}}",
    "rewards.levelNext": "{{current}} → {{next}}",
    "rewards.availableRewards": "Cadeaux disponibles",
    "rewards.exclusiveApp": "Exclusivités de l'app — non disponibles en boutique",
    "rewards.comingSoon": "Bientôt",
    "rewards.comingSoonDesc": "Nous préparons des cadeaux exclusifs pour vous. Continuez à accumuler des points !",
    "rewards.merchandise": "Merchandising",
    "rewards.exclusiveProduct": "Produit exclusif",
    "rewards.experience": "Expérience",
    "rewards.outOfStock": "Épuisé",
    "rewards.redeem": "Échanger",
    "rewards.missingPoints": "Il manque {{count}} pts",
    "rewards.linkAccountForRewards": "Vous devez lier votre email pour échanger des cadeaux.",
    "rewards.insufficientPoints": "Points insuffisants",
    "rewards.insufficientPointsDesc": "Il vous manque {{count}} points pour échanger \"{{name}}\". Continuez votre rituel quotidien !",
    "rewards.redeemConfirm": "Échanger le cadeau",
    "rewards.redeemConfirmDesc": "Voulez-vous échanger \"{{name}}\" pour {{points}} points ?",
    "rewards.redeemed": "Cadeau échangé ! 🎉",
    "rewards.redeemedDesc": "Vous recevrez plus d'informations par email.",
    "rewards.redeemError": "Erreur lors de l'échange",
    "rewards.myRedemptions": "Mes échanges",
    "rewards.statusPending": "⏳ En attente",
    "rewards.statusProcessing": "📦 En préparation",
    "rewards.statusShipped": "🚚 Expédié",
    "rewards.statusDelivered": "✅ Livré",
    "rewards.howItWorks": "Comment ça marche ?",
    "rewards.howStep1": "Complétez votre rituel quotidien pour gagner des points",
    "rewards.howStep2": "Accumulez des points avec les séries, achats et parrainages",
    "rewards.howStep3": "Échangez vos points contre des cadeaux exclusifs",
    "rewards.morePointsNeeded": "{{count}} pts de plus pour {{level}}",
    "rewards.rewardsTitle": "Récompenses",
    "rewards.pointsAvailable": "points disponibles",
    "rewards.howToEarnPoints": "Comment gagner des points ?",
    "rewards.earn_purchases": "Achats : +1 pt par 1€ dépensé",
    "rewards.earn_ritualStep": "Chaque étape du Rituel quotidien : +1 pt",
    "rewards.earn_ritualComplete": "Compléter le Rituel quotidien : +5 pts bonus",
    "rewards.earn_referralRegister": "Inviter des ami(e)s : +50 pts par inscription",
    "rewards.earn_referralPurchase": "Achat de votre invité(e) : +150 pts",
    "rewards.earn_survey": "Compléter des sondages : points variables",
    "rewards.earn_review": "Écrire un avis sur votre achat : +50 pts",
    "orders.myOrders": "Mes commandes",
    "orders.processing": "En traitement",
    "orders.delivered": "Livré",
    "orders.inTransit": "En transit",
    "orders.shipped": "Expédié",
    "orders.partiallySent": "Partiellement expédié",
    "orders.inPreparation": "En préparation",
    "orders.cancelled": "Annulé",
    "orders.login": "Connexion",
    "orders.loginDesc": "Liez votre compte pour voir vos commandes",
    "orders.linkAccount": "Lier le compte",
    "orders.loadingOrders": "Chargement des commandes...",
    "orders.loadError": "Erreur de chargement",
    "orders.noOrders": "Aucune commande",
    "orders.noOrdersDesc": "Vous n'avez pas encore passé de commande",
    "orders.goToShop": "Aller à la boutique",
    "orders.viewDetail": "Voir le détail",
    "orders.loadMore": "Charger plus de commandes",
    "orders.exception": "Incident",
    "orders.outForDelivery": "En livraison",
    "orders.returned": "Retourné",
    "orders.refunded": "Remboursé",
    "surveys.title": "Nouveautés",
    "surveys.subtitle": "Découvrez les dernières nouveautés, enquêtes et contenus exclusifs",
    "surveys.noSurveys": "Aucune nouveauté disponible",
    "surveys.noSurveysDesc": "Nous vous préviendrons quand il y aura des nouveautés. Continuez votre rituel quotidien !",
    "surveys.question": "Question {{number}}",
    "surveys.required": "Obligatoire",
    "surveys.answered": "{{answered}} sur {{total}} répondues",
    "surveys.writeAnswer": "Écrivez votre réponse...",
    "surveys.completeSurvey": "Compléter l'enquête",
    "surveys.thanks": "Merci !",
    "surveys.pointsEarned": "Vous avez gagné ⭐ {{points}} points",
    "surveys.answersHelp": "Vos réponses nous aident à améliorer votre expérience matcha 🍵",
    "surveys.surveyNotFound": "Enquête non trouvée",
    "surveys.loadError": "Impossible de charger l'enquête.",
    "surveys.submitError": "Erreur lors de l'envoi de l'enquête",
    "surveys.questions_one": "{{count}} question",
    "surveys.questions_other": "{{count}} questions",
    "surveys.survey": "Enquête",
    "profile.myProfile": "Mon profil",
    "profile.matchaPoints": "⭐ {{count}} Matcha Points",
    "profile.orders": "Commandes",
    "profile.points": "Points",
    "profile.streak": "Série",
    "profile.badges": "Médailles",
    "profile.shippingAddress": "Adresse de livraison",
    "profile.edit": "Modifier",
    "profile.add": "Ajouter",
    "profile.firstName": "Prénom",
    "profile.lastName": "Nom",
    "profile.phone": "Téléphone",
    "profile.address": "Adresse",
    "profile.addressPlaceholder": "Rue, numéro, étage...",
    "profile.addressLine2": "Adresse (ligne 2)",
    "profile.optional": "Facultatif",
    "profile.city": "Ville",
    "profile.zip": "Code postal",
    "profile.province": "Province",
    "profile.country": "Pays",
    "profile.invalidPhone": "Numéro de téléphone invalide",
    "profile.addressUpdated": "Adresse mise à jour",
    "profile.addressSaved": "Votre adresse de livraison a été enregistrée.",
    "profile.saveError": "Erreur lors de l'enregistrement de l'adresse",
    "profile.saving": "Enregistrement...",
    "profile.saveAddress": "Enregistrer l'adresse",
    "profile.addShippingAddress": "Ajouter une adresse de livraison",
    "profile.inviteFriend": "Invitez un ami",
    "profile.inviteReward": "Gagnez 100 pts pour chaque ami qui achète",
    "profile.shareLink": "Partager le lien",
    "profile.shareMessage": "Essayez Matcha & CO ! Utilisez mon code pour obtenir une réduction sur votre première commande. https://matchaandco.com",
    "profile.notifications": "Notifications",
    "profile.myOrdersMenu": "Mes commandes",
    "profile.quickReorder": "Renouveler rapidement",
    "profile.helpSupport": "Aide et support",
    "profile.terms": "Conditions générales",
    "profile.signOut": "Déconnexion",
    "profile.signOutConfirm": "Êtes-vous sûr ?",
    "profile.language": "Langue",
    "profile.selectLanguage": "Sélectionnez votre langue",
    "profile.selectProvince": "Sélectionner la province",
    "profile.searchProvince": "Rechercher une province...",
    "profile.selectCountry": "Sélectionner le pays",
    "profile.referralCodeTitle": "Code de parrainage",
    "profile.referralCodePlaceholder": "Saisis ton code",
    "profile.referralCodeHint": "Tu as un code de parrainage ? Saisis-le pour gagner des points",
    "profile.applyCode": "Appliquer le code",
    "profile.referralApplied": "Code appliqué avec succès",
    "profile.referralConverted": "Parrainage converti",
    "profile.referralError": "Code non valide",
    "profile.referralAlready": "Tu as déjà appliqué un code de parrainage",
    "profile.referralSelf": "Tu ne peux pas utiliser ton propre code",
    "profile.referralNotFound": "Code non trouvé",
    "profile.referralExpired": "Ce code a expiré",
    "profile.referralInvited": "Invités",
    "profile.referralPointsEarned": "Pts gagnés",
    "profile.shareMessageWithLink": "Essaie Matcha & CO ! Télécharge l'app et gagne 25 points de bienvenue 🍵 {{link}}",
    "profile.yourReferralCode": "Ton code de parrainage",
    "profile.paymentMethod": "Moyen de paiement",
    "profile.paymentMethodHint": "Enregistrez votre moyen de paiement pour acheter en un clic",
    "profile.paymentMethodUpdated": "Méthode de paiement mise à jour",
    "profile.paymentMethodUpdatedDesc": "Votre méthode de paiement a été enregistrée avec succès.",
    "auth.linkAccount": "Liez votre compte",
    "orderStatus.processing": "En traitement",
    "orderStatus.delivered": "Livré",
    "orderStatus.inTransit": "En transit",
    "orderStatus.shipped": "Expédié",
    "orderStatus.partiallySent": "Partiellement expédié",
    "language.es": "Español",
    "language.en": "English",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.it": "Italiano",
    "language.nl": "Nederlands",
    "language.de": "Deutsch",
    "language.pl": "Polski",
    "product.notFound": "Produit non trouvé",
    "product.back": "Retour",
    "product.variant": "Variante",
    "product.quantity": "Quantité",
    "product.description": "Description",
    "product.addToCart": "Ajouter au panier",
    "product.addedToCart": "Ajouté au panier",
    "product.continueShopping": "Continuer les achats",
    "product.viewCart": "Voir le panier",
    "product.unit_one": "unité",
    "product.unit_other": "unités",
    "product.ingredients": "Ingrédients",
    "checkout.confirmOrder": "Confirmer la commande",
    "checkout.cartEmpty": "Votre panier est vide",
    "checkout.products": "Produits",
    "checkout.shippingAddress": "Adresse de livraison",
    "checkout.changeAddress": "Changer d'adresse",
    "checkout.addAddress": "Ajouter une adresse",
    "checkout.couldNotLoadAddress": "Impossible de charger l'adresse",
    "checkout.paymentMethod": "Mode de paiement",
    "checkout.changePayment": "Changer de mode de paiement",
    "checkout.useStandardCheckout": "Utiliser le checkout standard",
    "checkout.couldNotLoadPayment": "Impossible de charger le mode de paiement",
    "checkout.noPaymentMethod": "Aucun mode de paiement enregistré",
    "checkout.addPaymentMethod": "Ajouter une carte",
    "checkout.subtotal": "Sous-total",
    "checkout.shipping": "Livraison",
    "checkout.tax": "Taxes",
    "checkout.free": "Gratuit",
    "checkout.total": "Total",
    "checkout.securePayment": "Paiement sécurisé",
    "checkout.placeOrder": "Finaliser la commande",
    "checkout.quantity": "Quantité : {{count}}",
    "checkout.requiredFields": "Champs obligatoires",
    "checkout.requiredFieldsDesc": "Remplissez au moins le nom, l'adresse, la ville et le code postal.",
    "checkout.addressError": "Impossible de mettre à jour l'adresse. Réessayez.",
    "checkout.orderSuccess": "Commande passée ! 🎉",
    "checkout.orderSuccessDesc": "Votre commande a été traitée. Vous recevrez un email de confirmation.",
    "checkout.orderSuccessBtn": "Parfait",
    "checkout.orderError": "Impossible de traiter la commande. Réessayez.",
    "checkout.unexpectedError": "Une erreur inattendue s'est produite. Réessayez.",
    "checkout.checkoutError": "Impossible de créer la commande. Réessayez.",
    "checkout.card": "Carte",
    "checkout.freeShipping": "Livraison gratuite",
    "checkout.freeShippingAt": "Livraison gratuite dès {{amount}}",
    "checkout.firstName": "Prénom *",
    "checkout.lastName": "Nom *",
    "checkout.phone": "Téléphone *",
    "checkout.address": "Adresse *",
    "checkout.floor": "Étage / Porte",
    "checkout.zip": "Code postal *",
    "checkout.city": "Ville *",
    "checkout.optional": "Optionnel",
    "checkout.streetNumber": "Rue et numéro",
    "checkout.urlNotAvailable": "URL de paiement non disponible",
    "checkout.secureCheckout": "Paiement sécurisé",
    "checkout.loading": "Chargement du paiement...",
    "checkout.paymentDeclined": "Le paiement a été refusé. Vérifiez votre carte et réessayez.",
    "checkout.paymentError_INSUFFICIENT_FUNDS": "Fonds insuffisants. Vérifiez le solde de votre carte.",
    "checkout.paymentError_PAYMENT_DECLINED": "Le paiement a été refusé par votre banque.",
    "checkout.paymentError_INVALID_PAYMENT_METHOD": "Le moyen de paiement n'est pas valide. Mettez-le à jour dans votre profil.",
    "checkout.paymentError_EXPIRED_PAYMENT_METHOD": "Votre carte a expiré. Mettez à jour votre moyen de paiement.",
    "checkout.paymentError_AUTHENTICATION_ERROR": "Authentification requise. Veuillez réessayer.",
    "checkout.paymentError_PAYMENT_PROCESSING": "Le paiement est en cours. Veuillez patienter quelques minutes et vérifier vos commandes.",
    "checkout.email": "Email",
    "checkout.emailPlaceholder": "votre@email.com",
    "checkout.continue": "Continuer",
    "checkout.loginForAddress": "Entrez votre email pour ajouter une adresse",
    "checkout.loginForPayment": "Entrez votre email pour ajouter un moyen de paiement",
    "checkout.emailError": "Impossible de lier l'email. Réessayez.",
    "checkout.verifyCode": "Vérifier le code",
    "checkout.invalidCode": "Code invalide ou expiré. Réessayez.",
    "checkout.codeSent": "Code envoyé à {{email}}",
    "checkout.pickupPoint": "Point relais",
    "checkout.noServicePoints": "Aucun point relais trouvé à proximité",
    "reorder.repeatOrder": "Répétez votre commande",
    "reorder.adjustQuantities": "Ajustez les quantités si vous voulez et confirmez d'un toucher",
    "reorder.products": "Produits",
    "reorder.shippingAddress": "Adresse de livraison",
    "reorder.loadingAddress": "Chargement de l'adresse...",
    "reorder.change": "Modifier",
    "reorder.add": "Ajouter",
    "reorder.total": "Total",
    "reorder.changesNote": "* Quantités modifiées par rapport à votre dernière commande",
    "reorder.repeatBtn": "Répéter la commande",
    "reorder.loadingOrder": "Chargement de votre commande...",
    "reorder.noPreviousOrder": "Pas de commande précédente",
    "reorder.noPreviousOrderDesc": "Aucun contrat de réachat actif trouvé. Passez votre première commande dans la boutique.",
    "reorder.goToShop": "Aller à la boutique",
    "reorder.noProducts": "Aucun produit",
    "reorder.noProductsDesc": "Ajoutez au moins un produit pour répéter votre commande.",
    "reorder.orderSuccess": "Commande passée ! 🎉",
    "reorder.orderSuccessDesc": "Votre commande a été traitée. Vous recevrez un email de confirmation.",
    "reorder.orderSuccessBtn": "Parfait",
    "reorder.orderError": "Impossible de traiter la commande. Réessayez.",
    "reorder.unexpectedError": "Une erreur inattendue s'est produite. Réessayez.",
    "reorder.addressError": "Impossible de mettre à jour l'adresse.",
    "reorder.requiredFields": "Champs obligatoires",
    "reorder.requiredFieldsDesc": "Remplissez au moins le nom, l'adresse, la ville et le code postal.",
    "reorder.product": "Produit",
    "orderDetail.order": "Commande",
    "orderDetail.orders": "Commandes",
    "orderDetail.loadingOrder": "Chargement de la commande...",
    "orderDetail.loadError": "Erreur de chargement",
    "orderDetail.orderNotFound": "Commande non trouvée",
    "orderDetail.retry": "Réessayer",
    "orderDetail.shippingStatus": "État de l'envoi",
    "orderDetail.confirmed": "Commande confirmée",
    "orderDetail.confirmedDesc": "Votre commande a été reçue",
    "orderDetail.preparing": "En préparation",
    "orderDetail.preparingDesc": "Nous préparons votre matcha",
    "orderDetail.shipped": "Expédié",
    "orderDetail.shippedDesc": "En route vers vous",
    "orderDetail.delivered": "Livré",
    "orderDetail.deliveredDesc": "Profitez de votre matcha !",
    "orderDetail.cancelled": "Annulé",
    "orderDetail.products": "Produits",
    "orderDetail.quantity": "Quantité : {{count}}",
    "orderDetail.summary": "Résumé",
    "orderDetail.shippingAddress": "Adresse de livraison",
    "orderDetail.paymentStatus": "État du paiement",
    "orderDetail.total": "Total",
    "orderDetail.repeatThisOrder": "Répéter cette commande",
    "orderDetail.repeatConfirm": "Répéter la commande",
    "orderDetail.repeatConfirmDesc": "Voulez-vous répéter cette commande de matcha ?",
    "orderDetail.repeatSuccess": "Commande passée ! 🎉",
    "orderDetail.repeatSuccessDesc": "Votre matcha est en route.",
    "orderDetail.repeatError": "Impossible de traiter la récommande",
    "orderDetail.needHelp": "Besoin d'aide ?",
    "orderDetail.needHelpDesc": "Contactez le support si vous avez des questions sur votre commande",
    "orderDetail.contactSupport": "Contacter le support",
    "orderDetail.inTransit": "En transit",
    "orderDetail.outForDelivery": "En livraison",
    "orderDetail.outForDeliveryDesc": "Ta commande arrive aujourd’hui !",
    "orderDetail.exception": "Incident",
    "orderDetail.exceptionDesc": "Il y a eu un incident avec votre envoi",
    "orderDetail.returned": "Retourné",
    "orderDetail.returnedDesc": "Votre colis a été retourné",
    "orderDetail.inTransitDesc": "Votre commande est en transit",
    "orderDetail.trackShipment": "Suivre envoi",
    "orderDetail.trackingEvents": "Historique",
    "redeem.rewardNotFound": "Cadeau non trouvé",
    "redeem.couldNotLoadReward": "Impossible de charger le cadeau.",
    "redeem.rewardRedeemed": "Cadeau échangé !",
    "redeem.experienceInfo": "Vous recevrez plus d'informations par email.",
    "redeem.physicalInfo": "Nous vous l'enverrons bientôt à votre adresse.",
    "redeem.pointsSpent": "−{{cost}} points • Solde : ⭐ {{balance}}",
    "redeem.backToRewards": "Retour aux cadeaux",
    "redeem.cost": "Coût",
    "redeem.yourBalance": "Votre solde",
    "redeem.missingPoints": "Il vous manque {{count}} points",
    "redeem.addressNeeded": "Adresse nécessaire",
    "redeem.addressNeededDesc": "Ajoutez une adresse de livraison pour recevoir votre cadeau.",
    "redeem.noAddressSaved": "Vous n'avez pas d'adresse enregistrée",
    "redeem.addAddress": "Ajouter une adresse",
    "redeem.changeAddress": "Changer d'adresse",
    "redeem.confirmRedeem": "Confirmer l'échange",
    "redeem.redeemError": "Erreur lors de l'échange du cadeau",
    "redeem.insufficientPoints": "Points insuffisants",
    "redeem.insufficientPointsDesc": "Il vous manque {{count}} points pour échanger \"{{name}}\".",
    "savedRecipes.title": "Mes recettes sauvegardées",
    "savedRecipes.deleteRecipe": "Supprimer la recette",
    "savedRecipes.deleteConfirm": "Voulez-vous retirer cette recette de vos sauvegardées ?",
    "savedRecipes.noRecipes": "Aucune recette sauvegardée",
    "savedRecipes.noRecipesDesc": "Sauvegardez les recettes que vous aimez pendant votre rituel quotidien pour les retrouver ici.",
    "recipeDetail.notFound": "Recette non trouvée",
    "recipeDetail.ingredients": "Ingrédients",
    "recipeDetail.preparation": "Préparation",
    "recipeDetail.servings": "{{count}} portions",
    "recipeDetail.viewSource": "Voir sur matchaandco.com",
    "notifications.title": "Notifications",
    "notifications.profile": "Profil",
    "notifications.disabled": "Notifications désactivées",
    "notifications.disabledDesc": "Activez les notifications pour ne pas manquer votre rituel quotidien",
    "notifications.enable": "Activer les notifications",
    "notifications.enabled": "C'est fait !",
    "notifications.enabledDesc": "Les notifications sont activées",
    "notifications.permissionsNeeded": "Autorisations nécessaires",
    "notifications.permissionsNeededDesc": "Pour recevoir des notifications, activez-les dans les paramètres de votre appareil.",
    "notifications.couldNotLoad": "Impossible de charger les préférences",
    "notifications.couldNotSave": "Impossible de sauvegarder la préférence",
    "notifications.saving": "Sauvegarde...",
    "notifications.quietHours": "Heures silencieuses",
    "notifications.quietHoursDesc": "Vous ne recevrez pas de notifications entre {{start}} et {{end}}",
    "notifications.dailyReminder": "Rappel quotidien",
    "notifications.dailyReminderDesc": "Nous vous rappelons votre rituel matinal",
    "notifications.streakWarning": "Alerte de série",
    "notifications.streakWarningDesc": "Avertissement avant de perdre votre série",
    "notifications.orderStatus": "État des commandes",
    "notifications.orderStatusDesc": "Mises à jour d'expédition et de livraison",
    "notifications.restockReminder": "Rappel de réapprovisionnement",
    "notifications.restockReminderDesc": "Quand votre matcha est presque épuisé",
    "notifications.rewardsAvailable": "Récompenses disponibles",
    "notifications.rewardsAvailableDesc": "Quand vous pouvez échanger des points",
    "notifications.contentNew": "Nouveau contenu",
    "notifications.contentNewDesc": "Nouvelles recettes et méditations",
    "notifications.announcements": "Annonces",
    "notifications.announcementsDesc": "Nouveautés de Matcha & CO",
    "notifications.subscriptionInfo": "Info d'abonnement",
    "notifications.subscriptionInfoDesc": "Renouvellements et changements",
    "onboarding.skip": "Passer",
    "onboarding.next": "Suivant →",
    "onboarding.linkAccount": "Lier le compte",
    "onboarding.exploreWithoutAccount": "Explorer sans compte",
    "onboarding.welcomeTitle": "Bienvenue sur Matcha & CO",
    "onboarding.welcomeDesc": "Votre boutique matcha avec récommande en un clic. Mais aussi un outil de Mindfulness pour prendre soin de votre bien-être chaque jour.",
    "onboarding.ritualTitle": "Qu'est-ce que le Rituel ?",
    "onboarding.ritualDesc": "Un exercice quotidien pour être plus conscient de comment vous vous sentez et intégrer de bonnes habitudes à votre routine.",
    "onboarding.ritualStep1Name": "Check-in émotionnel",
    "onboarding.ritualStep1Desc": "Comment vous sentez-vous aujourd'hui ?",
    "onboarding.ritualStep2Name": "Recette du jour",
    "onboarding.ritualStep2Desc": "Une recette de matcha personnalisée",
    "onboarding.ritualStep3Name": "Méditation",
    "onboarding.ritualStep3Desc": "Un moment de calme et de pleine conscience",
    "onboarding.ritualStep4Name": "Matcha",
    "onboarding.ritualStep4Desc": "Enregistrez votre moment matcha du jour",
    "onboarding.ritualStep5Name": "Journal",
    "onboarding.ritualStep5Desc": "Réfléchissez à votre journée",
    "onboarding.pointsTitle": "Matcha Points ⭐",
    "onboarding.pointsDesc": "Gagnez des points en complétant votre rituel, avec vos achats, parrainages et séries. Échangez-les contre des récompenses exclusives introuvables en boutique.",
    "onboarding.streaksTitle": "Séries 🔥",
    "onboarding.streaksDesc": "Chaque jour où vous faites votre check-in matcha, votre série grandit. Atteignez des paliers (5, 10, 30 jours) pour des points bonus. Si vous manquez un jour, elle revient à zéro !",
    "onboarding.letsGoTitle": "C'est parti !",
    "onboarding.letsGoDesc": "Liez votre email pour synchroniser vos commandes, vos points et débloquer l'expérience complète. Ou explorez d'abord.",
    "linkAccount.title": "Liez votre compte",
    "linkAccount.subtitle": "Entrez votre email et nous vous enverrons un lien magique pour connecter votre appareil.",
    "linkAccount.sendMagicLink": "Envoyer le lien magique",
    "linkAccount.enterCode": "Entrez le code",
    "linkAccount.codeSent": "Nous avons envoyé un code à 6 chiffres à",
    "linkAccount.verifyCode": "Vérifier le code",
    "linkAccount.resendCode": "Renvoyer le code",
    "linkAccount.accountLinked": "Compte lié",
    "linkAccount.deviceLinked": "Votre appareil est lié à",
    "linkAccount.backToProfile": "Retour au profil",
    "linkAccount.sendError": "Erreur lors de l'envoi du lien",
    "linkAccount.codeError": "Code invalide",
    "linkAccount.haveReferralCode": "J'ai un code d'ami",
    "linkAccount.validateEmail": "Valider l'email",
    "completeProfile.title": "Complétez votre profil",
    "completeProfile.subtitle": "Pour personnaliser votre expérience, nous avons besoin de quelques informations",
    "completeProfile.firstName": "Prénom",
    "completeProfile.lastName": "Nom",
    "completeProfile.phone": "Téléphone",
    "completeProfile.save": "Sauvegarder le profil",
    "completeProfile.error": "Erreur lors de la complétion du profil",
    "completeProfile.firstNamePlaceholder": "Prénom",
    "completeProfile.lastNamePlaceholder": "Nom",
    "suggestedProducts.title": "Vous pourriez aussi aimer",
    "suggestedProducts.add": "Ajouter"
  },
  "de": {
    "tabs.home": "Home",
    "tabs.ritual": "Ritual",
    "tabs.shop": "Shop",
    "tabs.garden": "Garten",
    "tabs.rewards": "Prämien",
    "common.back": "Zurück",
    "common.cancel": "Abbrechen",
    "common.save": "Speichern",
    "common.delete": "Löschen",
    "common.retry": "Erneut versuchen",
    "common.close": "Schließen",
    "common.confirm": "Bestätigen",
    "common.loading": "Laden...",
    "common.error": "Fehler",
    "common.ok": "OK",
    "common.seeAll": "Alle anzeigen →",
    "common.days": "Tage",
    "common.day": "Tag",
    "common.points": "Punkte",
    "common.pts": "Pkt",
    "common.noResults": "Keine Ergebnisse",
    "date.sunday": "Sonntag",
    "date.monday": "Montag",
    "date.tuesday": "Dienstag",
    "date.wednesday": "Mittwoch",
    "date.thursday": "Donnerstag",
    "date.friday": "Freitag",
    "date.saturday": "Samstag",
    "date.january": "Januar",
    "date.february": "Februar",
    "date.march": "März",
    "date.april": "April",
    "date.may": "Mai",
    "date.june": "Juni",
    "date.july": "Juli",
    "date.august": "August",
    "date.september": "September",
    "date.october": "Oktober",
    "date.november": "November",
    "date.december": "Dezember",
    "date.dateFormat": "{{day}}, {{date}}. {{month}}",
    "home.reorderTitle": "Meine letzte Bestellung wiederholen",
    "home.reorderSubtitle": "Mit einem Klick nachbestellen",
    "home.reorderBtn": "Bestellen",
    "home.oneClickTitle": "Bestellung wiederholen",
    "home.oneClickBtn": "Bestellen",
    "home.oneClickConfirmTitle": "Bestellung wiederholen?",
    "home.oneClickConfirmTotal": "Total: {{total}} €",
    "home.oneClickConfirmCard": "Karte ····{{digits}}",
    "home.oneClickConfirmBtn": "Bestätigen",
    "home.oneClickSuccess": "Bestellung aufgegeben! Sie erhalten eine Bestätigungs-E-Mail.",
    "home.streakDays": "🔥 {{count}} Tage Serie",
    "home.wildcardAvailable": "🛡️ 1 Gnadentag verfügbar",
    "home.nextMilestone": "⭐ {{days}}T → +{{points}}Pkt",
    "home.treesCount_one": "🌳 {{count}} Baum in deinem Garten",
    "home.treesCount_other": "🌳 {{count}} Bäume in deinem Garten",
    "home.yourRitualToday": "Dein heutiges Ritual",
    "home.savedRecipes": "Meine gespeicherten Rezepte",
    "home.matchaFinished": "Dein Matcha ist aufgebraucht",
    "home.matchaRunningOut": "Dein Matcha reicht noch ~{{days}} Tage",
    "home.dontLoseStreak": "Verlier deine Serie nicht!",
    "home.oneClick": "1 Klick",
    "home.restock": "Nachfüllen",
    "home.orderInProgress": "Bestellung in Bearbeitung",
    "home.lastOrder": "Deine letzte Bestellung",
    "home.seeAllOrders": "Alle meine Bestellungen →",
    "home.dailyRitual": "Dein tägliches Ritual",
    "home.nextStep": "NÄCHSTER SCHRITT",
    "home.ritualBonus": "Schließe alle 5 heute ab und verdiene +5 Pkt Bonus",
    "home.ritualCta.start": "Mein Ritual starten →",
    "home.ritualCta.continue": "Ritual fortsetzen →",
    "home.ritualCta.completed": "Zusammenfassung ansehen →",
    "home.linkAccount": "Konto verknüpfen",
    "home.linkAccountDesc": "Synchronisiere deine Bestellungen und Punkte durch Verknüpfung deiner E-Mail",
    "home.stat.streakLabel": "TAGE\nIN FOLGE",
    "home.stat.pointsLabel": "PUNKTE\nGESAMMELT",
    "home.stat.levelLabel": "AKTUELLES\nLEVEL",
    "home.statModal.streakTitle": "Tage in Folge",
    "home.statModal.streakBody": "Deine Serie zählt die aufeinanderfolgenden Tage, an denen du mindestens einen Schritt deines täglichen Rituals abschließt.\n\nDeine Serie aufrechtzuerhalten schaltet Punkteboni bei 7, 14 und 30 Tagen frei.\n\nWenn du einen Tag verpasst, hast du einen Gnadentag, der deine Serie schützt.",
    "home.statModal.pointsTitle": "Gesammelte Punkte",
    "home.statModal.pointsBody": "Punkte sind deine Währung bei Matcha & CO. Verdiene sie durch dein tägliches Ritual, Umfragen und andere Aktivitäten.\n\nTausche sie gegen exklusive Belohnungen wie Gratisprodukte, Rabatte und besondere Geschenke ein.\n\nDieser Zähler zeigt deine verfügbaren Punkte.",
    "home.statModal.levelTitle": "Aktuelles Level",
    "home.statModal.levelIntro": "Dein Level spiegelt dein gesammeltes Engagement bei Matcha & CO wider. Steige auf, indem du Punkte sammelst.",
    "home.statModal.levelNeverDrops": "Im Gegensatz zu einlösbaren Punkten sinkt dein Level nie.",
    "home.greetingMorning": "GUTEN MORGEN",
    "home.greetingAfternoon": "GUTEN TAG",
    "home.greetingEvening": "GUTEN ABEND",
    "home.greetingFallback": "Hallo!",
    "home.today": "HEUTE",
    "home.understood": "Verstanden",
    "home.rewardsTitle": "BELOHNUNGEN",
    "home.rewardsSubtitle": "Exklusive Geschenke",
    "home.seeAllRewards": "Alle Geschenke ansehen  →",
    "home.recipeOfDay": "REZEPT DES TAGES",
    "home.motivational_0": "Jede Tasse ist ein Schritt zu deinem Wohlbefinden 🍵",
    "home.motivational_1": "Dein Körper dankt es dir 🌿",
    "home.motivational_2": "Ein kleines Ritual, eine große Veränderung ✨",
    "home.motivational_3": "Heute hast du dich entschieden, auf dich zu achten 💚",
    "home.motivational_4": "Deine Beständigkeit ist deine Superkraft 🌱",
    "home.motivational_5": "Atme, trink, lächle. Morgen wieder ☀️",
    "home.greetingHello": "Hallo, {{name}}!",
    "home.paymentBannerTitle": "Karte hinzufügen und mit einem Klick kaufen",
    "home.paymentBannerSubtitle": "Speichere deine Zahlungsmethode für einfachere Bestellungen und verdiene {{points}} Punkte.",
    "home.paymentBannerBtn": "Hinzufügen",
    "home.paymentMethodBonusSuccess": "Du hast {{points}} Punkte für das Hinzufügen deiner Zahlungsmethode verdient!",
    "ritual.emotionalCheckin": "Emotionaler Check-in",
    "ritual.recommendedRecipe": "Empfohlenes Rezept",
    "ritual.meditation": "Meditation",
    "ritual.registerMatcha": "Matcha registrieren",
    "ritual.journaling": "Journaling",
    "ritual.howDoYouFeel": "Wie fühlst du dich heute?",
    "ritual.chooseMood": "Wähle die Emotion, die dich am besten beschreibt",
    "ritual.whatRecipe": "Welche Art von Rezept hast du Lust auf?",
    "ritual.yourState": "Dein Zustand: {{emoji}} {{label}}",
    "ritual.illusion": "Begeisterung",
    "ritual.calm": "Ruhe",
    "ritual.apathy": "Apathie",
    "ritual.anxiety": "Angst",
    "ritual.sadness": "Traurigkeit",
    "ritual.allCategories": "Alle",
    "ritual.drinks": "Getränke",
    "ritual.breakfast": "Frühstück",
    "ritual.desserts": "Desserts",
    "ritual.mains": "Hauptgerichte",
    "ritual.snacks": "Snacks",
    "ritual.doCheckinFirst": "Mach zuerst deinen emotionalen Check-in, damit wir dir das perfekte Rezept empfehlen können.",
    "ritual.doCheckinBtn": "Emotionalen Check-in machen 🫶",
    "ritual.noRecipes": "Keine Rezepte verfügbar",
    "ritual.noRecipesDesc": "Keine Rezepte für diesen Filter. Probiere eine andere Kategorie!",
    "ritual.completeAnyway": "Trotzdem abschließen ✓",
    "ritual.basedOnState": "Basierend auf deinem Zustand: {{mood}}",
    "ritual.servings": "{{count}} Portionen",
    "ritual.ingredients": "Zutaten:",
    "ritual.preparation": "Zubereitung:",
    "ritual.complete": "Abschließen ✓",
    "ritual.guidedMeditation": "Geführte Meditation",
    "ritual.minutesSingular": "{{count}} Minute",
    "ritual.minutesPlural": "{{count}} Minuten",
    "ritual.startMeditation": "▶  Meditation starten",
    "ritual.meditating": "Meditieren... 🧘",
    "ritual.skip": "Überspringen →",
    "ritual.alreadyDrankMatcha": "Ich habe meinen Matcha schon getrunken",
    "ritual.whatMatchaToday": "Welchen Matcha hattest du heute?",
    "ritual.selectMatchaType": "Wähle deine Matcha-Art",
    "ritual.matchaType_solo": "Purer Matcha",
    "ritual.matchaType_latte": "Matcha Latte",
    "ritual.matchaType_protein": "Matcha Protein",
    "ritual.matchaType_collagen": "Matcha Kollagen",
    "ritual.matchaType_creatine": "Matcha Kreatin",
    "ritual.matchaType_golden_milk": "Golden Milk",
    "ritual.matchaType_iced": "Eismatcha",
    "ritual.matchaType_recipe": "In einem Rezept",
    "ritual.matchaType_other": "Sonstiges",
    "ritual.streakLabel": "🔥 Serie: {{count}} Tage",
    "ritual.plantEvolved": "🌱 Deine Pflanze hat sich entwickelt!",
    "ritual.newTree": "🌳 Du hast einen Baum vollendet!",
    "ritual.journalingTitle": "Journaling 📝",
    "ritual.writeHere": "Hier schreiben...",
    "ritual.ritualComplete": "🎉 Ritual abgeschlossen!",
    "ritual.yourRitualToday": "Dein heutiges Ritual",
    "ritual.bonusPoints": "+5 Pkt Bonus. Deine Pflanze dankt dir 🌱",
    "ritual.completed": "✓ Abgeschlossen",
    "ritual.completeFiveSteps": "✨ Schließe alle 5 Schritte ab für +5 Pkt Bonus",
    "ritual.journalPrompt1": "Was war das Beste an heute?",
    "ritual.journalPrompt2": "Wofür bist du heute dankbar?",
    "ritual.journalPrompt3": "Wie willst du dich morgen fühlen?",
    "ritual.journalPrompt4": "Was hat dich zum Lächeln gebracht?",
    "ritual.meditationSubtitle_illusion": "Stärke diese Begeisterung mit Dankbarkeit und Visualisierung",
    "ritual.meditationSubtitle_calm": "Vertiefe deine Ruhe mit bewusstem Atmen",
    "ritual.meditationSubtitle_apathy": "Gewinne deine Energie zurück und verbinde dich mit dir selbst",
    "ritual.meditationSubtitle_anxiety": "Löse die Anspannung und finde deine Mitte",
    "ritual.meditationSubtitle_sadness": "Umarme deine Emotionen mit Mitgefühl und Fürsorge",
    "ritual.moodLabel_illusion": "Begeisterung",
    "ritual.moodLabel_calm": "Ruhe",
    "ritual.moodLabel_apathy": "Apathie",
    "ritual.moodLabel_anxiety": "Angst",
    "ritual.moodLabel_sadness": "Traurigkeit",
    "ritual.checkin": "Check-in",
    "ritual.recipe": "Rezept",
    "ritual.meditate": "Meditieren",
    "ritual.matcha": "Matcha",
    "ritual.journal": "Journal",
    "shop.topSellers": "Bestseller",
    "shop.buy": "+ Hinzufügen",
    "shop.all": "Alles",
    "shop.couldNotLoadProducts": "Produkte konnten nicht geladen werden",
    "shop.noProductsInCategory": "Keine Produkte in dieser Kategorie",
    "cart.title": "Warenkorb ({{count}})",
    "cart.myCart": "Mein Warenkorb ({{count}})",
    "cart.myCartLabel": "Mein Warenkorb",
    "cart.viewCartLabel": "Warenkorb ansehen",
    "cart.empty": "Leeren",
    "cart.emptyCart": "Warenkorb leeren",
    "cart.emptyCartConfirm": "Bist du sicher?",
    "cart.cartIsEmpty": "Dein Warenkorb ist leer",
    "cart.exploreShop": "Entdecke den Shop und füge Produkte hinzu",
    "cart.addFromShop": "Produkte aus dem Shop hinzufügen",
    "cart.goToShop": "Zum Shop",
    "cart.total": "Gesamt",
    "cart.checkout": "Zur Kasse",
    "cart.checkoutError": "Die Bestellung konnte nicht erstellt werden. Bitte versuche es erneut.",
    "cart.freeShipping": "Kostenloser Versand",
    "cart.subtotal": "Zwischensumme",
    "cart.shipping": "Versand",
    "cart.free": "Kostenlos",
    "cart.freeShippingAt": "Versandkostenfrei ab {{amount}}",
    "cart.remove": "Entfernen",
    "cart.removeConfirm": "\"{{title}}\" aus dem Warenkorb entfernen?",
    "cart.clear": "Warenkorb leeren",
    "cart.clearConfirm": "Bist du sicher?",
    "cart.clearBtn": "Leeren",
    "cart.emptyDesc": "Entdecke den Shop und füge Produkte hinzu",
    "cart.earnPoints": "⭐ Du verdienst {{points}} Punkte mit diesem Einkauf",
    "cart.shippingAtCheckout": "Wird an der Kasse berechnet",
    "offers.addMore": "Füge <bold>{{amount}}€</bold> mehr hinzu für <bold>{{percent}}% Rabatt</bold>",
    "offers.maxUnlocked": "<bold>Maximaler Rabatt freigeschaltet!</bold> 🎉",
    "garden.dayLabel": "Tag {{day}}",
    "garden.daysToNext": "{{days}} Tage bis {{name}}",
    "garden.treeComplete": "Baum vollendet! 🎉",
    "garden.consecutiveDays": "Aufeinanderfolgende Tage",
    "garden.totalWaterings": "Gesamte Bewässerungen",
    "garden.currentLevel": "Aktuelles Level",
    "garden.consecutiveDaysHelp": "Deine aktuelle Serie aufeinanderfolgender Matcha-Check-in-Tage. Wenn du einen Tag verpasst, geht es zurück auf Null!",
    "garden.totalWateringsHelp": "Die Gesamtzahl der Tage, an denen du deinen Matcha-Check-in gemacht hast. Jeder Check-in gießt deine Pflanze und hilft ihr zu wachsen.",
    "garden.currentLevelHelp": "Das Level deiner Pflanze. Es wächst, wenn du aufeinanderfolgende Check-in-Tage sammelst. Beim maximalen Level wird sie ein Baum für deinen Garten.",
    "garden.understood": "Verstanden",
    "garden.badgesTitle": "Abzeichen & Erfolge",
    "garden.badge_primer_brote": "Erster Keim",
    "garden.badge_racha_5": "5-Tage-Serie",
    "garden.badge_racha_10": "10-Tage-Serie",
    "garden.badge_racha_30": "30-Tage-Serie",
    "garden.badge_primer_arbol": "Erster Baum",
    "garden.badgeDesc_primer_brote": "Erster Check-in",
    "garden.badgeDesc_racha_5": "5 aufeinanderfolgende Tage",
    "garden.badgeDesc_racha_10": "10 aufeinanderfolgende Tage",
    "garden.badgeDesc_racha_30": "30 aufeinanderfolgende Tage",
    "garden.badgeDesc_primer_arbol": "30 Tage abgeschlossen",
    "rewards.yourPoints": "Deine Punkte",
    "rewards.level": "Level: {{current}}",
    "rewards.levelNext": "{{current}} → {{next}}",
    "rewards.availableRewards": "Verfügbare Prämien",
    "rewards.exclusiveApp": "App-Exklusiv — nicht im Shop erhältlich",
    "rewards.comingSoon": "Demnächst",
    "rewards.comingSoonDesc": "Wir bereiten exklusive Prämien für dich vor. Sammle weiter Punkte!",
    "rewards.merchandise": "Merchandise",
    "rewards.exclusiveProduct": "Exklusives Produkt",
    "rewards.experience": "Erlebnis",
    "rewards.outOfStock": "Ausverkauft",
    "rewards.redeem": "Einlösen",
    "rewards.missingPoints": "Noch {{count}} Pkt nötig",
    "rewards.linkAccountForRewards": "Du musst deine E-Mail verknüpfen, um Prämien einzulösen.",
    "rewards.insufficientPoints": "Unzureichende Punkte",
    "rewards.insufficientPointsDesc": "Dir fehlen {{count}} Punkte um \"{{name}}\" einzulösen. Mach weiter mit deinem täglichen Ritual!",
    "rewards.redeemConfirm": "Prämie einlösen",
    "rewards.redeemConfirmDesc": "Möchtest du \"{{name}}\" für {{points}} Punkte einlösen?",
    "rewards.redeemed": "Prämie eingelöst! 🎉",
    "rewards.redeemedDesc": "Du erhältst weitere Informationen per E-Mail.",
    "rewards.redeemError": "Fehler beim Einlösen",
    "rewards.myRedemptions": "Meine Einlösungen",
    "rewards.statusPending": "⏳ Ausstehend",
    "rewards.statusProcessing": "📦 In Vorbereitung",
    "rewards.statusShipped": "🚚 Versandt",
    "rewards.statusDelivered": "✅ Zugestellt",
    "rewards.howItWorks": "Wie funktioniert es?",
    "rewards.howStep1": "Schließe dein tägliches Ritual ab, um Punkte zu verdienen",
    "rewards.howStep2": "Sammle Punkte durch Serien, Käufe und Empfehlungen",
    "rewards.howStep3": "Löse deine Punkte für exklusive Prämien ein",
    "rewards.morePointsNeeded": "{{count}} Pkt mehr für {{level}}",
    "rewards.rewardsTitle": "Belohnungen",
    "rewards.pointsAvailable": "Punkte verfügbar",
    "rewards.howToEarnPoints": "Wie kann man Punkte verdienen?",
    "rewards.earn_purchases": "Einkäufe: +1 Pkt pro 1€ ausgegeben",
    "rewards.earn_ritualStep": "Jeder Schritt des täglichen Rituals: +1 Pkt",
    "rewards.earn_ritualComplete": "Tägliches Ritual abschließen: +5 Pkt Bonus",
    "rewards.earn_referralRegister": "Freunde einladen: +50 Pkt pro Registrierung",
    "rewards.earn_referralPurchase": "Kauf deines Gastes: +150 Pkt",
    "rewards.earn_survey": "Umfragen ausfüllen: variable Punkte",
    "rewards.earn_review": "Bewertung schreiben: +50 Pkt",
    "orders.myOrders": "Meine Bestellungen",
    "orders.processing": "In Bearbeitung",
    "orders.delivered": "Zugestellt",
    "orders.inTransit": "Unterwegs",
    "orders.shipped": "Versandt",
    "orders.partiallySent": "Teilweise versandt",
    "orders.inPreparation": "In Vorbereitung",
    "orders.cancelled": "Storniert",
    "orders.login": "Anmelden",
    "orders.loginDesc": "Verknüpfe dein Konto, um deine Bestellungen zu sehen",
    "orders.linkAccount": "Konto verknüpfen",
    "orders.loadingOrders": "Bestellungen laden...",
    "orders.loadError": "Fehler beim Laden",
    "orders.noOrders": "Keine Bestellungen",
    "orders.noOrdersDesc": "Du hast noch keine Bestellungen aufgegeben",
    "orders.goToShop": "Zum Shop",
    "orders.viewDetail": "Detail anzeigen",
    "orders.loadMore": "Mehr Bestellungen laden",
    "orders.exception": "Vorfall",
    "orders.outForDelivery": "Wird zugestellt",
    "orders.returned": "Zurückgeschickt",
    "orders.refunded": "Erstattet",
    "surveys.title": "Neuigkeiten",
    "surveys.subtitle": "Entdecke die neuesten Nachrichten, Umfragen und exklusive Inhalte",
    "surveys.noSurveys": "Keine Neuigkeiten verfügbar",
    "surveys.noSurveysDesc": "Wir benachrichtigen dich, wenn es Neues gibt. Mach weiter mit deinem täglichen Ritual!",
    "surveys.question": "Frage {{number}}",
    "surveys.required": "Pflichtfeld",
    "surveys.answered": "{{answered}} von {{total}} beantwortet",
    "surveys.writeAnswer": "Schreibe deine Antwort...",
    "surveys.completeSurvey": "Umfrage abschließen",
    "surveys.thanks": "Danke!",
    "surveys.pointsEarned": "Du hast ⭐ {{points}} Punkte verdient",
    "surveys.answersHelp": "Deine Antworten helfen uns, dein Matcha-Erlebnis zu verbessern 🍵",
    "surveys.surveyNotFound": "Umfrage nicht gefunden",
    "surveys.loadError": "Umfrage konnte nicht geladen werden.",
    "surveys.submitError": "Fehler beim Senden der Umfrage",
    "surveys.questions_one": "{{count}} Frage",
    "surveys.questions_other": "{{count}} Fragen",
    "surveys.survey": "Umfrage",
    "profile.myProfile": "Mein Profil",
    "profile.matchaPoints": "⭐ {{count}} Matcha Points",
    "profile.orders": "Bestellungen",
    "profile.points": "Punkte",
    "profile.streak": "Serie",
    "profile.badges": "Abzeichen",
    "profile.shippingAddress": "Lieferadresse",
    "profile.edit": "Bearbeiten",
    "profile.add": "Hinzufügen",
    "profile.firstName": "Vorname",
    "profile.lastName": "Nachname",
    "profile.phone": "Telefon",
    "profile.address": "Adresse",
    "profile.addressPlaceholder": "Straße, Nummer, Stock...",
    "profile.addressLine2": "Adresse (Zeile 2)",
    "profile.optional": "Optional",
    "profile.city": "Stadt",
    "profile.zip": "PLZ",
    "profile.province": "Bundesland",
    "profile.country": "Land",
    "profile.invalidPhone": "Ungültige Telefonnummer",
    "profile.addressUpdated": "Adresse aktualisiert",
    "profile.addressSaved": "Deine Lieferadresse wurde gespeichert.",
    "profile.saveError": "Fehler beim Speichern der Adresse",
    "profile.saving": "Speichern...",
    "profile.saveAddress": "Adresse speichern",
    "profile.addShippingAddress": "Lieferadresse hinzufügen",
    "profile.inviteFriend": "Freund einladen",
    "profile.inviteReward": "Verdiene 100 Pkt für jeden Freund, der kauft",
    "profile.shareLink": "Link teilen",
    "profile.shareMessage": "Probiere Matcha & CO! Nutze meinen Code für einen Rabatt auf deine erste Bestellung. https://matchaandco.com",
    "profile.notifications": "Benachrichtigungen",
    "profile.myOrdersMenu": "Meine Bestellungen",
    "profile.quickReorder": "Schnelle Nachbestellung",
    "profile.helpSupport": "Hilfe & Support",
    "profile.terms": "AGB",
    "profile.signOut": "Abmelden",
    "profile.signOutConfirm": "Bist du sicher?",
    "profile.language": "Sprache",
    "profile.selectLanguage": "Wähle deine Sprache",
    "profile.selectProvince": "Provinz auswählen",
    "profile.searchProvince": "Provinz suchen...",
    "profile.selectCountry": "Land auswählen",
    "profile.referralCodeTitle": "Empfehlungscode",
    "profile.referralCodePlaceholder": "Gib deinen Code ein",
    "profile.referralCodeHint": "Hast du einen Empfehlungscode? Gib ihn ein für Extrapunkte",
    "profile.applyCode": "Code anwenden",
    "profile.referralApplied": "Code erfolgreich angewendet",
    "profile.referralConverted": "Empfehlung umgewandelt",
    "profile.referralError": "Ungültiger Code",
    "profile.referralAlready": "Du hast bereits einen Empfehlungscode angewendet",
    "profile.referralSelf": "Du kannst deinen eigenen Code nicht verwenden",
    "profile.referralNotFound": "Code nicht gefunden",
    "profile.referralExpired": "Dieser Code ist abgelaufen",
    "profile.referralInvited": "Eingeladen",
    "profile.referralPointsEarned": "Punkte verdient",
    "profile.shareMessageWithLink": "Probier Matcha & CO! Lade die App herunter und verdiene 25 Willkommenspunkte 🍵 {{link}}",
    "profile.yourReferralCode": "Dein Empfehlungscode",
    "profile.paymentMethod": "Zahlungsmethode",
    "profile.paymentMethodHint": "Zahlungsmethode speichern und mit einem Klick kaufen",
    "profile.paymentMethodUpdated": "Zahlungsmethode aktualisiert",
    "profile.paymentMethodUpdatedDesc": "Ihre Zahlungsmethode wurde erfolgreich gespeichert.",
    "auth.linkAccount": "Konto verknüpfen",
    "orderStatus.processing": "In Bearbeitung",
    "orderStatus.delivered": "Zugestellt",
    "orderStatus.inTransit": "Unterwegs",
    "orderStatus.shipped": "Versandt",
    "orderStatus.partiallySent": "Teilweise versandt",
    "language.es": "Español",
    "language.en": "English",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.it": "Italiano",
    "language.nl": "Nederlands",
    "language.de": "Deutsch",
    "language.pl": "Polski",
    "product.notFound": "Produkt nicht gefunden",
    "product.back": "Zurück",
    "product.variant": "Variante",
    "product.quantity": "Menge",
    "product.description": "Beschreibung",
    "product.addToCart": "In den Warenkorb",
    "product.addedToCart": "Zum Warenkorb hinzugefügt",
    "product.continueShopping": "Weiter einkaufen",
    "product.viewCart": "Warenkorb anzeigen",
    "product.unit_one": "Einheit",
    "product.unit_other": "Einheiten",
    "product.ingredients": "Zutaten",
    "checkout.confirmOrder": "Bestellung bestätigen",
    "checkout.cartEmpty": "Dein Warenkorb ist leer",
    "checkout.products": "Produkte",
    "checkout.shippingAddress": "Lieferadresse",
    "checkout.changeAddress": "Adresse ändern",
    "checkout.addAddress": "Adresse hinzufügen",
    "checkout.couldNotLoadAddress": "Adresse konnte nicht geladen werden",
    "checkout.paymentMethod": "Zahlungsmethode",
    "checkout.changePayment": "Zahlungsmethode ändern",
    "checkout.useStandardCheckout": "Standard-Checkout verwenden",
    "checkout.couldNotLoadPayment": "Zahlungsmethode konnte nicht geladen werden",
    "checkout.noPaymentMethod": "Keine gespeicherte Zahlungsmethode",
    "checkout.addPaymentMethod": "Karte hinzufügen",
    "checkout.subtotal": "Zwischensumme",
    "checkout.shipping": "Versand",
    "checkout.tax": "Steuern",
    "checkout.free": "Kostenlos",
    "checkout.total": "Gesamt",
    "checkout.securePayment": "Sichere Zahlung",
    "checkout.placeOrder": "Bestellung aufgeben",
    "checkout.quantity": "Menge: {{count}}",
    "checkout.requiredFields": "Pflichtfelder",
    "checkout.requiredFieldsDesc": "Fülle mindestens Name, Adresse, Stadt und Postleitzahl aus.",
    "checkout.addressError": "Adresse konnte nicht aktualisiert werden. Bitte versuche es erneut.",
    "checkout.orderSuccess": "Bestellung aufgegeben! 🎉",
    "checkout.orderSuccessDesc": "Deine Bestellung wurde bearbeitet. Du erhältst eine Bestätigungsemail.",
    "checkout.orderSuccessBtn": "Perfekt",
    "checkout.orderError": "Bestellung konnte nicht bearbeitet werden. Bitte versuche es erneut.",
    "checkout.unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.",
    "checkout.checkoutError": "Bestellung konnte nicht erstellt werden. Bitte versuche es erneut.",
    "checkout.card": "Karte",
    "checkout.freeShipping": "Kostenloser Versand",
    "checkout.freeShippingAt": "Versandkostenfrei ab {{amount}}",
    "checkout.firstName": "Vorname *",
    "checkout.lastName": "Nachname *",
    "checkout.phone": "Telefon *",
    "checkout.address": "Adresse *",
    "checkout.floor": "Stock / Tür",
    "checkout.zip": "PLZ *",
    "checkout.city": "Stadt *",
    "checkout.optional": "Optional",
    "checkout.streetNumber": "Straße und Nummer",
    "checkout.urlNotAvailable": "Checkout-URL nicht verfügbar",
    "checkout.secureCheckout": "Sicherer Checkout",
    "checkout.loading": "Checkout wird geladen...",
    "checkout.paymentDeclined": "Die Zahlung wurde abgelehnt. Überprüfe deine Karte und versuche es erneut.",
    "checkout.paymentError_INSUFFICIENT_FUNDS": "Nicht genügend Guthaben. Überprüfe den Kontostand deiner Karte.",
    "checkout.paymentError_PAYMENT_DECLINED": "Die Zahlung wurde von deiner Bank abgelehnt.",
    "checkout.paymentError_INVALID_PAYMENT_METHOD": "Die Zahlungsmethode ist ungültig. Aktualisiere sie in deinem Profil.",
    "checkout.paymentError_EXPIRED_PAYMENT_METHOD": "Deine Karte ist abgelaufen. Aktualisiere deine Zahlungsmethode.",
    "checkout.paymentError_AUTHENTICATION_ERROR": "Authentifizierung erforderlich. Bitte versuche es erneut.",
    "checkout.paymentError_PAYMENT_PROCESSING": "Die Zahlung wird verarbeitet. Bitte warten Sie einige Minuten und überprüfen Sie Ihre Bestellungen.",
    "checkout.email": "E-Mail",
    "checkout.emailPlaceholder": "deine@email.com",
    "checkout.continue": "Weiter",
    "checkout.loginForAddress": "Gib deine E-Mail ein, um eine Adresse hinzuzufügen",
    "checkout.loginForPayment": "Gib deine E-Mail ein, um eine Zahlungsmethode hinzuzufügen",
    "checkout.emailError": "E-Mail konnte nicht verknüpft werden. Versuche es erneut.",
    "checkout.verifyCode": "Code bestätigen",
    "checkout.invalidCode": "Ungültiger oder abgelaufener Code. Versuche es erneut.",
    "checkout.codeSent": "Code gesendet an {{email}}",
    "checkout.pickupPoint": "Abholpunkt",
    "checkout.noServicePoints": "Keine Abholpunkte in der Nähe gefunden",
    "reorder.repeatOrder": "Bestellung wiederholen",
    "reorder.adjustQuantities": "Passe die Mengen an und bestätige mit einem Tippen",
    "reorder.products": "Produkte",
    "reorder.shippingAddress": "Lieferadresse",
    "reorder.loadingAddress": "Adresse wird geladen...",
    "reorder.change": "Ändern",
    "reorder.add": "Hinzufügen",
    "reorder.total": "Gesamt",
    "reorder.changesNote": "* Mengen gegenüber deiner letzten Bestellung geändert",
    "reorder.repeatBtn": "Bestellung wiederholen",
    "reorder.loadingOrder": "Deine Bestellung wird geladen...",
    "reorder.noPreviousOrder": "Keine vorherige Bestellung",
    "reorder.noPreviousOrderDesc": "Kein aktiver Nachbestellungsvertrag gefunden. Gib deine erste Bestellung im Shop auf.",
    "reorder.goToShop": "Zum Shop",
    "reorder.noProducts": "Keine Produkte",
    "reorder.noProductsDesc": "Füge mindestens ein Produkt hinzu, um deine Bestellung zu wiederholen.",
    "reorder.orderSuccess": "Bestellung aufgegeben! 🎉",
    "reorder.orderSuccessDesc": "Deine Bestellung wurde bearbeitet. Du erhältst eine Bestätigungsemail.",
    "reorder.orderSuccessBtn": "Perfekt",
    "reorder.orderError": "Bestellung konnte nicht bearbeitet werden. Bitte versuche es erneut.",
    "reorder.unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.",
    "reorder.addressError": "Adresse konnte nicht aktualisiert werden.",
    "reorder.requiredFields": "Pflichtfelder",
    "reorder.requiredFieldsDesc": "Fülle mindestens Name, Adresse, Stadt und Postleitzahl aus.",
    "reorder.product": "Produkt",
    "orderDetail.order": "Bestellung",
    "orderDetail.orders": "Bestellungen",
    "orderDetail.loadingOrder": "Bestellung wird geladen...",
    "orderDetail.loadError": "Fehler beim Laden",
    "orderDetail.orderNotFound": "Bestellung nicht gefunden",
    "orderDetail.retry": "Erneut versuchen",
    "orderDetail.shippingStatus": "Versandstatus",
    "orderDetail.confirmed": "Bestellung bestätigt",
    "orderDetail.confirmedDesc": "Deine Bestellung wurde empfangen",
    "orderDetail.preparing": "In Vorbereitung",
    "orderDetail.preparingDesc": "Wir bereiten deinen Matcha vor",
    "orderDetail.shipped": "Versandt",
    "orderDetail.shippedDesc": "Auf dem Weg zu dir",
    "orderDetail.delivered": "Zugestellt",
    "orderDetail.deliveredDesc": "Genieße deinen Matcha!",
    "orderDetail.cancelled": "Storniert",
    "orderDetail.products": "Produkte",
    "orderDetail.quantity": "Menge: {{count}}",
    "orderDetail.summary": "Zusammenfassung",
    "orderDetail.shippingAddress": "Lieferadresse",
    "orderDetail.paymentStatus": "Zahlungsstatus",
    "orderDetail.total": "Gesamt",
    "orderDetail.repeatThisOrder": "Diese Bestellung wiederholen",
    "orderDetail.repeatConfirm": "Bestellung wiederholen",
    "orderDetail.repeatConfirmDesc": "Möchtest du diese Matcha-Bestellung wiederholen?",
    "orderDetail.repeatSuccess": "Bestellung aufgegeben! 🎉",
    "orderDetail.repeatSuccessDesc": "Dein Matcha ist unterwegs.",
    "orderDetail.repeatError": "Nachbestellung konnte nicht bearbeitet werden",
    "orderDetail.needHelp": "Brauchst du Hilfe?",
    "orderDetail.needHelpDesc": "Kontaktiere den Support bei Fragen zu deiner Bestellung",
    "orderDetail.contactSupport": "Support kontaktieren",
    "orderDetail.inTransit": "Unterwegs",
    "orderDetail.outForDelivery": "In Zustellung",
    "orderDetail.outForDeliveryDesc": "Deine Bestellung kommt heute!",
    "orderDetail.exception": "Vorfall",
    "orderDetail.exceptionDesc": "Es gab ein Problem mit deiner Sendung",
    "orderDetail.returned": "Zurückgesendet",
    "orderDetail.returnedDesc": "Dein Paket wurde zurückgeschickt",
    "orderDetail.inTransitDesc": "Deine Bestellung ist unterwegs",
    "orderDetail.trackShipment": "Sendung verfolgen",
    "orderDetail.trackingEvents": "Versandverlauf",
    "redeem.rewardNotFound": "Prämie nicht gefunden",
    "redeem.couldNotLoadReward": "Prämie konnte nicht geladen werden.",
    "redeem.rewardRedeemed": "Prämie eingelöst!",
    "redeem.experienceInfo": "Du erhältst weitere Informationen per E-Mail.",
    "redeem.physicalInfo": "Wir senden es bald an deine Adresse.",
    "redeem.pointsSpent": "−{{cost}} Punkte • Guthaben: ⭐ {{balance}}",
    "redeem.backToRewards": "Zurück zu Prämien",
    "redeem.cost": "Kosten",
    "redeem.yourBalance": "Dein Guthaben",
    "redeem.missingPoints": "Dir fehlen {{count}} Punkte",
    "redeem.addressNeeded": "Adresse erforderlich",
    "redeem.addressNeededDesc": "Füge eine Lieferadresse hinzu, um deine Prämie zu erhalten.",
    "redeem.noAddressSaved": "Du hast keine gespeicherte Adresse",
    "redeem.addAddress": "Adresse hinzufügen",
    "redeem.changeAddress": "Adresse ändern",
    "redeem.confirmRedeem": "Einlösung bestätigen",
    "redeem.redeemError": "Fehler beim Einlösen der Prämie",
    "redeem.insufficientPoints": "Unzureichende Punkte",
    "redeem.insufficientPointsDesc": "Dir fehlen {{count}} Punkte um \"{{name}}\" einzulösen.",
    "savedRecipes.title": "Meine gespeicherten Rezepte",
    "savedRecipes.deleteRecipe": "Rezept löschen",
    "savedRecipes.deleteConfirm": "Möchtest du dieses Rezept aus deinen Gespeicherten entfernen?",
    "savedRecipes.noRecipes": "Keine gespeicherten Rezepte",
    "savedRecipes.noRecipesDesc": "Speichere die Rezepte, die dir gefallen, während deines täglichen Rituals, um sie hier zu finden.",
    "recipeDetail.notFound": "Rezept nicht gefunden",
    "recipeDetail.ingredients": "Zutaten",
    "recipeDetail.preparation": "Zubereitung",
    "recipeDetail.servings": "{{count}} Portionen",
    "recipeDetail.viewSource": "Auf matchaandco.com ansehen",
    "notifications.title": "Benachrichtigungen",
    "notifications.profile": "Profil",
    "notifications.disabled": "Benachrichtigungen deaktiviert",
    "notifications.disabledDesc": "Aktiviere Benachrichtigungen, um dein tägliches Ritual nicht zu verpassen",
    "notifications.enable": "Benachrichtigungen aktivieren",
    "notifications.enabled": "Fertig!",
    "notifications.enabledDesc": "Benachrichtigungen sind aktiviert",
    "notifications.permissionsNeeded": "Berechtigungen erforderlich",
    "notifications.permissionsNeededDesc": "Um Benachrichtigungen zu erhalten, aktiviere sie in deinen Geräteeinstellungen.",
    "notifications.couldNotLoad": "Einstellungen konnten nicht geladen werden",
    "notifications.couldNotSave": "Einstellung konnte nicht gespeichert werden",
    "notifications.saving": "Speichern...",
    "notifications.quietHours": "Ruhezeiten",
    "notifications.quietHoursDesc": "Du erhältst keine Benachrichtigungen zwischen {{start}} und {{end}}",
    "notifications.dailyReminder": "Tägliche Erinnerung",
    "notifications.dailyReminderDesc": "Wir erinnern dich an dein Morgenritual",
    "notifications.streakWarning": "Serienwarnung",
    "notifications.streakWarningDesc": "Warnung bevor du deine Serie verlierst",
    "notifications.orderStatus": "Bestellstatus",
    "notifications.orderStatusDesc": "Versand- und Lieferupdates",
    "notifications.restockReminder": "Nachfüll-Erinnerung",
    "notifications.restockReminderDesc": "Wenn dein Matcha zur Neige geht",
    "notifications.rewardsAvailable": "Prämien verfügbar",
    "notifications.rewardsAvailableDesc": "Wenn du Punkte einlösen kannst",
    "notifications.contentNew": "Neuer Inhalt",
    "notifications.contentNewDesc": "Neue Rezepte und Meditationen",
    "notifications.announcements": "Ankündigungen",
    "notifications.announcementsDesc": "Neuigkeiten von Matcha & CO",
    "notifications.subscriptionInfo": "Abo-Info",
    "notifications.subscriptionInfoDesc": "Verlängerungen und Änderungen",
    "onboarding.skip": "Überspringen",
    "onboarding.next": "Weiter →",
    "onboarding.linkAccount": "Konto verknüpfen",
    "onboarding.exploreWithoutAccount": "Ohne Konto erkunden",
    "onboarding.welcomeTitle": "Willkommen bei Matcha & CO",
    "onboarding.welcomeDesc": "Dein Matcha-Shop mit Nachbestellung per Klick. Aber auch ein Achtsamkeits-Tool, um jeden Tag für dein Wohlbefinden zu sorgen.",
    "onboarding.ritualTitle": "Was ist das Ritual?",
    "onboarding.ritualDesc": "Eine tägliche Übung, um bewusster wahrzunehmen, wie du dich fühlst, und gesunde Gewohnheiten in deinen Alltag einzubauen.",
    "onboarding.ritualStep1Name": "Emotionaler Check-in",
    "onboarding.ritualStep1Desc": "Wie fühlst du dich heute?",
    "onboarding.ritualStep2Name": "Rezept des Tages",
    "onboarding.ritualStep2Desc": "Ein personalisiertes Matcha-Rezept",
    "onboarding.ritualStep3Name": "Meditation",
    "onboarding.ritualStep3Desc": "Ein Moment der Ruhe und Achtsamkeit",
    "onboarding.ritualStep4Name": "Matcha",
    "onboarding.ritualStep4Desc": "Halte deinen Matcha-Moment des Tages fest",
    "onboarding.ritualStep5Name": "Tagebuch",
    "onboarding.ritualStep5Desc": "Reflektiere über deinen Tag",
    "onboarding.pointsTitle": "Matcha Points ⭐",
    "onboarding.pointsDesc": "Verdiene Punkte durch dein Ritual, Einkäufe, Empfehlungen und Serien. Löse sie für exklusive Belohnungen ein, die es nicht im Shop gibt.",
    "onboarding.streaksTitle": "Serien 🔥",
    "onboarding.streaksDesc": "Jeder Tag mit Matcha-Check-in lässt deine Serie wachsen. Erreiche Meilensteine (5, 10, 30 Tage) für Bonuspunkte. Verpasst du einen Tag, geht sie auf null zurück!",
    "onboarding.letsGoTitle": "Los geht's!",
    "onboarding.letsGoDesc": "Verknüpfe deine E-Mail, um Bestellungen und Punkte zu synchronisieren und das volle Erlebnis freizuschalten. Oder erkunde zuerst.",
    "linkAccount.title": "Konto verknüpfen",
    "linkAccount.subtitle": "Gib deine E-Mail ein und wir senden dir einen magischen Link zur Verknüpfung deines Geräts.",
    "linkAccount.sendMagicLink": "Magischen Link senden",
    "linkAccount.enterCode": "Code eingeben",
    "linkAccount.codeSent": "Wir haben einen 6-stelligen Code gesendet an",
    "linkAccount.verifyCode": "Code verifizieren",
    "linkAccount.resendCode": "Code erneut senden",
    "linkAccount.accountLinked": "Konto verknüpft",
    "linkAccount.deviceLinked": "Dein Gerät ist verknüpft mit",
    "linkAccount.backToProfile": "Zurück zum Profil",
    "linkAccount.sendError": "Fehler beim Senden des Links",
    "linkAccount.codeError": "Ungültiger Code",
    "linkAccount.haveReferralCode": "Ich habe einen Freundescode",
    "linkAccount.validateEmail": "E-Mail bestätigen",
    "completeProfile.title": "Profil vervollständigen",
    "completeProfile.subtitle": "Um deine Erfahrung zu personalisieren, benötigen wir einige Angaben",
    "completeProfile.firstName": "Vorname",
    "completeProfile.lastName": "Nachname",
    "completeProfile.phone": "Telefon",
    "completeProfile.save": "Profil speichern",
    "completeProfile.error": "Fehler beim Vervollständigen des Profils",
    "completeProfile.firstNamePlaceholder": "Vorname",
    "completeProfile.lastNamePlaceholder": "Nachname",
    "suggestedProducts.title": "Das könnte dir auch gefallen",
    "suggestedProducts.add": "Hinzufügen"
  },
  "it": {
    "tabs.home": "Home",
    "tabs.ritual": "Rituale",
    "tabs.shop": "Negozio",
    "tabs.garden": "Giardino",
    "tabs.rewards": "Premi",
    "common.back": "Indietro",
    "common.cancel": "Annulla",
    "common.save": "Salva",
    "common.delete": "Elimina",
    "common.retry": "Riprova",
    "common.close": "Chiudi",
    "common.confirm": "Conferma",
    "common.loading": "Caricamento...",
    "common.error": "Errore",
    "common.ok": "OK",
    "common.seeAll": "Vedi tutto →",
    "common.days": "giorni",
    "common.day": "giorno",
    "common.points": "punti",
    "common.pts": "pts",
    "common.noResults": "Nessun risultato",
    "date.sunday": "Domenica",
    "date.monday": "Lunedì",
    "date.tuesday": "Martedì",
    "date.wednesday": "Mercoledì",
    "date.thursday": "Giovedì",
    "date.friday": "Venerdì",
    "date.saturday": "Sabato",
    "date.january": "gennaio",
    "date.february": "febbraio",
    "date.march": "marzo",
    "date.april": "aprile",
    "date.may": "maggio",
    "date.june": "giugno",
    "date.july": "luglio",
    "date.august": "agosto",
    "date.september": "settembre",
    "date.october": "ottobre",
    "date.november": "novembre",
    "date.december": "dicembre",
    "date.dateFormat": "{{day}}, {{date}} {{month}}",
    "home.reorderTitle": "Ripeti il mio ultimo ordine",
    "home.reorderSubtitle": "Ordina di nuovo con un clic",
    "home.reorderBtn": "Ordina",
    "home.oneClickTitle": "Ripeti ordine",
    "home.oneClickBtn": "Ordina",
    "home.oneClickConfirmTitle": "Ripetere ordine?",
    "home.oneClickConfirmTotal": "Total: {{total}} €",
    "home.oneClickConfirmCard": "Carta ····{{digits}}",
    "home.oneClickConfirmBtn": "Conferma",
    "home.oneClickSuccess": "Ordine effettuato! Riceverai un email di conferma.",
    "home.streakDays": "🔥 {{count}} giorni di serie",
    "home.wildcardAvailable": "🛡️ 1 giorno di grazia disponibile",
    "home.nextMilestone": "⭐ {{days}}g → +{{points}}pts",
    "home.treesCount_one": "🌳 {{count}} albero nel tuo giardino",
    "home.treesCount_other": "🌳 {{count}} alberi nel tuo giardino",
    "home.yourRitualToday": "Il tuo rituale di oggi",
    "home.savedRecipes": "Le mie ricette salvate",
    "home.matchaFinished": "Il tuo matcha è finito",
    "home.matchaRunningOut": "Il tuo matcha finirà tra ~{{days}} giorni",
    "home.dontLoseStreak": "Non perdere la tua serie!",
    "home.oneClick": "1 clic",
    "home.restock": "Rifornisci",
    "home.orderInProgress": "Ordine in corso",
    "home.lastOrder": "Il tuo ultimo ordine",
    "home.seeAllOrders": "Vedi tutti i miei ordini →",
    "home.dailyRitual": "Il tuo rituale quotidiano",
    "home.nextStep": "PROSSIMO PASSO",
    "home.ritualBonus": "Completa tutti i 5 oggi e guadagna +5 pts bonus",
    "home.ritualCta.start": "Inizia il mio rituale →",
    "home.ritualCta.continue": "Continua il rituale →",
    "home.ritualCta.completed": "Vedi il riepilogo →",
    "home.linkAccount": "Collega il tuo account",
    "home.linkAccountDesc": "Sincronizza i tuoi ordini e punti collegando la tua email",
    "home.stat.streakLabel": "GIORNI\nDI FILA",
    "home.stat.pointsLabel": "PUNTI\nGUADAGNATI",
    "home.stat.levelLabel": "LIVELLO\nATTUALE",
    "home.statModal.streakTitle": "Giorni di fila",
    "home.statModal.streakBody": "La tua serie conta i giorni consecutivi in cui completi almeno un passo del tuo rituale quotidiano.\n\nMantenere la serie sblocca bonus punti ai traguardi di 7, 14 e 30 giorni.\n\nSe salti un giorno, hai un giorno di grazia che protegge la tua serie.",
    "home.statModal.pointsTitle": "Punti guadagnati",
    "home.statModal.pointsBody": "I punti sono la tua valuta in Matcha & CO. Guadagnali completando il tuo rituale quotidiano, sondaggi e altre attività.\n\nScambiali per ricompense esclusive come prodotti gratis, sconti e regali speciali.\n\nQuesto contatore mostra i tuoi punti disponibili.",
    "home.statModal.levelTitle": "Livello attuale",
    "home.statModal.levelIntro": "Il tuo livello riflette il tuo impegno accumulato con Matcha & CO. Sali di livello guadagnando punti.",
    "home.statModal.levelNeverDrops": "A differenza dei punti riscattabili, il tuo livello non scende mai.",
    "home.greetingMorning": "BUONGIORNO",
    "home.greetingAfternoon": "BUON POMERIGGIO",
    "home.greetingEvening": "BUONASERA",
    "home.greetingFallback": "Ciao!",
    "home.today": "OGGI",
    "home.understood": "Capito",
    "home.rewardsTitle": "PREMI",
    "home.rewardsSubtitle": "Regali esclusivi",
    "home.seeAllRewards": "Vedi tutti i regali  →",
    "home.recipeOfDay": "RICETTA DEL GIORNO",
    "home.motivational_0": "Ogni tazza è un passo verso il tuo benessere 🍵",
    "home.motivational_1": "Il tuo corpo ti ringrazia 🌿",
    "home.motivational_2": "Un piccolo rituale, un grande cambiamento ✨",
    "home.motivational_3": "Oggi hai scelto di prenderti cura di te 💚",
    "home.motivational_4": "La tua costanza è il tuo superpotere 🌱",
    "home.motivational_5": "Respira, bevi, sorridi. Ripeti domani ☀️",
    "home.greetingHello": "Ciao, {{name}}!",
    "home.paymentBannerTitle": "Aggiungi la tua carta e acquista con un clic",
    "home.paymentBannerSubtitle": "Salva il tuo metodo di pagamento per rendere il prossimo ordine più facile e guadagna {{points}} punti.",
    "home.paymentBannerBtn": "Aggiungi",
    "home.paymentMethodBonusSuccess": "Hai guadagnato {{points}} punti aggiungendo il tuo metodo di pagamento!",
    "ritual.emotionalCheckin": "Check-in emotivo",
    "ritual.recommendedRecipe": "Ricetta consigliata",
    "ritual.meditation": "Meditazione",
    "ritual.registerMatcha": "Registra matcha",
    "ritual.journaling": "Journaling",
    "ritual.howDoYouFeel": "Come ti senti oggi?",
    "ritual.chooseMood": "Scegli l'emozione che ti rappresenta meglio",
    "ritual.whatRecipe": "Che tipo di ricetta ti va?",
    "ritual.yourState": "Il tuo stato: {{emoji}} {{label}}",
    "ritual.illusion": "Entusiasmo",
    "ritual.calm": "Calma",
    "ritual.apathy": "Apatia",
    "ritual.anxiety": "Ansia",
    "ritual.sadness": "Tristezza",
    "ritual.allCategories": "Tutte",
    "ritual.drinks": "Bevande",
    "ritual.breakfast": "Colazione",
    "ritual.desserts": "Dolci",
    "ritual.mains": "Piatti principali",
    "ritual.snacks": "Snack",
    "ritual.doCheckinFirst": "Fai prima il tuo check-in emotivo per poterti consigliare la ricetta perfetta.",
    "ritual.doCheckinBtn": "Fare check-in emotivo 🫶",
    "ritual.noRecipes": "Nessuna ricetta disponibile",
    "ritual.noRecipesDesc": "Nessuna ricetta per questo filtro. Prova un'altra categoria!",
    "ritual.completeAnyway": "Completa comunque ✓",
    "ritual.basedOnState": "Basata sul tuo stato: {{mood}}",
    "ritual.servings": "{{count}} porzioni",
    "ritual.ingredients": "Ingredienti:",
    "ritual.preparation": "Preparazione:",
    "ritual.complete": "Completa ✓",
    "ritual.guidedMeditation": "Meditazione guidata",
    "ritual.minutesSingular": "{{count}} minuto",
    "ritual.minutesPlural": "{{count}} minuti",
    "ritual.startMeditation": "▶  Inizia meditazione",
    "ritual.meditating": "Meditando... 🧘",
    "ritual.skip": "Salta →",
    "ritual.alreadyDrankMatcha": "Ho già bevuto il mio matcha",
    "ritual.whatMatchaToday": "Che matcha hai preso oggi?",
    "ritual.selectMatchaType": "Seleziona il tipo di matcha",
    "ritual.matchaType_solo": "Matcha puro",
    "ritual.matchaType_latte": "Matcha latte",
    "ritual.matchaType_protein": "Matcha proteina",
    "ritual.matchaType_collagen": "Matcha collagene",
    "ritual.matchaType_creatine": "Matcha creatina",
    "ritual.matchaType_golden_milk": "Golden milk",
    "ritual.matchaType_iced": "Matcha freddo",
    "ritual.matchaType_recipe": "In ricetta",
    "ritual.matchaType_other": "Altro",
    "ritual.streakLabel": "🔥 Serie: {{count}} giorni",
    "ritual.plantEvolved": "🌱 La tua pianta si è evoluta!",
    "ritual.newTree": "🌳 Hai completato un albero!",
    "ritual.journalingTitle": "Journaling 📝",
    "ritual.writeHere": "Scrivi qui...",
    "ritual.ritualComplete": "🎉 Rituale completo!",
    "ritual.yourRitualToday": "Il tuo rituale di oggi",
    "ritual.bonusPoints": "+5 pts bonus. La tua pianta ti ringrazia 🌱",
    "ritual.completed": "✓ Completato",
    "ritual.completeFiveSteps": "✨ Completa i 5 passaggi per guadagnare +5 pts bonus",
    "ritual.journalPrompt1": "Qual è stata la cosa migliore di oggi?",
    "ritual.journalPrompt2": "Di cosa sei grato oggi?",
    "ritual.journalPrompt3": "Come vuoi sentirti domani?",
    "ritual.journalPrompt4": "Cosa ti ha fatto sorridere?",
    "ritual.meditationSubtitle_illusion": "Rafforza l'entusiasmo con gratitudine e visualizzazione",
    "ritual.meditationSubtitle_calm": "Approfondisci la tua calma con la respirazione consapevole",
    "ritual.meditationSubtitle_apathy": "Recupera la tua energia e riconnettiti con te stesso",
    "ritual.meditationSubtitle_anxiety": "Libera la tensione e trova il tuo centro",
    "ritual.meditationSubtitle_sadness": "Abbraccia le tue emozioni con compassione e affetto",
    "ritual.moodLabel_illusion": "entusiasmo",
    "ritual.moodLabel_calm": "calma",
    "ritual.moodLabel_apathy": "apatia",
    "ritual.moodLabel_anxiety": "ansia",
    "ritual.moodLabel_sadness": "tristezza",
    "ritual.checkin": "Check-in",
    "ritual.recipe": "Ricetta",
    "ritual.meditate": "Meditare",
    "ritual.matcha": "Matcha",
    "ritual.journal": "Journal",
    "shop.topSellers": "Più venduti",
    "shop.buy": "+ Aggiungi",
    "shop.all": "Tutto",
    "shop.couldNotLoadProducts": "Impossibile caricare i prodotti",
    "shop.noProductsInCategory": "Nessun prodotto in questa categoria",
    "cart.title": "Carrello ({{count}})",
    "cart.myCart": "Il mio carrello ({{count}})",
    "cart.myCartLabel": "Il mio carrello",
    "cart.viewCartLabel": "Vedi il mio carrello",
    "cart.empty": "Svuota",
    "cart.emptyCart": "Svuota carrello",
    "cart.emptyCartConfirm": "Sei sicuro?",
    "cart.cartIsEmpty": "Il tuo carrello è vuoto",
    "cart.exploreShop": "Esplora il negozio e aggiungi prodotti",
    "cart.addFromShop": "Aggiungi prodotti dal negozio",
    "cart.goToShop": "Vai al negozio",
    "cart.total": "Totale",
    "cart.checkout": "Completa l'acquisto",
    "cart.checkoutError": "Impossibile creare l'ordine. Riprova.",
    "cart.freeShipping": "Spedizione gratuita",
    "cart.subtotal": "Subtotale",
    "cart.shipping": "Spedizione",
    "cart.free": "Gratuita",
    "cart.freeShippingAt": "Spedizione gratuita da {{amount}}",
    "cart.remove": "Rimuovi",
    "cart.removeConfirm": "Rimuovere \"{{title}}\" dal carrello?",
    "cart.clear": "Svuota carrello",
    "cart.clearConfirm": "Sei sicuro?",
    "cart.clearBtn": "Svuota",
    "cart.emptyDesc": "Esplora il negozio e aggiungi prodotti",
    "cart.earnPoints": "⭐ Guadagnerai {{points}} punti con questo acquisto",
    "cart.shippingAtCheckout": "Calcolato al checkout",
    "offers.addMore": "Aggiungi <bold>{{amount}}€</bold> in più per uno <bold>sconto del {{percent}}%</bold>",
    "offers.maxUnlocked": "<bold>Sconto massimo sbloccato!</bold> 🎉",
    "garden.dayLabel": "Giorno {{day}}",
    "garden.daysToNext": "{{days}} giorni per {{name}}",
    "garden.treeComplete": "Albero completo! 🎉",
    "garden.consecutiveDays": "Giorni consecutivi",
    "garden.totalWaterings": "Innaffiature totali",
    "garden.currentLevel": "Livello attuale",
    "garden.consecutiveDaysHelp": "La tua serie attuale di giorni consecutivi di check-in matcha. Se salti un giorno, riparte da zero!",
    "garden.totalWateringsHelp": "Il numero totale di giorni in cui hai fatto il check-in matcha. Ogni check-in innaffia la tua pianta e la aiuta a crescere.",
    "garden.currentLevelHelp": "Il livello della tua pianta. Cresce man mano che accumuli giorni di check-in consecutivi. Al livello massimo, diventa un albero per il tuo giardino.",
    "garden.understood": "Capito",
    "garden.badgesTitle": "Medaglie e traguardi",
    "garden.badge_primer_brote": "Primo Germoglio",
    "garden.badge_racha_5": "Serie di 5",
    "garden.badge_racha_10": "Serie di 10",
    "garden.badge_racha_30": "Serie di 30",
    "garden.badge_primer_arbol": "Primo Albero",
    "garden.badgeDesc_primer_brote": "Primo check-in",
    "garden.badgeDesc_racha_5": "5 giorni consecutivi",
    "garden.badgeDesc_racha_10": "10 giorni consecutivi",
    "garden.badgeDesc_racha_30": "30 giorni consecutivi",
    "garden.badgeDesc_primer_arbol": "30 giorni completati",
    "rewards.yourPoints": "I tuoi punti",
    "rewards.level": "Livello: {{current}}",
    "rewards.levelNext": "{{current}} → {{next}}",
    "rewards.availableRewards": "Premi disponibili",
    "rewards.exclusiveApp": "Esclusivi dell'app — non disponibili in negozio",
    "rewards.comingSoon": "In arrivo",
    "rewards.comingSoonDesc": "Stiamo preparando premi esclusivi per te. Continua ad accumulare punti!",
    "rewards.merchandise": "Merchandising",
    "rewards.exclusiveProduct": "Prodotto esclusivo",
    "rewards.experience": "Esperienza",
    "rewards.outOfStock": "Esaurito",
    "rewards.redeem": "Riscatta",
    "rewards.missingPoints": "Mancano {{count}} pts",
    "rewards.linkAccountForRewards": "Devi collegare la tua email per riscattare i premi.",
    "rewards.insufficientPoints": "Punti insufficienti",
    "rewards.insufficientPointsDesc": "Ti mancano {{count}} punti per riscattare \"{{name}}\". Continua con il tuo rituale quotidiano!",
    "rewards.redeemConfirm": "Riscatta premio",
    "rewards.redeemConfirmDesc": "Vuoi riscattare \"{{name}}\" per {{points}} punti?",
    "rewards.redeemed": "Premio riscattato! 🎉",
    "rewards.redeemedDesc": "Riceverai maggiori informazioni via email.",
    "rewards.redeemError": "Errore nel riscatto",
    "rewards.myRedemptions": "I miei riscatti",
    "rewards.statusPending": "⏳ In attesa",
    "rewards.statusProcessing": "📦 In preparazione",
    "rewards.statusShipped": "🚚 Spedito",
    "rewards.statusDelivered": "✅ Consegnato",
    "rewards.howItWorks": "Come funziona?",
    "rewards.howStep1": "Completa il tuo rituale quotidiano per guadagnare punti",
    "rewards.howStep2": "Accumula punti con serie, acquisti e referral",
    "rewards.howStep3": "Riscatta i tuoi punti per premi esclusivi",
    "rewards.morePointsNeeded": "{{count}} pts in più per {{level}}",
    "rewards.rewardsTitle": "Premi",
    "rewards.pointsAvailable": "punti disponibili",
    "rewards.howToEarnPoints": "Come guadagnare punti?",
    "rewards.earn_purchases": "Acquisti: +1 pt per ogni 1€ speso",
    "rewards.earn_ritualStep": "Ogni passo del Rituale quotidiano: +1 pt",
    "rewards.earn_ritualComplete": "Completare il Rituale quotidiano: +5 pts bonus",
    "rewards.earn_referralRegister": "Invitare amici: +50 pts per registrazione",
    "rewards.earn_referralPurchase": "Acquisto del tuo invitato: +150 pts",
    "rewards.earn_survey": "Completare sondaggi: punti variabili",
    "rewards.earn_review": "Scrivere una recensione: +50 pts",
    "orders.myOrders": "I miei ordini",
    "orders.processing": "In elaborazione",
    "orders.delivered": "Consegnato",
    "orders.inTransit": "In transito",
    "orders.shipped": "Spedito",
    "orders.partiallySent": "Parzialmente spedito",
    "orders.inPreparation": "In preparazione",
    "orders.cancelled": "Annullato",
    "orders.login": "Accedi",
    "orders.loginDesc": "Collega il tuo account per vedere i tuoi ordini",
    "orders.linkAccount": "Collega account",
    "orders.loadingOrders": "Caricamento ordini...",
    "orders.loadError": "Errore di caricamento",
    "orders.noOrders": "Nessun ordine",
    "orders.noOrdersDesc": "Non hai ancora effettuato nessun ordine",
    "orders.goToShop": "Vai al negozio",
    "orders.viewDetail": "Vedi dettaglio",
    "orders.loadMore": "Carica altri ordini",
    "orders.exception": "Problema",
    "orders.outForDelivery": "In consegna",
    "orders.returned": "Restituito",
    "orders.refunded": "Rimborsato",
    "surveys.title": "Novità",
    "surveys.subtitle": "Scopri le ultime novità, sondaggi e contenuti esclusivi",
    "surveys.noSurveys": "Nessuna novità disponibile",
    "surveys.noSurveysDesc": "Ti avviseremo quando ci saranno novità. Continua con il tuo rituale quotidiano!",
    "surveys.question": "Domanda {{number}}",
    "surveys.required": "Obbligatoria",
    "surveys.answered": "{{answered}} di {{total}} risposte",
    "surveys.writeAnswer": "Scrivi la tua risposta...",
    "surveys.completeSurvey": "Completa sondaggio",
    "surveys.thanks": "Grazie!",
    "surveys.pointsEarned": "Hai guadagnato ⭐ {{points}} punti",
    "surveys.answersHelp": "Le tue risposte ci aiutano a migliorare la tua esperienza matcha 🍵",
    "surveys.surveyNotFound": "Sondaggio non trovato",
    "surveys.loadError": "Impossibile caricare il sondaggio.",
    "surveys.submitError": "Errore nell'invio del sondaggio",
    "surveys.questions_one": "{{count}} domanda",
    "surveys.questions_other": "{{count}} domande",
    "surveys.survey": "Sondaggio",
    "profile.myProfile": "Il mio profilo",
    "profile.matchaPoints": "⭐ {{count}} Matcha Points",
    "profile.orders": "Ordini",
    "profile.points": "Punti",
    "profile.streak": "Serie",
    "profile.badges": "Medaglie",
    "profile.shippingAddress": "Indirizzo di spedizione",
    "profile.edit": "Modifica",
    "profile.add": "Aggiungi",
    "profile.firstName": "Nome",
    "profile.lastName": "Cognome",
    "profile.phone": "Telefono",
    "profile.address": "Indirizzo",
    "profile.addressPlaceholder": "Via, numero, piano...",
    "profile.addressLine2": "Indirizzo (riga 2)",
    "profile.optional": "Facoltativo",
    "profile.city": "Città",
    "profile.zip": "CAP",
    "profile.province": "Provincia",
    "profile.country": "Paese",
    "profile.invalidPhone": "Numero di telefono non valido",
    "profile.addressUpdated": "Indirizzo aggiornato",
    "profile.addressSaved": "Il tuo indirizzo di spedizione è stato salvato.",
    "profile.saveError": "Errore nel salvataggio dell'indirizzo",
    "profile.saving": "Salvataggio...",
    "profile.saveAddress": "Salva indirizzo",
    "profile.addShippingAddress": "Aggiungi indirizzo di spedizione",
    "profile.inviteFriend": "Invita un amico",
    "profile.inviteReward": "Guadagna 100 pts per ogni amico che acquista",
    "profile.shareLink": "Condividi link",
    "profile.shareMessage": "Prova Matcha & CO! Usa il mio codice per ottenere uno sconto sul tuo primo ordine. https://matchaandco.com",
    "profile.notifications": "Notifiche",
    "profile.myOrdersMenu": "I miei ordini",
    "profile.quickReorder": "Riordino rapido",
    "profile.helpSupport": "Aiuto e supporto",
    "profile.terms": "Termini e condizioni",
    "profile.signOut": "Disconnetti",
    "profile.signOutConfirm": "Sei sicuro?",
    "profile.language": "Lingua",
    "profile.selectLanguage": "Seleziona la tua lingua",
    "profile.selectProvince": "Seleziona la provincia",
    "profile.searchProvince": "Cerca provincia...",
    "profile.selectCountry": "Seleziona il paese",
    "profile.referralCodeTitle": "Codice referral",
    "profile.referralCodePlaceholder": "Inserisci il codice",
    "profile.referralCodeHint": "Hai un codice referral? Inseriscilo per guadagnare punti extra",
    "profile.applyCode": "Applica codice",
    "profile.referralApplied": "Codice applicato con successo",
    "profile.referralConverted": "Referral convertito",
    "profile.referralError": "Codice non valido",
    "profile.referralAlready": "Hai già applicato un codice referral",
    "profile.referralSelf": "Non puoi usare il tuo codice",
    "profile.referralNotFound": "Codice non trovato",
    "profile.referralExpired": "Questo codice è scaduto",
    "profile.referralInvited": "Invitati",
    "profile.referralPointsEarned": "Pts guadagnati",
    "profile.shareMessageWithLink": "Prova Matcha & CO! Scarica l'app e guadagna 25 punti di benvenuto 🍵 {{link}}",
    "profile.yourReferralCode": "Il tuo codice referral",
    "profile.paymentMethod": "Metodo di pagamento",
    "profile.paymentMethodHint": "Salva il tuo metodo di pagamento per acquistare con un clic",
    "profile.paymentMethodUpdated": "Metodo di pagamento aggiornato",
    "profile.paymentMethodUpdatedDesc": "Il tuo metodo di pagamento è stato salvato con successo.",
    "auth.linkAccount": "Collega il tuo account",
    "orderStatus.processing": "In elaborazione",
    "orderStatus.delivered": "Consegnato",
    "orderStatus.inTransit": "In transito",
    "orderStatus.shipped": "Spedito",
    "orderStatus.partiallySent": "Parzialmente spedito",
    "language.es": "Español",
    "language.en": "English",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.it": "Italiano",
    "language.nl": "Nederlands",
    "language.de": "Deutsch",
    "language.pl": "Polski",
    "product.notFound": "Prodotto non trovato",
    "product.back": "Indietro",
    "product.variant": "Variante",
    "product.quantity": "Quantità",
    "product.description": "Descrizione",
    "product.addToCart": "Aggiungi al carrello",
    "product.addedToCart": "Aggiunto al carrello",
    "product.continueShopping": "Continua lo shopping",
    "product.viewCart": "Vedi carrello",
    "product.unit_one": "unità",
    "product.unit_other": "unità",
    "product.ingredients": "Ingredienti",
    "checkout.confirmOrder": "Conferma ordine",
    "checkout.cartEmpty": "Il tuo carrello è vuoto",
    "checkout.products": "Prodotti",
    "checkout.shippingAddress": "Indirizzo di spedizione",
    "checkout.changeAddress": "Cambia indirizzo",
    "checkout.addAddress": "Aggiungi indirizzo",
    "checkout.couldNotLoadAddress": "Impossibile caricare l'indirizzo",
    "checkout.paymentMethod": "Metodo di pagamento",
    "checkout.changePayment": "Cambia metodo di pagamento",
    "checkout.useStandardCheckout": "Usa checkout standard",
    "checkout.couldNotLoadPayment": "Impossibile caricare il metodo di pagamento",
    "checkout.noPaymentMethod": "Nessun metodo di pagamento salvato",
    "checkout.addPaymentMethod": "Aggiungi carta",
    "checkout.subtotal": "Subtotale",
    "checkout.shipping": "Spedizione",
    "checkout.tax": "Tasse",
    "checkout.free": "Gratuita",
    "checkout.total": "Totale",
    "checkout.securePayment": "Pagamento sicuro",
    "checkout.placeOrder": "Completa l'ordine",
    "checkout.quantity": "Quantità: {{count}}",
    "checkout.requiredFields": "Campi obbligatori",
    "checkout.requiredFieldsDesc": "Compila almeno nome, indirizzo, città e codice postale.",
    "checkout.addressError": "Impossibile aggiornare l'indirizzo. Riprova.",
    "checkout.orderSuccess": "Ordine effettuato! 🎉",
    "checkout.orderSuccessDesc": "Il tuo ordine è stato elaborato. Riceverai un'email di conferma.",
    "checkout.orderSuccessBtn": "Perfetto",
    "checkout.orderError": "Impossibile elaborare l'ordine. Riprova.",
    "checkout.unexpectedError": "Si è verificato un errore imprevisto. Riprova.",
    "checkout.checkoutError": "Impossibile creare l'ordine. Riprova.",
    "checkout.card": "Carta",
    "checkout.freeShipping": "Spedizione gratuita",
    "checkout.freeShippingAt": "Spedizione gratuita da {{amount}}",
    "checkout.firstName": "Nome *",
    "checkout.lastName": "Cognome *",
    "checkout.phone": "Telefono *",
    "checkout.address": "Indirizzo *",
    "checkout.floor": "Piano / Porta",
    "checkout.zip": "CAP *",
    "checkout.city": "Città *",
    "checkout.optional": "Facoltativo",
    "checkout.streetNumber": "Via e numero",
    "checkout.urlNotAvailable": "URL di checkout non disponibile",
    "checkout.secureCheckout": "Checkout sicuro",
    "checkout.loading": "Caricamento checkout...",
    "checkout.paymentDeclined": "Il pagamento è stato rifiutato. Verifica la tua carta e riprova.",
    "checkout.paymentError_INSUFFICIENT_FUNDS": "Fondi insufficienti. Verifica il saldo della tua carta.",
    "checkout.paymentError_PAYMENT_DECLINED": "Il pagamento è stato rifiutato dalla tua banca.",
    "checkout.paymentError_INVALID_PAYMENT_METHOD": "Il metodo di pagamento non è valido. Aggiornalo nel tuo profilo.",
    "checkout.paymentError_EXPIRED_PAYMENT_METHOD": "La tua carta è scaduta. Aggiorna il metodo di pagamento.",
    "checkout.paymentError_AUTHENTICATION_ERROR": "Autenticazione richiesta. Riprova.",
    "checkout.paymentError_PAYMENT_PROCESSING": "Il pagamento è in elaborazione. Attendi qualche minuto e controlla i tuoi ordini.",
    "checkout.email": "Email",
    "checkout.emailPlaceholder": "tua@email.com",
    "checkout.continue": "Continua",
    "checkout.loginForAddress": "Inserisci la tua email per aggiungere un indirizzo",
    "checkout.loginForPayment": "Inserisci la tua email per aggiungere un metodo di pagamento",
    "checkout.emailError": "Impossibile collegare l'email. Riprova.",
    "checkout.verifyCode": "Verifica codice",
    "checkout.invalidCode": "Codice non valido o scaduto. Riprova.",
    "checkout.codeSent": "Codice inviato a {{email}}",
    "checkout.pickupPoint": "Punto di ritiro",
    "checkout.noServicePoints": "Nessun punto di ritiro trovato nelle vicinanze",
    "reorder.repeatOrder": "Ripeti il tuo ordine",
    "reorder.adjustQuantities": "Regola le quantità se vuoi e conferma con un tocco",
    "reorder.products": "Prodotti",
    "reorder.shippingAddress": "Indirizzo di spedizione",
    "reorder.loadingAddress": "Caricamento indirizzo...",
    "reorder.change": "Modifica",
    "reorder.add": "Aggiungi",
    "reorder.total": "Totale",
    "reorder.changesNote": "* Quantità modificate rispetto all'ultimo ordine",
    "reorder.repeatBtn": "Ripeti ordine",
    "reorder.loadingOrder": "Caricamento del tuo ordine...",
    "reorder.noPreviousOrder": "Nessun ordine precedente",
    "reorder.noPreviousOrderDesc": "Nessun contratto di riacquisto attivo trovato. Fai il tuo primo ordine nel negozio.",
    "reorder.goToShop": "Vai al negozio",
    "reorder.noProducts": "Nessun prodotto",
    "reorder.noProductsDesc": "Aggiungi almeno un prodotto per ripetere il tuo ordine.",
    "reorder.orderSuccess": "Ordine effettuato! 🎉",
    "reorder.orderSuccessDesc": "Il tuo ordine è stato elaborato. Riceverai un'email di conferma.",
    "reorder.orderSuccessBtn": "Perfetto",
    "reorder.orderError": "Impossibile elaborare l'ordine. Riprova.",
    "reorder.unexpectedError": "Si è verificato un errore imprevisto. Riprova.",
    "reorder.addressError": "Impossibile aggiornare l'indirizzo.",
    "reorder.requiredFields": "Campi obbligatori",
    "reorder.requiredFieldsDesc": "Compila almeno nome, indirizzo, città e codice postale.",
    "reorder.product": "Prodotto",
    "orderDetail.order": "Ordine",
    "orderDetail.orders": "Ordini",
    "orderDetail.loadingOrder": "Caricamento ordine...",
    "orderDetail.loadError": "Errore di caricamento",
    "orderDetail.orderNotFound": "Ordine non trovato",
    "orderDetail.retry": "Riprova",
    "orderDetail.shippingStatus": "Stato della spedizione",
    "orderDetail.confirmed": "Ordine confermato",
    "orderDetail.confirmedDesc": "Il tuo ordine è stato ricevuto",
    "orderDetail.preparing": "In preparazione",
    "orderDetail.preparingDesc": "Stiamo preparando il tuo matcha",
    "orderDetail.shipped": "Spedito",
    "orderDetail.shippedDesc": "In arrivo da te",
    "orderDetail.delivered": "Consegnato",
    "orderDetail.deliveredDesc": "Goditi il tuo matcha!",
    "orderDetail.cancelled": "Annullato",
    "orderDetail.products": "Prodotti",
    "orderDetail.quantity": "Quantità: {{count}}",
    "orderDetail.summary": "Riepilogo",
    "orderDetail.shippingAddress": "Indirizzo di spedizione",
    "orderDetail.paymentStatus": "Stato del pagamento",
    "orderDetail.total": "Totale",
    "orderDetail.repeatThisOrder": "Ripeti questo ordine",
    "orderDetail.repeatConfirm": "Ripeti ordine",
    "orderDetail.repeatConfirmDesc": "Vuoi ripetere questo ordine di matcha?",
    "orderDetail.repeatSuccess": "Ordine effettuato! 🎉",
    "orderDetail.repeatSuccessDesc": "Il tuo matcha è in arrivo.",
    "orderDetail.repeatError": "Impossibile elaborare il riacquisto",
    "orderDetail.needHelp": "Hai bisogno di aiuto?",
    "orderDetail.needHelpDesc": "Contatta il supporto se hai domande sul tuo ordine",
    "orderDetail.contactSupport": "Contatta il supporto",
    "orderDetail.inTransit": "In transito",
    "orderDetail.outForDelivery": "In consegna",
    "orderDetail.outForDeliveryDesc": "Il tuo ordine arriva oggi!",
    "orderDetail.exception": "Problema",
    "orderDetail.exceptionDesc": "C'è stato un problema con la tua spedizione",
    "orderDetail.returned": "Restituito",
    "orderDetail.returnedDesc": "Il tuo pacco è stato restituito al mittente",
    "orderDetail.inTransitDesc": "Il tuo ordine è in transito",
    "orderDetail.trackShipment": "Traccia spedizione",
    "orderDetail.trackingEvents": "Cronologia spedizione",
    "redeem.rewardNotFound": "Premio non trovato",
    "redeem.couldNotLoadReward": "Impossibile caricare il premio.",
    "redeem.rewardRedeemed": "Premio riscattato!",
    "redeem.experienceInfo": "Riceverai maggiori informazioni via email.",
    "redeem.physicalInfo": "Te lo invieremo presto al tuo indirizzo.",
    "redeem.pointsSpent": "−{{cost}} punti • Saldo: ⭐ {{balance}}",
    "redeem.backToRewards": "Torna ai premi",
    "redeem.cost": "Costo",
    "redeem.yourBalance": "Il tuo saldo",
    "redeem.missingPoints": "Ti mancano {{count}} punti",
    "redeem.addressNeeded": "Indirizzo necessario",
    "redeem.addressNeededDesc": "Aggiungi un indirizzo di spedizione per ricevere il tuo premio.",
    "redeem.noAddressSaved": "Non hai un indirizzo salvato",
    "redeem.addAddress": "Aggiungi indirizzo",
    "redeem.changeAddress": "Cambia indirizzo",
    "redeem.confirmRedeem": "Conferma riscatto",
    "redeem.redeemError": "Errore nel riscatto del premio",
    "redeem.insufficientPoints": "Punti insufficienti",
    "redeem.insufficientPointsDesc": "Ti mancano {{count}} punti per riscattare \"{{name}}\".",
    "savedRecipes.title": "Le mie ricette salvate",
    "savedRecipes.deleteRecipe": "Elimina ricetta",
    "savedRecipes.deleteConfirm": "Vuoi rimuovere questa ricetta dalle tue salvate?",
    "savedRecipes.noRecipes": "Nessuna ricetta salvata",
    "savedRecipes.noRecipesDesc": "Salva le ricette che ti piacciono durante il tuo rituale quotidiano per ritrovarle qui.",
    "recipeDetail.notFound": "Ricetta non trovata",
    "recipeDetail.ingredients": "Ingredienti",
    "recipeDetail.preparation": "Preparazione",
    "recipeDetail.servings": "{{count}} porzioni",
    "recipeDetail.viewSource": "Vedi su matchaandco.com",
    "notifications.title": "Notifiche",
    "notifications.profile": "Profilo",
    "notifications.disabled": "Notifiche disattivate",
    "notifications.disabledDesc": "Attiva le notifiche per non perderti il tuo rituale quotidiano",
    "notifications.enable": "Attiva notifiche",
    "notifications.enabled": "Fatto!",
    "notifications.enabledDesc": "Le notifiche sono attivate",
    "notifications.permissionsNeeded": "Permessi necessari",
    "notifications.permissionsNeededDesc": "Per ricevere notifiche, attivale nelle impostazioni del tuo dispositivo.",
    "notifications.couldNotLoad": "Impossibile caricare le preferenze",
    "notifications.couldNotSave": "Impossibile salvare la preferenza",
    "notifications.saving": "Salvataggio...",
    "notifications.quietHours": "Ore silenziose",
    "notifications.quietHoursDesc": "Non riceverai notifiche tra le {{start}} e le {{end}}",
    "notifications.dailyReminder": "Promemoria giornaliero",
    "notifications.dailyReminderDesc": "Ti ricordiamo il tuo rituale mattutino",
    "notifications.streakWarning": "Avviso serie",
    "notifications.streakWarningDesc": "Avviso prima di perdere la tua serie",
    "notifications.orderStatus": "Stato degli ordini",
    "notifications.orderStatusDesc": "Aggiornamenti su spedizione e consegna",
    "notifications.restockReminder": "Promemoria rifornimento",
    "notifications.restockReminderDesc": "Quando il tuo matcha sta finendo",
    "notifications.rewardsAvailable": "Premi disponibili",
    "notifications.rewardsAvailableDesc": "Quando puoi riscattare punti",
    "notifications.contentNew": "Nuovo contenuto",
    "notifications.contentNewDesc": "Nuove ricette e meditazioni",
    "notifications.announcements": "Comunicazioni",
    "notifications.announcementsDesc": "Novità da Matcha & CO",
    "notifications.subscriptionInfo": "Info abbonamento",
    "notifications.subscriptionInfoDesc": "Rinnovi e modifiche",
    "onboarding.skip": "Salta",
    "onboarding.next": "Avanti →",
    "onboarding.linkAccount": "Collega account",
    "onboarding.exploreWithoutAccount": "Esplora senza account",
    "onboarding.welcomeTitle": "Benvenuto su Matcha & CO",
    "onboarding.welcomeDesc": "Il tuo negozio di matcha con riordino in un clic. Ma anche uno strumento di Mindfulness per prenderti cura del tuo benessere ogni giorno.",
    "onboarding.ritualTitle": "Cos'è il Rituale?",
    "onboarding.ritualDesc": "Un esercizio quotidiano per essere più consapevole di come ti senti e integrare buone abitudini nella tua routine.",
    "onboarding.ritualStep1Name": "Check-in emotivo",
    "onboarding.ritualStep1Desc": "Come ti senti oggi?",
    "onboarding.ritualStep2Name": "Ricetta del giorno",
    "onboarding.ritualStep2Desc": "Una ricetta di matcha personalizzata",
    "onboarding.ritualStep3Name": "Meditazione",
    "onboarding.ritualStep3Desc": "Un momento di calma e mindfulness",
    "onboarding.ritualStep4Name": "Matcha",
    "onboarding.ritualStep4Desc": "Registra il tuo momento matcha del giorno",
    "onboarding.ritualStep5Name": "Diario",
    "onboarding.ritualStep5Desc": "Rifletti sulla tua giornata",
    "onboarding.pointsTitle": "Matcha Points ⭐",
    "onboarding.pointsDesc": "Guadagna punti completando il rituale, con acquisti, referral e serie. Riscattali per premi esclusivi che non trovi in negozio.",
    "onboarding.streaksTitle": "Serie 🔥",
    "onboarding.streaksDesc": "Ogni giorno che completi il check-in matcha, la tua serie cresce. Raggiungi traguardi (5, 10, 30 giorni) per punti bonus. Se salti un giorno, torna a zero!",
    "onboarding.letsGoTitle": "Si parte!",
    "onboarding.letsGoDesc": "Collega la tua email per sincronizzare ordini, punti e sbloccare l'esperienza completa. Oppure esplora prima.",
    "linkAccount.title": "Collega il tuo account",
    "linkAccount.subtitle": "Inserisci la tua email e ti invieremo un link magico per collegare il tuo dispositivo.",
    "linkAccount.sendMagicLink": "Invia link magico",
    "linkAccount.enterCode": "Inserisci il codice",
    "linkAccount.codeSent": "Abbiamo inviato un codice di 6 cifre a",
    "linkAccount.verifyCode": "Verifica codice",
    "linkAccount.resendCode": "Rinvia codice",
    "linkAccount.accountLinked": "Account collegato",
    "linkAccount.deviceLinked": "Il tuo dispositivo è collegato a",
    "linkAccount.backToProfile": "Torna al profilo",
    "linkAccount.sendError": "Errore nell'invio del link",
    "linkAccount.codeError": "Codice non valido",
    "linkAccount.haveReferralCode": "Ho il codice di un amico",
    "linkAccount.validateEmail": "Convalida email",
    "completeProfile.title": "Completa il tuo profilo",
    "completeProfile.subtitle": "Per personalizzare la tua esperienza abbiamo bisogno di alcuni dati",
    "completeProfile.firstName": "Nome",
    "completeProfile.lastName": "Cognome",
    "completeProfile.phone": "Telefono",
    "completeProfile.save": "Salva profilo",
    "completeProfile.error": "Errore nel completamento del profilo",
    "completeProfile.firstNamePlaceholder": "Nome",
    "completeProfile.lastNamePlaceholder": "Cognome",
    "suggestedProducts.title": "Potrebbe piacerti anche",
    "suggestedProducts.add": "Aggiungi"
  },
  "pt": {
    "tabs.home": "Início",
    "tabs.ritual": "Ritual",
    "tabs.shop": "Loja",
    "tabs.garden": "Jardim",
    "tabs.rewards": "Prémios",
    "common.back": "Voltar",
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.delete": "Eliminar",
    "common.retry": "Tentar novamente",
    "common.close": "Fechar",
    "common.confirm": "Confirmar",
    "common.loading": "A carregar...",
    "common.error": "Erro",
    "common.ok": "OK",
    "common.seeAll": "Ver todas →",
    "common.days": "dias",
    "common.day": "dia",
    "common.points": "pontos",
    "common.pts": "pts",
    "common.noResults": "Sem resultados",
    "date.sunday": "Domingo",
    "date.monday": "Segunda-feira",
    "date.tuesday": "Terça-feira",
    "date.wednesday": "Quarta-feira",
    "date.thursday": "Quinta-feira",
    "date.friday": "Sexta-feira",
    "date.saturday": "Sábado",
    "date.january": "janeiro",
    "date.february": "fevereiro",
    "date.march": "março",
    "date.april": "abril",
    "date.may": "maio",
    "date.june": "junho",
    "date.july": "julho",
    "date.august": "agosto",
    "date.september": "setembro",
    "date.october": "outubro",
    "date.november": "novembro",
    "date.december": "dezembro",
    "date.dateFormat": "{{day}}, {{date}} de {{month}}",
    "home.reorderTitle": "Repetir o meu último pedido",
    "home.reorderSubtitle": "Pede novamente com um clique",
    "home.reorderBtn": "Pedir",
    "home.oneClickTitle": "Repetir pedido",
    "home.oneClickBtn": "Pedir",
    "home.oneClickConfirmTitle": "Repetir pedido?",
    "home.oneClickConfirmTotal": "Total: {{total}} €",
    "home.oneClickConfirmCard": "Cartão ····{{digits}}",
    "home.oneClickConfirmBtn": "Confirmar",
    "home.oneClickSuccess": "Pedido realizado! Receberá um email de confirmação.",
    "home.streakDays": "🔥 {{count}} dias de sequência",
    "home.wildcardAvailable": "🛡️ 1 dia de graça disponível",
    "home.nextMilestone": "⭐ {{days}}d → +{{points}}pts",
    "home.treesCount_one": "🌳 {{count}} árvore no teu jardim",
    "home.treesCount_other": "🌳 {{count}} árvores no teu jardim",
    "home.yourRitualToday": "O teu ritual de hoje",
    "home.savedRecipes": "As minhas receitas guardadas",
    "home.matchaFinished": "O teu matcha acabou",
    "home.matchaRunningOut": "O teu matcha acaba em ~{{days}} dias",
    "home.dontLoseStreak": "Não percas a tua sequência!",
    "home.oneClick": "1 clique",
    "home.restock": "Repor",
    "home.orderInProgress": "Pedido em curso",
    "home.lastOrder": "O teu último pedido",
    "home.seeAllOrders": "Ver todos os meus pedidos →",
    "home.dailyRitual": "O teu ritual diário",
    "home.nextStep": "PRÓXIMO PASSO",
    "home.ritualBonus": "Completa os 5 hoje e ganha +5 pts bónus",
    "home.ritualCta.start": "Começar o meu ritual →",
    "home.ritualCta.continue": "Continuar ritual →",
    "home.ritualCta.completed": "Ver resumo →",
    "home.linkAccount": "Vincula a tua conta",
    "home.linkAccountDesc": "Sincroniza os teus pedidos e pontos vinculando o teu email",
    "home.stat.streakLabel": "DIAS\nSEGUIDOS",
    "home.stat.pointsLabel": "PONTOS\nGANHOS",
    "home.stat.levelLabel": "NÍVEL\nATUAL",
    "home.statModal.streakTitle": "Dias seguidos",
    "home.statModal.streakBody": "A tua série conta os dias consecutivos em que completas pelo menos um passo do teu ritual diário.\n\nManter a série desbloqueia bónus de pontos nos marcos de 7, 14 e 30 dias.\n\nSe falhares um dia, tens um dia de graça que protege a tua série.",
    "home.statModal.pointsTitle": "Pontos ganhos",
    "home.statModal.pointsBody": "Os pontos são a tua moeda na Matcha & CO. Ganha-os completando o teu ritual diário, inquéritos e outras atividades.\n\nTroca-os por recompensas exclusivas como produtos grátis, descontos e presentes especiais.\n\nEste contador mostra os teus pontos disponíveis.",
    "home.statModal.levelTitle": "Nível atual",
    "home.statModal.levelIntro": "O teu nível reflete o teu compromisso acumulado com a Matcha & CO. Sobe de nível ganhando pontos.",
    "home.statModal.levelNeverDrops": "Ao contrário dos pontos resgatáveis, o teu nível nunca desce.",
    "home.greetingMorning": "BOM DIA",
    "home.greetingAfternoon": "BOA TARDE",
    "home.greetingEvening": "BOA NOITE",
    "home.greetingFallback": "Olá!",
    "home.today": "HOJE",
    "home.understood": "Entendido",
    "home.rewardsTitle": "RECOMPENSAS",
    "home.rewardsSubtitle": "Presentes exclusivos",
    "home.seeAllRewards": "Ver todos os presentes  →",
    "home.recipeOfDay": "RECEITA DO DIA",
    "home.motivational_0": "Cada chávena é um passo para o teu bem-estar 🍵",
    "home.motivational_1": "O teu corpo agradece 🌿",
    "home.motivational_2": "Um pequeno ritual, uma mudança enorme ✨",
    "home.motivational_3": "Hoje escolheste cuidar de ti 💚",
    "home.motivational_4": "A tua constância é o teu superpoder 🌱",
    "home.motivational_5": "Respira, bebe, sorri. Repete amanhã ☀️",
    "home.greetingHello": "Olá, {{name}}!",
    "home.paymentBannerTitle": "Adicione o seu cartão e compre com um clique",
    "home.paymentBannerSubtitle": "Guarde o seu método de pagamento para facilitar a próxima encomenda e ganhe {{points}} pontos.",
    "home.paymentBannerBtn": "Adicionar",
    "home.paymentMethodBonusSuccess": "Ganhou {{points}} pontos por adicionar o seu método de pagamento!",
    "ritual.emotionalCheckin": "Check-in emocional",
    "ritual.recommendedRecipe": "Receita recomendada",
    "ritual.meditation": "Meditação",
    "ritual.registerMatcha": "Registar matcha",
    "ritual.journaling": "Journaling",
    "ritual.howDoYouFeel": "Como te sentes hoje?",
    "ritual.chooseMood": "Escolhe a emoção que melhor te representa",
    "ritual.whatRecipe": "Que tipo de receita te apetece?",
    "ritual.yourState": "O teu estado: {{emoji}} {{label}}",
    "ritual.illusion": "Ilusão",
    "ritual.calm": "Calma",
    "ritual.apathy": "Apatia",
    "ritual.anxiety": "Ansiedade",
    "ritual.sadness": "Tristeza",
    "ritual.allCategories": "Todas",
    "ritual.drinks": "Bebidas",
    "ritual.breakfast": "Pequeno-almoço",
    "ritual.desserts": "Sobremesas",
    "ritual.mains": "Principais",
    "ritual.snacks": "Snacks",
    "ritual.doCheckinFirst": "Faz o teu check-in emocional primeiro para podermos recomendar-te a receita perfeita.",
    "ritual.doCheckinBtn": "Fazer check-in emocional 🫶",
    "ritual.noRecipes": "Sem receitas disponíveis",
    "ritual.noRecipesDesc": "Não há receitas para este filtro. Experimenta outra categoria!",
    "ritual.completeAnyway": "Completar mesmo assim ✓",
    "ritual.basedOnState": "Baseada no teu estado: {{mood}}",
    "ritual.servings": "{{count}} porções",
    "ritual.ingredients": "Ingredientes:",
    "ritual.preparation": "Preparação:",
    "ritual.complete": "Completar ✓",
    "ritual.guidedMeditation": "Meditação guiada",
    "ritual.minutesSingular": "{{count}} minuto",
    "ritual.minutesPlural": "{{count}} minutos",
    "ritual.startMeditation": "▶  Iniciar meditação",
    "ritual.meditating": "A meditar... 🧘",
    "ritual.skip": "Saltar →",
    "ritual.alreadyDrankMatcha": "Já tomei o meu matcha",
    "ritual.whatMatchaToday": "Que matcha tomaste hoje?",
    "ritual.selectMatchaType": "Seleciona o tipo de matcha",
    "ritual.matchaType_solo": "Matcha puro",
    "ritual.matchaType_latte": "Matcha com leite",
    "ritual.matchaType_protein": "Matcha proteína",
    "ritual.matchaType_collagen": "Matcha colagénio",
    "ritual.matchaType_creatine": "Matcha creatina",
    "ritual.matchaType_golden_milk": "Golden milk",
    "ritual.matchaType_iced": "Matcha frio",
    "ritual.matchaType_recipe": "Em receita",
    "ritual.matchaType_other": "Outros",
    "ritual.streakLabel": "🔥 Sequência: {{count}} dias",
    "ritual.plantEvolved": "🌱 A tua planta evoluiu!",
    "ritual.newTree": "🌳 Completaste uma árvore!",
    "ritual.journalingTitle": "Journaling 📝",
    "ritual.writeHere": "Escreve aqui...",
    "ritual.ritualComplete": "🎉 Ritual completo!",
    "ritual.yourRitualToday": "O teu ritual de hoje",
    "ritual.bonusPoints": "+5 pts bónus. A tua planta agradece 🌱",
    "ritual.completed": "✓ Completado",
    "ritual.completeFiveSteps": "✨ Completa os 5 passos para ganhar +5 pts bónus",
    "ritual.journalPrompt1": "Qual foi o melhor de hoje?",
    "ritual.journalPrompt2": "O que agradeces hoje?",
    "ritual.journalPrompt3": "Como queres sentir-te amanhã?",
    "ritual.journalPrompt4": "O que te fez sorrir?",
    "ritual.meditationSubtitle_illusion": "Potencia essa ilusão com gratidão e visualização",
    "ritual.meditationSubtitle_calm": "Aprofunda a tua calma com respiração consciente",
    "ritual.meditationSubtitle_apathy": "Recupera a tua energia e reconecta-te contigo",
    "ritual.meditationSubtitle_anxiety": "Liberta a tensão e encontra o teu centro",
    "ritual.meditationSubtitle_sadness": "Abraça as tuas emoções com compaixão e carinho",
    "ritual.moodLabel_illusion": "ilusão",
    "ritual.moodLabel_calm": "calma",
    "ritual.moodLabel_apathy": "apatia",
    "ritual.moodLabel_anxiety": "ansiedade",
    "ritual.moodLabel_sadness": "tristeza",
    "ritual.checkin": "Check-in",
    "ritual.recipe": "Receita",
    "ritual.meditate": "Meditar",
    "ritual.matcha": "Matcha",
    "ritual.journal": "Journal",
    "shop.topSellers": "Mais vendidos",
    "shop.buy": "+ Adicionar",
    "shop.all": "Tudo",
    "shop.couldNotLoadProducts": "Não foi possível carregar os produtos",
    "shop.noProductsInCategory": "Sem produtos nesta categoria",
    "cart.title": "Carrinho ({{count}})",
    "cart.myCart": "O meu cesto ({{count}})",
    "cart.myCartLabel": "O meu cesto",
    "cart.viewCartLabel": "Ver o meu cesto",
    "cart.empty": "Esvaziar",
    "cart.emptyCart": "Esvaziar carrinho",
    "cart.emptyCartConfirm": "Tens a certeza?",
    "cart.cartIsEmpty": "O teu carrinho está vazio",
    "cart.exploreShop": "Explora a loja e adiciona produtos",
    "cart.addFromShop": "Adiciona produtos da loja",
    "cart.goToShop": "Ir para a loja",
    "cart.total": "Total",
    "cart.checkout": "Finalizar compra",
    "cart.checkoutError": "Não foi possível criar o pedido. Tenta novamente.",
    "cart.freeShipping": "Envio grátis",
    "cart.subtotal": "Subtotal",
    "cart.shipping": "Envio",
    "cart.free": "Grátis",
    "cart.freeShippingAt": "Envio grátis a partir de {{amount}}",
    "cart.remove": "Remover",
    "cart.removeConfirm": "Remover \"{{title}}\" do carrinho?",
    "cart.clear": "Limpar carrinho",
    "cart.clearConfirm": "Tem certeza?",
    "cart.clearBtn": "Limpar",
    "cart.emptyDesc": "Explora a loja e adiciona produtos",
    "cart.earnPoints": "⭐ Ganharás {{points}} pontos com esta compra",
    "cart.shippingAtCheckout": "Calculado no checkout",
    "offers.addMore": "Adiciona <bold>{{amount}}€</bold> mais para um <bold>desconto de {{percent}}%</bold>",
    "offers.maxUnlocked": "<bold>Desconto máximo desbloqueado!</bold> 🎉",
    "garden.dayLabel": "Dia {{day}}",
    "garden.daysToNext": "{{days}} dias para {{name}}",
    "garden.treeComplete": "Árvore completa! 🎉",
    "garden.consecutiveDays": "Dias seguidos",
    "garden.totalWaterings": "Regas totais",
    "garden.currentLevel": "Nível atual",
    "garden.consecutiveDaysHelp": "A tua sequência atual de dias consecutivos de check-in de matcha. Se falhares um dia, volta a zero!",
    "garden.totalWateringsHelp": "O número total de dias em que fizeste o check-in de matcha. Cada check-in rega a tua planta e ajuda-a a crescer.",
    "garden.currentLevelHelp": "O nível da tua planta. Cresce à medida que acumulas dias de check-in consecutivos. Ao atingir o nível máximo, transforma-se numa árvore para o teu jardim.",
    "garden.understood": "Entendido",
    "garden.badgesTitle": "Medalhas e conquistas",
    "garden.badge_primer_brote": "Primeiro Broto",
    "garden.badge_racha_5": "Sequência de 5",
    "garden.badge_racha_10": "Sequência de 10",
    "garden.badge_racha_30": "Sequência de 30",
    "garden.badge_primer_arbol": "Primeira Árvore",
    "garden.badgeDesc_primer_brote": "Primeiro check-in",
    "garden.badgeDesc_racha_5": "5 dias consecutivos",
    "garden.badgeDesc_racha_10": "10 dias consecutivos",
    "garden.badgeDesc_racha_30": "30 dias consecutivos",
    "garden.badgeDesc_primer_arbol": "30 dias completados",
    "rewards.yourPoints": "Os teus pontos",
    "rewards.level": "Nível: {{current}}",
    "rewards.levelNext": "{{current}} → {{next}}",
    "rewards.availableRewards": "Prémios disponíveis",
    "rewards.exclusiveApp": "Exclusivos da app — não disponíveis na loja",
    "rewards.comingSoon": "Em breve",
    "rewards.comingSoonDesc": "Estamos a preparar prémios exclusivos para ti. Continua a acumular pontos!",
    "rewards.merchandise": "Merchandising",
    "rewards.exclusiveProduct": "Produto exclusivo",
    "rewards.experience": "Experiência",
    "rewards.outOfStock": "Esgotado",
    "rewards.redeem": "Resgatar",
    "rewards.missingPoints": "Faltam {{count}} pts",
    "rewards.linkAccountForRewards": "Precisas de vincular o teu email para resgatar prémios.",
    "rewards.insufficientPoints": "Pontos insuficientes",
    "rewards.insufficientPointsDesc": "Faltam-te {{count}} pontos para resgatar \"{{name}}\". Continua com o teu ritual diário!",
    "rewards.redeemConfirm": "Resgatar prémio",
    "rewards.redeemConfirmDesc": "Queres resgatar \"{{name}}\" por {{points}} pontos?",
    "rewards.redeemed": "Prémio resgatado! 🎉",
    "rewards.redeemedDesc": "Receberás mais informações por email.",
    "rewards.redeemError": "Erro ao resgatar",
    "rewards.myRedemptions": "Os meus resgates",
    "rewards.statusPending": "⏳ Pendente",
    "rewards.statusProcessing": "📦 A preparar",
    "rewards.statusShipped": "🚚 Enviado",
    "rewards.statusDelivered": "✅ Entregue",
    "rewards.howItWorks": "Como funciona?",
    "rewards.howStep1": "Completa o teu ritual diário para ganhar pontos",
    "rewards.howStep2": "Acumula pontos com sequências, compras e referências",
    "rewards.howStep3": "Resgata os teus pontos por prémios exclusivos",
    "rewards.morePointsNeeded": "{{count}} pts mais para {{level}}",
    "rewards.rewardsTitle": "Recompensas",
    "rewards.pointsAvailable": "pontos disponíveis",
    "rewards.howToEarnPoints": "Como ganhar pontos?",
    "rewards.earn_purchases": "Compras: +1 pt por cada 1€ gasto",
    "rewards.earn_ritualStep": "Cada passo do Ritual diário: +1 pt",
    "rewards.earn_ritualComplete": "Completar o Ritual diário: +5 pts bónus",
    "rewards.earn_referralRegister": "Convidar amigos: +50 pts por registo",
    "rewards.earn_referralPurchase": "Compra do seu convidado: +150 pts",
    "rewards.earn_survey": "Completar inquéritos: pontos variáveis",
    "rewards.earn_review": "Escrever uma opinião da sua compra: +50 pts",
    "orders.myOrders": "Os meus pedidos",
    "orders.processing": "A processar",
    "orders.delivered": "Entregue",
    "orders.inTransit": "Em trânsito",
    "orders.shipped": "Enviado",
    "orders.partiallySent": "Parcialmente enviado",
    "orders.inPreparation": "Em preparação",
    "orders.cancelled": "Cancelado",
    "orders.login": "Iniciar sessão",
    "orders.loginDesc": "Vincula a tua conta para ver os teus pedidos",
    "orders.linkAccount": "Vincular conta",
    "orders.loadingOrders": "A carregar pedidos...",
    "orders.loadError": "Erro ao carregar",
    "orders.noOrders": "Sem pedidos",
    "orders.noOrdersDesc": "Ainda não realizaste nenhum pedido",
    "orders.goToShop": "Ir para a loja",
    "orders.viewDetail": "Ver detalhe",
    "orders.loadMore": "Carregar mais pedidos",
    "orders.exception": "Incidência",
    "orders.outForDelivery": "Em entrega",
    "orders.returned": "Devolvido",
    "orders.refunded": "Reembolsado",
    "surveys.title": "Novidades",
    "surveys.subtitle": "Descobre as últimas novidades, inquéritos e conteúdos exclusivos",
    "surveys.noSurveys": "Sem novidades disponíveis",
    "surveys.noSurveysDesc": "Avisamos-te quando houver novidades. Continua com o teu ritual diário!",
    "surveys.question": "Pergunta {{number}}",
    "surveys.required": "Obrigatória",
    "surveys.answered": "{{answered}} de {{total}} respondidas",
    "surveys.writeAnswer": "Escreve a tua resposta...",
    "surveys.completeSurvey": "Completar inquérito",
    "surveys.thanks": "Obrigado!",
    "surveys.pointsEarned": "Ganhaste ⭐ {{points}} pontos",
    "surveys.answersHelp": "As tuas respostas ajudam-nos a melhorar a tua experiência matcha 🍵",
    "surveys.surveyNotFound": "Inquérito não encontrado",
    "surveys.loadError": "Não foi possível carregar o inquérito.",
    "surveys.submitError": "Erro ao enviar o inquérito",
    "surveys.questions_one": "{{count}} pergunta",
    "surveys.questions_other": "{{count}} perguntas",
    "surveys.survey": "Questionário",
    "profile.myProfile": "O meu perfil",
    "profile.matchaPoints": "⭐ {{count}} Matcha Points",
    "profile.orders": "Pedidos",
    "profile.points": "Pontos",
    "profile.streak": "Sequência",
    "profile.badges": "Medalhas",
    "profile.shippingAddress": "Morada de envio",
    "profile.edit": "Editar",
    "profile.add": "Adicionar",
    "profile.firstName": "Nome",
    "profile.lastName": "Apelidos",
    "profile.phone": "Telefone",
    "profile.address": "Morada",
    "profile.addressPlaceholder": "Rua, número, andar...",
    "profile.addressLine2": "Morada (linha 2)",
    "profile.optional": "Opcional",
    "profile.city": "Cidade",
    "profile.zip": "Código postal",
    "profile.province": "Distrito",
    "profile.country": "País",
    "profile.invalidPhone": "Número de telefone inválido",
    "profile.addressUpdated": "Morada atualizada",
    "profile.addressSaved": "A tua morada de envio foi guardada com sucesso.",
    "profile.saveError": "Erro ao guardar a morada",
    "profile.saving": "A guardar...",
    "profile.saveAddress": "Guardar morada",
    "profile.addShippingAddress": "Adicionar morada de envio",
    "profile.inviteFriend": "Convida um amigo",
    "profile.inviteReward": "Ganha 100 pts por cada amigo que comprar",
    "profile.shareLink": "Partilhar link",
    "profile.shareMessage": "Experimenta Matcha & CO! Usa o meu código para obter um desconto na tua primeira encomenda. https://matchaandco.com",
    "profile.notifications": "Notificações",
    "profile.myOrdersMenu": "Os meus pedidos",
    "profile.quickReorder": "Recompra rápida",
    "profile.helpSupport": "Ajuda e suporte",
    "profile.terms": "Termos e condições",
    "profile.signOut": "Terminar sessão",
    "profile.signOutConfirm": "Tens a certeza?",
    "profile.language": "Idioma",
    "profile.selectLanguage": "Seleciona o teu idioma",
    "profile.selectProvince": "Selecionar província",
    "profile.searchProvince": "Pesquisar província...",
    "profile.selectCountry": "Selecionar país",
    "profile.referralCodeTitle": "Código de referência",
    "profile.referralCodePlaceholder": "Introduz o teu código",
    "profile.referralCodeHint": "Tens um código de referência? Introduz para ganhar pontos extra",
    "profile.applyCode": "Aplicar código",
    "profile.referralApplied": "Código aplicado com sucesso",
    "profile.referralConverted": "Referência convertida",
    "profile.referralError": "Código inválido",
    "profile.referralAlready": "Já aplicaste um código de referência",
    "profile.referralSelf": "Não podes usar o teu próprio código",
    "profile.referralNotFound": "Código não encontrado",
    "profile.referralExpired": "Este código expirou",
    "profile.referralInvited": "Convidados",
    "profile.referralPointsEarned": "Pts ganhos",
    "profile.shareMessageWithLink": "Experimenta Matcha & CO! Descarrega a app e ganha 25 pontos de boas-vindas 🍵 {{link}}",
    "profile.yourReferralCode": "O teu código de referência",
    "profile.paymentMethod": "Método de pagamento",
    "profile.paymentMethodHint": "Guarde o seu método de pagamento para comprar com um clique",
    "profile.paymentMethodUpdated": "Método de pagamento atualizado",
    "profile.paymentMethodUpdatedDesc": "O seu método de pagamento foi salvo com sucesso.",
    "auth.linkAccount": "Vincular a tua conta",
    "orderStatus.processing": "A processar",
    "orderStatus.delivered": "Entregue",
    "orderStatus.inTransit": "Em trânsito",
    "orderStatus.shipped": "Enviado",
    "orderStatus.partiallySent": "Parcialmente enviado",
    "language.es": "Español",
    "language.en": "English",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.it": "Italiano",
    "language.nl": "Nederlands",
    "language.de": "Deutsch",
    "language.pl": "Polski",
    "product.notFound": "Produto não encontrado",
    "product.back": "Voltar",
    "product.variant": "Variante",
    "product.quantity": "Quantidade",
    "product.description": "Descrição",
    "product.addToCart": "Adicionar ao carrinho",
    "product.addedToCart": "Adicionado ao carrinho",
    "product.continueShopping": "Continuar comprando",
    "product.viewCart": "Ver carrinho",
    "product.unit_one": "unidade",
    "product.unit_other": "unidades",
    "product.ingredients": "Ingredientes",
    "checkout.confirmOrder": "Confirmar pedido",
    "checkout.cartEmpty": "O teu carrinho está vazio",
    "checkout.products": "Produtos",
    "checkout.shippingAddress": "Morada de envio",
    "checkout.changeAddress": "Alterar morada",
    "checkout.addAddress": "Adicionar morada",
    "checkout.couldNotLoadAddress": "Não foi possível carregar a morada",
    "checkout.paymentMethod": "Método de pagamento",
    "checkout.changePayment": "Alterar método de pagamento",
    "checkout.useStandardCheckout": "Usar checkout padrão",
    "checkout.couldNotLoadPayment": "Não foi possível carregar o método de pagamento",
    "checkout.noPaymentMethod": "Nenhum método de pagamento salvo",
    "checkout.addPaymentMethod": "Adicionar cartão",
    "checkout.subtotal": "Subtotal",
    "checkout.shipping": "Envio",
    "checkout.tax": "Impostos",
    "checkout.free": "Grátis",
    "checkout.total": "Total",
    "checkout.securePayment": "Pagamento seguro",
    "checkout.placeOrder": "Finalizar pedido",
    "checkout.quantity": "Quantidade: {{count}}",
    "checkout.requiredFields": "Campos obrigatórios",
    "checkout.requiredFieldsDesc": "Preenche pelo menos nome, morada, cidade e código postal.",
    "checkout.addressError": "Não foi possível atualizar a morada. Tenta novamente.",
    "checkout.orderSuccess": "Pedido realizado! 🎉",
    "checkout.orderSuccessDesc": "O teu pedido foi processado. Receberás um email de confirmação.",
    "checkout.orderSuccessBtn": "Perfeito",
    "checkout.orderError": "Não foi possível processar o pedido. Tenta novamente.",
    "checkout.unexpectedError": "Ocorreu um erro inesperado. Tenta novamente.",
    "checkout.checkoutError": "Não foi possível criar o pedido. Tenta novamente.",
    "checkout.card": "Cartão",
    "checkout.freeShipping": "Envio grátis",
    "checkout.freeShippingAt": "Envio grátis a partir de {{amount}}",
    "checkout.firstName": "Nome *",
    "checkout.lastName": "Apelido *",
    "checkout.phone": "Telefone *",
    "checkout.address": "Morada *",
    "checkout.floor": "Andar / Porta",
    "checkout.zip": "Código postal *",
    "checkout.city": "Cidade *",
    "checkout.optional": "Opcional",
    "checkout.streetNumber": "Rua e número",
    "checkout.urlNotAvailable": "URL de checkout não disponível",
    "checkout.secureCheckout": "Checkout seguro",
    "checkout.loading": "Carregando checkout...",
    "checkout.paymentDeclined": "O pagamento foi recusado. Verifique o seu cartão e tente novamente.",
    "checkout.paymentError_INSUFFICIENT_FUNDS": "Saldo insuficiente. Verifique o saldo do seu cartão.",
    "checkout.paymentError_PAYMENT_DECLINED": "O pagamento foi recusado pelo seu banco.",
    "checkout.paymentError_INVALID_PAYMENT_METHOD": "O método de pagamento não é válido. Atualize-o no seu perfil.",
    "checkout.paymentError_EXPIRED_PAYMENT_METHOD": "O seu cartão expirou. Atualize o método de pagamento.",
    "checkout.paymentError_AUTHENTICATION_ERROR": "Autenticação necessária. Tente novamente.",
    "checkout.paymentError_PAYMENT_PROCESSING": "O pagamento está sendo processado. Aguarde alguns minutos e verifique seus pedidos.",
    "checkout.email": "Email",
    "checkout.emailPlaceholder": "seu@email.com",
    "checkout.continue": "Continuar",
    "checkout.loginForAddress": "Introduza o seu email para adicionar morada",
    "checkout.loginForPayment": "Introduza o seu email para adicionar método de pagamento",
    "checkout.emailError": "Não foi possível vincular o email. Tente novamente.",
    "checkout.verifyCode": "Verificar código",
    "checkout.invalidCode": "Código inválido ou expirado. Tente novamente.",
    "checkout.codeSent": "Código enviado para {{email}}",
    "checkout.pickupPoint": "Ponto de recolha",
    "checkout.noServicePoints": "Nenhum ponto de recolha encontrado nas proximidades",
    "reorder.repeatOrder": "Repete o teu pedido",
    "reorder.adjustQuantities": "Ajusta as quantidades se quiseres e confirma com um toque",
    "reorder.products": "Produtos",
    "reorder.shippingAddress": "Morada de envio",
    "reorder.loadingAddress": "A carregar morada...",
    "reorder.change": "Alterar",
    "reorder.add": "Adicionar",
    "reorder.total": "Total",
    "reorder.changesNote": "* Quantidades modificadas em relação ao teu último pedido",
    "reorder.repeatBtn": "Repetir pedido",
    "reorder.loadingOrder": "A carregar o teu pedido...",
    "reorder.noPreviousOrder": "Sem pedido anterior",
    "reorder.noPreviousOrderDesc": "Não foi encontrado contrato de recompra ativo. Faz o teu primeiro pedido na loja.",
    "reorder.goToShop": "Ir para a loja",
    "reorder.noProducts": "Sem produtos",
    "reorder.noProductsDesc": "Adiciona pelo menos um produto para repetir o teu pedido.",
    "reorder.orderSuccess": "Pedido realizado! 🎉",
    "reorder.orderSuccessDesc": "O teu pedido foi processado. Receberás um email de confirmação.",
    "reorder.orderSuccessBtn": "Perfeito",
    "reorder.orderError": "Não foi possível processar o pedido. Tenta novamente.",
    "reorder.unexpectedError": "Ocorreu um erro inesperado. Tenta novamente.",
    "reorder.addressError": "Não foi possível atualizar a morada.",
    "reorder.requiredFields": "Campos obrigatórios",
    "reorder.requiredFieldsDesc": "Preenche pelo menos nome, morada, cidade e código postal.",
    "reorder.product": "Produto",
    "orderDetail.order": "Pedido",
    "orderDetail.orders": "Pedidos",
    "orderDetail.loadingOrder": "A carregar pedido...",
    "orderDetail.loadError": "Erro ao carregar",
    "orderDetail.orderNotFound": "Pedido não encontrado",
    "orderDetail.retry": "Tentar novamente",
    "orderDetail.shippingStatus": "Estado do envio",
    "orderDetail.confirmed": "Pedido confirmado",
    "orderDetail.confirmedDesc": "O teu pedido foi recebido",
    "orderDetail.preparing": "Em preparação",
    "orderDetail.preparingDesc": "Estamos a preparar o teu matcha",
    "orderDetail.shipped": "Enviado",
    "orderDetail.shippedDesc": "A caminho de ti",
    "orderDetail.delivered": "Entregue",
    "orderDetail.deliveredDesc": "Desfruta do teu matcha!",
    "orderDetail.cancelled": "Cancelado",
    "orderDetail.products": "Produtos",
    "orderDetail.quantity": "Quantidade: {{count}}",
    "orderDetail.summary": "Resumo",
    "orderDetail.shippingAddress": "Morada de envio",
    "orderDetail.paymentStatus": "Estado do pagamento",
    "orderDetail.total": "Total",
    "orderDetail.repeatThisOrder": "Repetir este pedido",
    "orderDetail.repeatConfirm": "Repetir pedido",
    "orderDetail.repeatConfirmDesc": "Queres repetir este pedido de matcha?",
    "orderDetail.repeatSuccess": "Pedido realizado! 🎉",
    "orderDetail.repeatSuccessDesc": "O teu matcha está a caminho.",
    "orderDetail.repeatError": "Não foi possível processar a recompra",
    "orderDetail.needHelp": "Precisas de ajuda?",
    "orderDetail.needHelpDesc": "Contacta o suporte se tiveres alguma questão sobre o teu pedido",
    "orderDetail.contactSupport": "Contactar suporte",
    "orderDetail.inTransit": "Em trânsito",
    "orderDetail.outForDelivery": "Em entrega",
    "orderDetail.outForDeliveryDesc": "O teu pedido chega hoje!",
    "orderDetail.exception": "Incidência",
    "orderDetail.exceptionDesc": "Houve uma incidência com o teu envio",
    "orderDetail.returned": "Devolvido",
    "orderDetail.returnedDesc": "O teu pacote foi devolvido ao remetente",
    "orderDetail.inTransitDesc": "O teu pedido está em trânsito",
    "orderDetail.trackShipment": "Rastrear envio",
    "orderDetail.trackingEvents": "Histórico de envio",
    "redeem.rewardNotFound": "Presente não encontrado",
    "redeem.couldNotLoadReward": "Não foi possível carregar o presente.",
    "redeem.rewardRedeemed": "Presente resgatado!",
    "redeem.experienceInfo": "Receberás mais informações por email.",
    "redeem.physicalInfo": "Enviaremos para a tua morada em breve.",
    "redeem.pointsSpent": "−{{cost}} pontos • Saldo: ⭐ {{balance}}",
    "redeem.backToRewards": "Voltar aos presentes",
    "redeem.cost": "Custo",
    "redeem.yourBalance": "O teu saldo",
    "redeem.missingPoints": "Faltam-te {{count}} pontos",
    "redeem.addressNeeded": "Morada necessária",
    "redeem.addressNeededDesc": "Adiciona uma morada de envio para receberes o teu presente.",
    "redeem.noAddressSaved": "Não tens morada guardada",
    "redeem.addAddress": "Adicionar morada",
    "redeem.changeAddress": "Alterar morada",
    "redeem.confirmRedeem": "Confirmar resgate",
    "redeem.redeemError": "Erro ao resgatar o presente",
    "redeem.insufficientPoints": "Pontos insuficientes",
    "redeem.insufficientPointsDesc": "Faltam-te {{count}} pontos para resgatar \"{{name}}\".",
    "savedRecipes.title": "As minhas receitas guardadas",
    "savedRecipes.deleteRecipe": "Eliminar receita",
    "savedRecipes.deleteConfirm": "Queres remover esta receita das tuas guardadas?",
    "savedRecipes.noRecipes": "Sem receitas guardadas",
    "savedRecipes.noRecipesDesc": "Guarda as receitas de que gostas durante o teu ritual diário para as encontrares aqui.",
    "recipeDetail.notFound": "Receita não encontrada",
    "recipeDetail.ingredients": "Ingredientes",
    "recipeDetail.preparation": "Preparação",
    "recipeDetail.servings": "{{count}} porções",
    "recipeDetail.viewSource": "Ver em matchaandco.com",
    "notifications.title": "Notificações",
    "notifications.profile": "Perfil",
    "notifications.disabled": "Notificações desativadas",
    "notifications.disabledDesc": "Ativa as notificações para não perderes o teu ritual diário",
    "notifications.enable": "Ativar notificações",
    "notifications.enabled": "Pronto!",
    "notifications.enabledDesc": "As notificações estão ativadas",
    "notifications.permissionsNeeded": "Permissões necessárias",
    "notifications.permissionsNeededDesc": "Para receberes notificações, ativa-as nas definições do teu dispositivo.",
    "notifications.couldNotLoad": "Não foi possível carregar as preferências",
    "notifications.couldNotSave": "Não foi possível guardar a preferência",
    "notifications.saving": "A guardar...",
    "notifications.quietHours": "Horário silencioso",
    "notifications.quietHoursDesc": "Não receberás notificações entre as {{start}} e as {{end}}",
    "notifications.dailyReminder": "Lembrete diário",
    "notifications.dailyReminderDesc": "Lembramos-te do teu ritual matinal",
    "notifications.streakWarning": "Alerta de sequência",
    "notifications.streakWarningDesc": "Aviso antes de perderes a tua sequência",
    "notifications.orderStatus": "Estado dos pedidos",
    "notifications.orderStatusDesc": "Atualizações de envio e entrega",
    "notifications.restockReminder": "Lembrete de restock",
    "notifications.restockReminderDesc": "Quando o teu matcha estiver a acabar",
    "notifications.rewardsAvailable": "Recompensas disponíveis",
    "notifications.rewardsAvailableDesc": "Quando puderes trocar pontos",
    "notifications.contentNew": "Conteúdo novo",
    "notifications.contentNewDesc": "Novas receitas e meditações",
    "notifications.announcements": "Comunicados",
    "notifications.announcementsDesc": "Novidades da Matcha & CO",
    "notifications.subscriptionInfo": "Info de subscrição",
    "notifications.subscriptionInfoDesc": "Renovações e alterações",
    "onboarding.skip": "Saltar",
    "onboarding.next": "Seguinte →",
    "onboarding.linkAccount": "Vincular conta",
    "onboarding.exploreWithoutAccount": "Explorar sem conta",
    "onboarding.welcomeTitle": "Bem-vindo ao Matcha & CO",
    "onboarding.welcomeDesc": "A tua loja de matcha com recompra num clique. Mas também uma ferramenta de Mindfulness para cuidares do teu bem-estar todos os dias.",
    "onboarding.ritualTitle": "O que é o Ritual?",
    "onboarding.ritualDesc": "Um exercício diário para seres mais consciente de como te sentes e incorporares bons hábitos na tua rotina.",
    "onboarding.ritualStep1Name": "Check-in emocional",
    "onboarding.ritualStep1Desc": "Como te sentes hoje?",
    "onboarding.ritualStep2Name": "Receita do dia",
    "onboarding.ritualStep2Desc": "Uma receita de matcha personalizada",
    "onboarding.ritualStep3Name": "Meditação",
    "onboarding.ritualStep3Desc": "Um momento de calma e mindfulness",
    "onboarding.ritualStep4Name": "Matcha",
    "onboarding.ritualStep4Desc": "Regista o teu momento matcha do dia",
    "onboarding.ritualStep5Name": "Diário",
    "onboarding.ritualStep5Desc": "Reflete sobre o teu dia",
    "onboarding.pointsTitle": "Matcha Points ⭐",
    "onboarding.pointsDesc": "Ganha pontos completando o ritual, com compras, referências e sequências. Troca-os por prémios exclusivos que não encontras na loja.",
    "onboarding.streaksTitle": "Sequências 🔥",
    "onboarding.streaksDesc": "Cada dia que completares o check-in matcha, a tua sequência cresce. Atinge marcos (5, 10, 30 dias) para pontos bónus. Se falhares um dia, volta a zero!",
    "onboarding.letsGoTitle": "Vamos começar!",
    "onboarding.letsGoDesc": "Vincula o teu email para sincronizar encomendas, pontos e desbloquear a experiência completa. Ou explora primeiro.",
    "linkAccount.title": "Vincula a tua conta",
    "linkAccount.subtitle": "Introduz o teu email e enviaremos um link mágico para vincular o teu dispositivo.",
    "linkAccount.sendMagicLink": "Enviar link mágico",
    "linkAccount.enterCode": "Introduz o código",
    "linkAccount.codeSent": "Enviámos um código de 6 dígitos para",
    "linkAccount.verifyCode": "Verificar código",
    "linkAccount.resendCode": "Reenviar código",
    "linkAccount.accountLinked": "Conta vinculada",
    "linkAccount.deviceLinked": "O teu dispositivo está vinculado a",
    "linkAccount.backToProfile": "Voltar ao perfil",
    "linkAccount.sendError": "Erro ao enviar o link",
    "linkAccount.codeError": "Código inválido",
    "linkAccount.haveReferralCode": "Tenho código de um amigo",
    "linkAccount.validateEmail": "Validar email",
    "completeProfile.title": "Completa o teu perfil",
    "completeProfile.subtitle": "Para personalizar a tua experiência precisamos de alguns dados",
    "completeProfile.firstName": "Nome",
    "completeProfile.lastName": "Apelido",
    "completeProfile.phone": "Telefone",
    "completeProfile.save": "Guardar perfil",
    "completeProfile.error": "Erro ao completar o perfil",
    "completeProfile.firstNamePlaceholder": "Nome",
    "completeProfile.lastNamePlaceholder": "Apelido",
    "suggestedProducts.title": "Também te pode interessar",
    "suggestedProducts.add": "Adicionar"
  },
  "nl": {
    "tabs.home": "Home",
    "tabs.ritual": "Ritueel",
    "tabs.shop": "Winkel",
    "tabs.garden": "Tuin",
    "tabs.rewards": "Beloningen",
    "common.back": "Terug",
    "common.cancel": "Annuleren",
    "common.save": "Opslaan",
    "common.delete": "Verwijderen",
    "common.retry": "Opnieuw proberen",
    "common.close": "Sluiten",
    "common.confirm": "Bevestigen",
    "common.loading": "Laden...",
    "common.error": "Fout",
    "common.ok": "OK",
    "common.seeAll": "Alles bekijken →",
    "common.days": "dagen",
    "common.day": "dag",
    "common.points": "punten",
    "common.pts": "pts",
    "common.noResults": "Geen resultaten",
    "date.sunday": "Zondag",
    "date.monday": "Maandag",
    "date.tuesday": "Dinsdag",
    "date.wednesday": "Woensdag",
    "date.thursday": "Donderdag",
    "date.friday": "Vrijdag",
    "date.saturday": "Zaterdag",
    "date.january": "januari",
    "date.february": "februari",
    "date.march": "maart",
    "date.april": "april",
    "date.may": "mei",
    "date.june": "juni",
    "date.july": "juli",
    "date.august": "augustus",
    "date.september": "september",
    "date.october": "oktober",
    "date.november": "november",
    "date.december": "december",
    "date.dateFormat": "{{day}} {{date}} {{month}}",
    "home.reorderTitle": "Mijn laatste bestelling herhalen",
    "home.reorderSubtitle": "Bestel opnieuw met één klik",
    "home.reorderBtn": "Bestellen",
    "home.oneClickTitle": "Bestelling herhalen",
    "home.oneClickBtn": "Bestellen",
    "home.oneClickConfirmTitle": "Bestelling herhalen?",
    "home.oneClickConfirmTotal": "Total: {{total}} €",
    "home.oneClickConfirmCard": "Kaart ····{{digits}}",
    "home.oneClickConfirmBtn": "Bevestigen",
    "home.oneClickSuccess": "Bestelling geplaatst! U ontvangt een bevestigingsmail.",
    "home.streakDays": "🔥 {{count}} dagen reeks",
    "home.wildcardAvailable": "🛡️ 1 gratiedag beschikbaar",
    "home.nextMilestone": "⭐ {{days}}d → +{{points}}pts",
    "home.treesCount_one": "🌳 {{count}} boom in je tuin",
    "home.treesCount_other": "🌳 {{count}} bomen in je tuin",
    "home.yourRitualToday": "Je ritueel van vandaag",
    "home.savedRecipes": "Mijn opgeslagen recepten",
    "home.matchaFinished": "Je matcha is op",
    "home.matchaRunningOut": "Je matcha is over ~{{days}} dagen op",
    "home.dontLoseStreak": "Verlies je reeks niet!",
    "home.oneClick": "1 klik",
    "home.restock": "Aanvullen",
    "home.orderInProgress": "Bestelling onderweg",
    "home.lastOrder": "Je laatste bestelling",
    "home.seeAllOrders": "Al mijn bestellingen bekijken →",
    "home.dailyRitual": "Je dagelijkse ritueel",
    "home.nextStep": "VOLGENDE STAP",
    "home.ritualBonus": "Voltooi alle 5 vandaag en verdien +5 pts bonus",
    "home.ritualCta.start": "Mijn ritueel starten →",
    "home.ritualCta.continue": "Ritueel voortzetten →",
    "home.ritualCta.completed": "Samenvatting bekijken →",
    "home.linkAccount": "Koppel je account",
    "home.linkAccountDesc": "Synchroniseer je bestellingen en punten door je e-mail te koppelen",
    "home.stat.streakLabel": "DAGEN\nOP RIJ",
    "home.stat.pointsLabel": "PUNTEN\nVERDIEND",
    "home.stat.levelLabel": "HUIDIG\nNIVEAU",
    "home.statModal.streakTitle": "Dagen op rij",
    "home.statModal.streakBody": "Je reeks telt de opeenvolgende dagen waarop je minstens één stap van je dagelijks ritueel voltooit.\n\nJe reeks behouden ontgrendelt puntenbonussen bij 7, 14 en 30 dagen.\n\nAls je een dag mist, heb je één genadedag die je reeks beschermt.",
    "home.statModal.pointsTitle": "Verdiende punten",
    "home.statModal.pointsBody": "Punten zijn je valuta bij Matcha & CO. Verdien ze door je dagelijks ritueel, enquêtes en andere activiteiten.\n\nWissel ze in voor exclusieve beloningen zoals gratis producten, kortingen en speciale cadeaus.\n\nDeze teller toont je beschikbare punten.",
    "home.statModal.levelTitle": "Huidig niveau",
    "home.statModal.levelIntro": "Je niveau weerspiegelt je opgebouwde betrokkenheid bij Matcha & CO. Stijg van niveau door punten te verdienen.",
    "home.statModal.levelNeverDrops": "In tegenstelling tot inwisselbare punten, daalt je niveau nooit.",
    "home.greetingMorning": "GOEDEMORGEN",
    "home.greetingAfternoon": "GOEDEMIDDAG",
    "home.greetingEvening": "GOEDENAVOND",
    "home.greetingFallback": "Hallo!",
    "home.today": "VANDAAG",
    "home.understood": "Begrepen",
    "home.rewardsTitle": "BELONINGEN",
    "home.rewardsSubtitle": "Exclusieve cadeaus",
    "home.seeAllRewards": "Bekijk alle cadeaus  →",
    "home.recipeOfDay": "RECEPT VAN DE DAG",
    "home.motivational_0": "Elke kop is een stap naar je welzijn 🍵",
    "home.motivational_1": "Je lichaam is je dankbaar 🌿",
    "home.motivational_2": "Een klein ritueel, een enorme verandering ✨",
    "home.motivational_3": "Vandaag koos je voor jezelf 💚",
    "home.motivational_4": "Je volharding is je superkracht 🌱",
    "home.motivational_5": "Adem, drink, lach. Herhaal morgen ☀️",
    "home.greetingHello": "Hallo, {{name}}!",
    "home.paymentBannerTitle": "Voeg je kaart toe en koop met één klik",
    "home.paymentBannerSubtitle": "Bewaar je betaalmethode om je volgende bestelling makkelijker te maken en verdien {{points}} punten.",
    "home.paymentBannerBtn": "Toevoegen",
    "home.paymentMethodBonusSuccess": "Je hebt {{points}} punten verdiend door je betaalmethode toe te voegen!",
    "ritual.emotionalCheckin": "Emotionele check-in",
    "ritual.recommendedRecipe": "Aanbevolen recept",
    "ritual.meditation": "Meditatie",
    "ritual.registerMatcha": "Matcha registreren",
    "ritual.journaling": "Journaling",
    "ritual.howDoYouFeel": "Hoe voel je je vandaag?",
    "ritual.chooseMood": "Kies de emotie die je het best vertegenwoordigt",
    "ritual.whatRecipe": "Welk type recept heb je zin in?",
    "ritual.yourState": "Je staat: {{emoji}} {{label}}",
    "ritual.illusion": "Enthousiasme",
    "ritual.calm": "Kalm",
    "ritual.apathy": "Apathie",
    "ritual.anxiety": "Angst",
    "ritual.sadness": "Verdriet",
    "ritual.allCategories": "Alle",
    "ritual.drinks": "Dranken",
    "ritual.breakfast": "Ontbijt",
    "ritual.desserts": "Desserts",
    "ritual.mains": "Hoofdgerechten",
    "ritual.snacks": "Snacks",
    "ritual.doCheckinFirst": "Doe eerst je emotionele check-in zodat we het perfecte recept voor je kunnen aanbevelen.",
    "ritual.doCheckinBtn": "Emotionele check-in doen 🫶",
    "ritual.noRecipes": "Geen recepten beschikbaar",
    "ritual.noRecipesDesc": "Geen recepten voor dit filter. Probeer een andere categorie!",
    "ritual.completeAnyway": "Toch voltooien ✓",
    "ritual.basedOnState": "Gebaseerd op je staat: {{mood}}",
    "ritual.servings": "{{count}} porties",
    "ritual.ingredients": "Ingrediënten:",
    "ritual.preparation": "Bereiding:",
    "ritual.complete": "Voltooien ✓",
    "ritual.guidedMeditation": "Begeleide meditatie",
    "ritual.minutesSingular": "{{count}} minuut",
    "ritual.minutesPlural": "{{count}} minuten",
    "ritual.startMeditation": "▶  Meditatie starten",
    "ritual.meditating": "Mediteren... 🧘",
    "ritual.skip": "Overslaan →",
    "ritual.alreadyDrankMatcha": "Ik heb mijn matcha al gedronken",
    "ritual.whatMatchaToday": "Welke matcha heb je vandaag gehad?",
    "ritual.selectMatchaType": "Selecteer je matcha type",
    "ritual.matchaType_solo": "Pure matcha",
    "ritual.matchaType_latte": "Matcha latte",
    "ritual.matchaType_protein": "Matcha proteïne",
    "ritual.matchaType_collagen": "Matcha collageen",
    "ritual.matchaType_creatine": "Matcha creatine",
    "ritual.matchaType_golden_milk": "Golden milk",
    "ritual.matchaType_iced": "Ijsmatcha",
    "ritual.matchaType_recipe": "In recept",
    "ritual.matchaType_other": "Anders",
    "ritual.streakLabel": "🔥 Reeks: {{count}} dagen",
    "ritual.plantEvolved": "🌱 Je plant is geëvolueerd!",
    "ritual.newTree": "🌳 Je hebt een boom voltooid!",
    "ritual.journalingTitle": "Journaling 📝",
    "ritual.writeHere": "Schrijf hier...",
    "ritual.ritualComplete": "🎉 Ritueel voltooid!",
    "ritual.yourRitualToday": "Je ritueel van vandaag",
    "ritual.bonusPoints": "+5 pts bonus. Je plant dankt je 🌱",
    "ritual.completed": "✓ Voltooid",
    "ritual.completeFiveSteps": "✨ Voltooi alle 5 stappen voor +5 pts bonus",
    "ritual.journalPrompt1": "Wat was het beste van vandaag?",
    "ritual.journalPrompt2": "Waar ben je dankbaar voor vandaag?",
    "ritual.journalPrompt3": "Hoe wil je je morgen voelen?",
    "ritual.journalPrompt4": "Wat deed je glimlachen?",
    "ritual.meditationSubtitle_illusion": "Versterk dat enthousiasme met dankbaarheid en visualisatie",
    "ritual.meditationSubtitle_calm": "Verdiep je kalmte met bewuste ademhaling",
    "ritual.meditationSubtitle_apathy": "Herstel je energie en verbind je opnieuw met jezelf",
    "ritual.meditationSubtitle_anxiety": "Laat de spanning los en vind je centrum",
    "ritual.meditationSubtitle_sadness": "Omarm je emoties met compassie en zorg",
    "ritual.moodLabel_illusion": "enthousiasme",
    "ritual.moodLabel_calm": "kalm",
    "ritual.moodLabel_apathy": "apathie",
    "ritual.moodLabel_anxiety": "angst",
    "ritual.moodLabel_sadness": "verdriet",
    "ritual.checkin": "Check-in",
    "ritual.recipe": "Recept",
    "ritual.meditate": "Mediteren",
    "ritual.matcha": "Matcha",
    "ritual.journal": "Journal",
    "shop.topSellers": "Topverkopers",
    "shop.buy": "+ Toevoegen",
    "shop.all": "Alles",
    "shop.couldNotLoadProducts": "Kon producten niet laden",
    "shop.noProductsInCategory": "Geen producten in deze categorie",
    "cart.title": "Winkelwagen ({{count}})",
    "cart.myCart": "Mijn mandje ({{count}})",
    "cart.myCartLabel": "Mijn mandje",
    "cart.viewCartLabel": "Bekijk mijn mandje",
    "cart.empty": "Legen",
    "cart.emptyCart": "Winkelwagen legen",
    "cart.emptyCartConfirm": "Weet je het zeker?",
    "cart.cartIsEmpty": "Je winkelwagen is leeg",
    "cart.exploreShop": "Verken de winkel en voeg producten toe",
    "cart.addFromShop": "Voeg producten toe vanuit de winkel",
    "cart.goToShop": "Naar de winkel",
    "cart.total": "Totaal",
    "cart.checkout": "Afrekenen",
    "cart.checkoutError": "Kon de bestelling niet aanmaken. Probeer het opnieuw.",
    "cart.freeShipping": "Gratis verzending",
    "cart.subtotal": "Subtotaal",
    "cart.shipping": "Verzending",
    "cart.free": "Gratis",
    "cart.freeShippingAt": "Gratis verzending vanaf {{amount}}",
    "cart.remove": "Verwijderen",
    "cart.removeConfirm": "\"{{title}}\" uit winkelwagen verwijderen?",
    "cart.clear": "Winkelwagen legen",
    "cart.clearConfirm": "Weet je het zeker?",
    "cart.clearBtn": "Legen",
    "cart.emptyDesc": "Bekijk de winkel en voeg producten toe",
    "cart.earnPoints": "⭐ Je verdient {{points}} punten met deze aankoop",
    "cart.shippingAtCheckout": "Berekend bij afrekenen",
    "offers.addMore": "Voeg <bold>{{amount}}€</bold> meer toe voor <bold>{{percent}}% korting</bold>",
    "offers.maxUnlocked": "<bold>Maximale korting ontgrendeld!</bold> 🎉",
    "garden.dayLabel": "Dag {{day}}",
    "garden.daysToNext": "{{days}} dagen tot {{name}}",
    "garden.treeComplete": "Boom voltooid! 🎉",
    "garden.consecutiveDays": "Opeenvolgende dagen",
    "garden.totalWaterings": "Totaal waterbeurten",
    "garden.currentLevel": "Huidig niveau",
    "garden.consecutiveDaysHelp": "Je huidige reeks opeenvolgende matcha check-in dagen. Als je een dag mist, gaat het terug naar nul!",
    "garden.totalWateringsHelp": "Het totaal aantal dagen dat je je matcha check-in hebt gedaan. Elke check-in geeft je plant water en helpt het groeien.",
    "garden.currentLevelHelp": "Het niveau van je plant. Het groeit naarmate je opeenvolgende check-in dagen opbouwt. Op het maximale niveau wordt het een boom voor je tuin.",
    "garden.understood": "Begrepen",
    "garden.badgesTitle": "Badges & prestaties",
    "garden.badge_primer_brote": "Eerste Kiem",
    "garden.badge_racha_5": "5-dagenreeks",
    "garden.badge_racha_10": "10-dagenreeks",
    "garden.badge_racha_30": "30-dagenreeks",
    "garden.badge_primer_arbol": "Eerste Boom",
    "garden.badgeDesc_primer_brote": "Eerste check-in",
    "garden.badgeDesc_racha_5": "5 opeenvolgende dagen",
    "garden.badgeDesc_racha_10": "10 opeenvolgende dagen",
    "garden.badgeDesc_racha_30": "30 opeenvolgende dagen",
    "garden.badgeDesc_primer_arbol": "30 dagen voltooid",
    "rewards.yourPoints": "Je punten",
    "rewards.level": "Niveau: {{current}}",
    "rewards.levelNext": "{{current}} → {{next}}",
    "rewards.availableRewards": "Beschikbare beloningen",
    "rewards.exclusiveApp": "App-exclusief — niet beschikbaar in de winkel",
    "rewards.comingSoon": "Binnenkort",
    "rewards.comingSoonDesc": "We bereiden exclusieve beloningen voor je voor. Blijf punten verzamelen!",
    "rewards.merchandise": "Merchandise",
    "rewards.exclusiveProduct": "Exclusief product",
    "rewards.experience": "Ervaring",
    "rewards.outOfStock": "Uitverkocht",
    "rewards.redeem": "Inwisselen",
    "rewards.missingPoints": "Nog {{count}} pts nodig",
    "rewards.linkAccountForRewards": "Je moet je e-mail koppelen om beloningen in te wisselen.",
    "rewards.insufficientPoints": "Onvoldoende punten",
    "rewards.insufficientPointsDesc": "Je hebt nog {{count}} punten nodig om \"{{name}}\" in te wisselen. Ga door met je dagelijkse ritueel!",
    "rewards.redeemConfirm": "Beloning inwisselen",
    "rewards.redeemConfirmDesc": "Wil je \"{{name}}\" inwisselen voor {{points}} punten?",
    "rewards.redeemed": "Beloning ingewisseld! 🎉",
    "rewards.redeemedDesc": "Je ontvangt meer informatie per e-mail.",
    "rewards.redeemError": "Fout bij inwisselen",
    "rewards.myRedemptions": "Mijn inwisselingen",
    "rewards.statusPending": "⏳ In behandeling",
    "rewards.statusProcessing": "📦 Wordt voorbereid",
    "rewards.statusShipped": "🚚 Verzonden",
    "rewards.statusDelivered": "✅ Afgeleverd",
    "rewards.howItWorks": "Hoe werkt het?",
    "rewards.howStep1": "Voltooi je dagelijkse ritueel om punten te verdienen",
    "rewards.howStep2": "Verzamel punten met reeksen, aankopen en verwijzingen",
    "rewards.howStep3": "Wissel je punten in voor exclusieve beloningen",
    "rewards.morePointsNeeded": "{{count}} pts meer voor {{level}}",
    "rewards.rewardsTitle": "Beloningen",
    "rewards.pointsAvailable": "punten beschikbaar",
    "rewards.howToEarnPoints": "Hoe punten verdienen?",
    "rewards.earn_purchases": "Aankopen: +1 pt per €1 besteed",
    "rewards.earn_ritualStep": "Elke stap van het dagelijks Ritueel: +1 pt",
    "rewards.earn_ritualComplete": "Dagelijks Ritueel voltooien: +5 pts bonus",
    "rewards.earn_referralRegister": "Vrienden uitnodigen: +50 pts per registratie",
    "rewards.earn_referralPurchase": "Aankoop van je gast: +150 pts",
    "rewards.earn_survey": "Enquêtes invullen: variabele punten",
    "rewards.earn_review": "Een review schrijven: +50 pts",
    "orders.myOrders": "Mijn bestellingen",
    "orders.processing": "In behandeling",
    "orders.delivered": "Afgeleverd",
    "orders.inTransit": "Onderweg",
    "orders.shipped": "Verzonden",
    "orders.partiallySent": "Gedeeltelijk verzonden",
    "orders.inPreparation": "In voorbereiding",
    "orders.cancelled": "Geannuleerd",
    "orders.login": "Inloggen",
    "orders.loginDesc": "Koppel je account om je bestellingen te zien",
    "orders.linkAccount": "Account koppelen",
    "orders.loadingOrders": "Bestellingen laden...",
    "orders.loadError": "Fout bij laden",
    "orders.noOrders": "Geen bestellingen",
    "orders.noOrdersDesc": "Je hebt nog geen bestellingen geplaatst",
    "orders.goToShop": "Naar de winkel",
    "orders.viewDetail": "Detail bekijken",
    "orders.loadMore": "Meer bestellingen laden",
    "orders.exception": "Incident",
    "orders.outForDelivery": "Wordt bezorgd",
    "orders.returned": "Geretourneerd",
    "orders.refunded": "Terugbetaald",
    "surveys.title": "Nieuws",
    "surveys.subtitle": "Ontdek het laatste nieuws, enquêtes en exclusieve content",
    "surveys.noSurveys": "Geen nieuws beschikbaar",
    "surveys.noSurveysDesc": "We laten je weten wanneer er iets nieuws is. Ga door met je dagelijkse ritueel!",
    "surveys.question": "Vraag {{number}}",
    "surveys.required": "Verplicht",
    "surveys.answered": "{{answered}} van {{total}} beantwoord",
    "surveys.writeAnswer": "Schrijf je antwoord...",
    "surveys.completeSurvey": "Enquête voltooien",
    "surveys.thanks": "Bedankt!",
    "surveys.pointsEarned": "Je hebt ⭐ {{points}} punten verdiend",
    "surveys.answersHelp": "Je antwoorden helpen ons je matcha-ervaring te verbeteren 🍵",
    "surveys.surveyNotFound": "Enquête niet gevonden",
    "surveys.loadError": "Kon de enquête niet laden.",
    "surveys.submitError": "Fout bij het verzenden van de enquête",
    "surveys.questions_one": "{{count}} vraag",
    "surveys.questions_other": "{{count}} vragen",
    "surveys.survey": "Enquête",
    "profile.myProfile": "Mijn profiel",
    "profile.matchaPoints": "⭐ {{count}} Matcha Points",
    "profile.orders": "Bestellingen",
    "profile.points": "Punten",
    "profile.streak": "Reeks",
    "profile.badges": "Badges",
    "profile.shippingAddress": "Verzendadres",
    "profile.edit": "Bewerken",
    "profile.add": "Toevoegen",
    "profile.firstName": "Voornaam",
    "profile.lastName": "Achternaam",
    "profile.phone": "Telefoon",
    "profile.address": "Adres",
    "profile.addressPlaceholder": "Straat, nummer, verdieping...",
    "profile.addressLine2": "Adres (regel 2)",
    "profile.optional": "Optioneel",
    "profile.city": "Stad",
    "profile.zip": "Postcode",
    "profile.province": "Provincie",
    "profile.country": "Land",
    "profile.invalidPhone": "Ongeldig telefoonnummer",
    "profile.addressUpdated": "Adres bijgewerkt",
    "profile.addressSaved": "Je verzendadres is opgeslagen.",
    "profile.saveError": "Fout bij opslaan van het adres",
    "profile.saving": "Opslaan...",
    "profile.saveAddress": "Adres opslaan",
    "profile.addShippingAddress": "Verzendadres toevoegen",
    "profile.inviteFriend": "Nodig een vriend uit",
    "profile.inviteReward": "Verdien 100 pts voor elke vriend die koopt",
    "profile.shareLink": "Link delen",
    "profile.shareMessage": "Probeer Matcha & CO! Gebruik mijn code voor korting op je eerste bestelling. https://matchaandco.com",
    "profile.notifications": "Meldingen",
    "profile.myOrdersMenu": "Mijn bestellingen",
    "profile.quickReorder": "Snel opnieuw bestellen",
    "profile.helpSupport": "Hulp & ondersteuning",
    "profile.terms": "Algemene voorwaarden",
    "profile.signOut": "Uitloggen",
    "profile.signOutConfirm": "Weet je het zeker?",
    "profile.language": "Taal",
    "profile.selectLanguage": "Selecteer je taal",
    "profile.selectProvince": "Selecteer provincie",
    "profile.searchProvince": "Zoek provincie...",
    "profile.selectCountry": "Selecteer land",
    "profile.referralCodeTitle": "Verwijzingscode",
    "profile.referralCodePlaceholder": "Voer je code in",
    "profile.referralCodeHint": "Heb je een verwijzingscode? Voer deze in voor extra punten",
    "profile.applyCode": "Code toepassen",
    "profile.referralApplied": "Code succesvol toegepast",
    "profile.referralConverted": "Verwijzing geconverteerd",
    "profile.referralError": "Ongeldige code",
    "profile.referralAlready": "Je hebt al een verwijzingscode toegepast",
    "profile.referralSelf": "Je kunt je eigen code niet gebruiken",
    "profile.referralNotFound": "Code niet gevonden",
    "profile.referralExpired": "Deze code is verlopen",
    "profile.referralInvited": "Uitgenodigd",
    "profile.referralPointsEarned": "Pts verdiend",
    "profile.shareMessageWithLink": "Probeer Matcha & CO! Download de app en verdien 25 welkomstpunten 🍵 {{link}}",
    "profile.yourReferralCode": "Jouw verwijzingscode",
    "profile.paymentMethod": "Betaalmethode",
    "profile.paymentMethodHint": "Bewaar je betaalmethode om met één klik te kopen",
    "profile.paymentMethodUpdated": "Betaalmethode bijgewerkt",
    "profile.paymentMethodUpdatedDesc": "Je betaalmethode is succesvol opgeslagen.",
    "auth.linkAccount": "Koppel je account",
    "orderStatus.processing": "In behandeling",
    "orderStatus.delivered": "Afgeleverd",
    "orderStatus.inTransit": "Onderweg",
    "orderStatus.shipped": "Verzonden",
    "orderStatus.partiallySent": "Gedeeltelijk verzonden",
    "language.es": "Español",
    "language.en": "English",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.it": "Italiano",
    "language.nl": "Nederlands",
    "language.de": "Deutsch",
    "language.pl": "Polski",
    "product.notFound": "Product niet gevonden",
    "product.back": "Terug",
    "product.variant": "Variant",
    "product.quantity": "Aantal",
    "product.description": "Beschrijving",
    "product.addToCart": "In winkelwagen",
    "product.addedToCart": "Toegevoegd aan winkelwagen",
    "product.continueShopping": "Verder winkelen",
    "product.viewCart": "Winkelwagen bekijken",
    "product.unit_one": "stuk",
    "product.unit_other": "stuks",
    "product.ingredients": "Ingrediënten",
    "checkout.confirmOrder": "Bestelling bevestigen",
    "checkout.cartEmpty": "Je winkelwagen is leeg",
    "checkout.products": "Producten",
    "checkout.shippingAddress": "Verzendadres",
    "checkout.changeAddress": "Adres wijzigen",
    "checkout.addAddress": "Adres toevoegen",
    "checkout.couldNotLoadAddress": "Kon het adres niet laden",
    "checkout.paymentMethod": "Betaalmethode",
    "checkout.changePayment": "Betaalmethode wijzigen",
    "checkout.useStandardCheckout": "Standaard checkout gebruiken",
    "checkout.couldNotLoadPayment": "Kon de betaalmethode niet laden",
    "checkout.noPaymentMethod": "Geen opgeslagen betaalmethode",
    "checkout.addPaymentMethod": "Kaart toevoegen",
    "checkout.subtotal": "Subtotaal",
    "checkout.shipping": "Verzending",
    "checkout.tax": "Belasting",
    "checkout.free": "Gratis",
    "checkout.total": "Totaal",
    "checkout.securePayment": "Veilige betaling",
    "checkout.placeOrder": "Bestelling plaatsen",
    "checkout.quantity": "Aantal: {{count}}",
    "checkout.requiredFields": "Verplichte velden",
    "checkout.requiredFieldsDesc": "Vul minimaal naam, adres, stad en postcode in.",
    "checkout.addressError": "Kon het adres niet bijwerken. Probeer opnieuw.",
    "checkout.orderSuccess": "Bestelling geplaatst! 🎉",
    "checkout.orderSuccessDesc": "Je bestelling is verwerkt. Je ontvangt een bevestigingsmail.",
    "checkout.orderSuccessBtn": "Prima",
    "checkout.orderError": "Kon de bestelling niet verwerken. Probeer opnieuw.",
    "checkout.unexpectedError": "Er is een onverwachte fout opgetreden. Probeer opnieuw.",
    "checkout.checkoutError": "Kon de bestelling niet aanmaken. Probeer opnieuw.",
    "checkout.card": "Kaart",
    "checkout.freeShipping": "Gratis verzending",
    "checkout.freeShippingAt": "Gratis verzending vanaf {{amount}}",
    "checkout.firstName": "Voornaam *",
    "checkout.lastName": "Achternaam *",
    "checkout.phone": "Telefoon *",
    "checkout.address": "Adres *",
    "checkout.floor": "Verdieping / Deur",
    "checkout.zip": "Postcode *",
    "checkout.city": "Stad *",
    "checkout.optional": "Optioneel",
    "checkout.streetNumber": "Straat en nummer",
    "checkout.urlNotAvailable": "Checkout URL niet beschikbaar",
    "checkout.secureCheckout": "Veilig afrekenen",
    "checkout.loading": "Checkout laden...",
    "checkout.paymentDeclined": "De betaling is geweigerd. Controleer je kaart en probeer het opnieuw.",
    "checkout.paymentError_INSUFFICIENT_FUNDS": "Onvoldoende saldo. Controleer het saldo van je kaart.",
    "checkout.paymentError_PAYMENT_DECLINED": "De betaling is geweigerd door je bank.",
    "checkout.paymentError_INVALID_PAYMENT_METHOD": "De betaalmethode is ongeldig. Werk deze bij in je profiel.",
    "checkout.paymentError_EXPIRED_PAYMENT_METHOD": "Je kaart is verlopen. Werk je betaalmethode bij.",
    "checkout.paymentError_AUTHENTICATION_ERROR": "Authenticatie vereist. Probeer het opnieuw.",
    "checkout.paymentError_PAYMENT_PROCESSING": "De betaling wordt verwerkt. Wacht enkele minuten en controleer uw bestellingen.",
    "checkout.email": "E-mail",
    "checkout.emailPlaceholder": "jouw@email.com",
    "checkout.continue": "Doorgaan",
    "checkout.loginForAddress": "Voer je e-mail in om een adres toe te voegen",
    "checkout.loginForPayment": "Voer je e-mail in om een betaalmethode toe te voegen",
    "checkout.emailError": "Kan e-mail niet koppelen. Probeer het opnieuw.",
    "checkout.verifyCode": "Code verifiëren",
    "checkout.invalidCode": "Ongeldige of verlopen code. Probeer het opnieuw.",
    "checkout.codeSent": "Code verzonden naar {{email}}",
    "checkout.pickupPoint": "Afhaalpunt",
    "checkout.noServicePoints": "Geen afhaalpunten gevonden in de buurt",
    "reorder.repeatOrder": "Herhaal je bestelling",
    "reorder.adjustQuantities": "Pas de hoeveelheden aan en bevestig met een tik",
    "reorder.products": "Producten",
    "reorder.shippingAddress": "Verzendadres",
    "reorder.loadingAddress": "Adres laden...",
    "reorder.change": "Wijzigen",
    "reorder.add": "Toevoegen",
    "reorder.total": "Totaal",
    "reorder.changesNote": "* Hoeveelheden gewijzigd ten opzichte van je laatste bestelling",
    "reorder.repeatBtn": "Bestelling herhalen",
    "reorder.loadingOrder": "Je bestelling laden...",
    "reorder.noPreviousOrder": "Geen eerdere bestelling",
    "reorder.noPreviousOrderDesc": "Geen actief herbestelcontract gevonden. Plaats je eerste bestelling in de winkel.",
    "reorder.goToShop": "Naar de winkel",
    "reorder.noProducts": "Geen producten",
    "reorder.noProductsDesc": "Voeg minimaal één product toe om je bestelling te herhalen.",
    "reorder.orderSuccess": "Bestelling geplaatst! 🎉",
    "reorder.orderSuccessDesc": "Je bestelling is verwerkt. Je ontvangt een bevestigingsmail.",
    "reorder.orderSuccessBtn": "Prima",
    "reorder.orderError": "Kon de bestelling niet verwerken. Probeer opnieuw.",
    "reorder.unexpectedError": "Er is een onverwachte fout opgetreden. Probeer opnieuw.",
    "reorder.addressError": "Kon het adres niet bijwerken.",
    "reorder.requiredFields": "Verplichte velden",
    "reorder.requiredFieldsDesc": "Vul minimaal naam, adres, stad en postcode in.",
    "reorder.product": "Product",
    "orderDetail.order": "Bestelling",
    "orderDetail.orders": "Bestellingen",
    "orderDetail.loadingOrder": "Bestelling laden...",
    "orderDetail.loadError": "Fout bij laden",
    "orderDetail.orderNotFound": "Bestelling niet gevonden",
    "orderDetail.retry": "Opnieuw proberen",
    "orderDetail.shippingStatus": "Verzendstatus",
    "orderDetail.confirmed": "Bestelling bevestigd",
    "orderDetail.confirmedDesc": "Je bestelling is ontvangen",
    "orderDetail.preparing": "In voorbereiding",
    "orderDetail.preparingDesc": "We bereiden je matcha voor",
    "orderDetail.shipped": "Verzonden",
    "orderDetail.shippedDesc": "Onderweg naar jou",
    "orderDetail.delivered": "Afgeleverd",
    "orderDetail.deliveredDesc": "Geniet van je matcha!",
    "orderDetail.cancelled": "Geannuleerd",
    "orderDetail.products": "Producten",
    "orderDetail.quantity": "Aantal: {{count}}",
    "orderDetail.summary": "Samenvatting",
    "orderDetail.shippingAddress": "Verzendadres",
    "orderDetail.paymentStatus": "Betaalstatus",
    "orderDetail.total": "Totaal",
    "orderDetail.repeatThisOrder": "Deze bestelling herhalen",
    "orderDetail.repeatConfirm": "Bestelling herhalen",
    "orderDetail.repeatConfirmDesc": "Wil je deze matcha-bestelling herhalen?",
    "orderDetail.repeatSuccess": "Bestelling geplaatst! 🎉",
    "orderDetail.repeatSuccessDesc": "Je matcha is onderweg.",
    "orderDetail.repeatError": "Kon de herbestelling niet verwerken",
    "orderDetail.needHelp": "Hulp nodig?",
    "orderDetail.needHelpDesc": "Neem contact op met support als je vragen hebt over je bestelling",
    "orderDetail.contactSupport": "Contact support",
    "orderDetail.inTransit": "Onderweg",
    "orderDetail.outForDelivery": "In bezorging",
    "orderDetail.outForDeliveryDesc": "Je bestelling komt vandaag!",
    "orderDetail.exception": "Probleem",
    "orderDetail.exceptionDesc": "Er was een probleem met je zending",
    "orderDetail.returned": "Geretourneerd",
    "orderDetail.returnedDesc": "Je pakket is teruggestuurd",
    "orderDetail.inTransitDesc": "Je bestelling is onderweg",
    "orderDetail.trackShipment": "Zending volgen",
    "orderDetail.trackingEvents": "Verzendgeschiedenis",
    "redeem.rewardNotFound": "Beloning niet gevonden",
    "redeem.couldNotLoadReward": "Kon de beloning niet laden.",
    "redeem.rewardRedeemed": "Beloning ingewisseld!",
    "redeem.experienceInfo": "Je ontvangt meer informatie per e-mail.",
    "redeem.physicalInfo": "We sturen het binnenkort naar je adres.",
    "redeem.pointsSpent": "−{{cost}} punten • Saldo: ⭐ {{balance}}",
    "redeem.backToRewards": "Terug naar beloningen",
    "redeem.cost": "Kosten",
    "redeem.yourBalance": "Je saldo",
    "redeem.missingPoints": "Je hebt nog {{count}} punten nodig",
    "redeem.addressNeeded": "Adres nodig",
    "redeem.addressNeededDesc": "Voeg een verzendadres toe om je beloning te ontvangen.",
    "redeem.noAddressSaved": "Je hebt geen opgeslagen adres",
    "redeem.addAddress": "Adres toevoegen",
    "redeem.changeAddress": "Adres wijzigen",
    "redeem.confirmRedeem": "Inwisseling bevestigen",
    "redeem.redeemError": "Fout bij inwisselen van de beloning",
    "redeem.insufficientPoints": "Onvoldoende punten",
    "redeem.insufficientPointsDesc": "Je hebt nog {{count}} punten nodig om \"{{name}}\" in te wisselen.",
    "savedRecipes.title": "Mijn opgeslagen recepten",
    "savedRecipes.deleteRecipe": "Recept verwijderen",
    "savedRecipes.deleteConfirm": "Wil je dit recept uit je opgeslagen verwijderen?",
    "savedRecipes.noRecipes": "Geen opgeslagen recepten",
    "savedRecipes.noRecipesDesc": "Sla de recepten die je leuk vindt op tijdens je dagelijkse ritueel om ze hier terug te vinden.",
    "recipeDetail.notFound": "Recept niet gevonden",
    "recipeDetail.ingredients": "Ingrediënten",
    "recipeDetail.preparation": "Bereiding",
    "recipeDetail.servings": "{{count}} porties",
    "recipeDetail.viewSource": "Bekijk op matchaandco.com",
    "notifications.title": "Meldingen",
    "notifications.profile": "Profiel",
    "notifications.disabled": "Meldingen uitgeschakeld",
    "notifications.disabledDesc": "Schakel meldingen in om je dagelijkse ritueel niet te missen",
    "notifications.enable": "Meldingen inschakelen",
    "notifications.enabled": "Klaar!",
    "notifications.enabledDesc": "Meldingen zijn ingeschakeld",
    "notifications.permissionsNeeded": "Toestemming nodig",
    "notifications.permissionsNeededDesc": "Om meldingen te ontvangen, schakel ze in in je apparaatinstellingen.",
    "notifications.couldNotLoad": "Kon voorkeuren niet laden",
    "notifications.couldNotSave": "Kon voorkeur niet opslaan",
    "notifications.saving": "Opslaan...",
    "notifications.quietHours": "Stille uren",
    "notifications.quietHoursDesc": "Je ontvangt geen meldingen tussen {{start}} en {{end}}",
    "notifications.dailyReminder": "Dagelijkse herinnering",
    "notifications.dailyReminderDesc": "We herinneren je aan je ochtendritueel",
    "notifications.streakWarning": "Reekswaarschuwing",
    "notifications.streakWarningDesc": "Waarschuwing voordat je je reeks verliest",
    "notifications.orderStatus": "Bestelstatus",
    "notifications.orderStatusDesc": "Verzend- en bezorgupdates",
    "notifications.restockReminder": "Aanvulherinnering",
    "notifications.restockReminderDesc": "Wanneer je matcha bijna op is",
    "notifications.rewardsAvailable": "Beloningen beschikbaar",
    "notifications.rewardsAvailableDesc": "Wanneer je punten kunt inwisselen",
    "notifications.contentNew": "Nieuwe content",
    "notifications.contentNewDesc": "Nieuwe recepten en meditaties",
    "notifications.announcements": "Aankondigingen",
    "notifications.announcementsDesc": "Nieuws van Matcha & CO",
    "notifications.subscriptionInfo": "Abonnement info",
    "notifications.subscriptionInfoDesc": "Verlengingen en wijzigingen",
    "onboarding.skip": "Overslaan",
    "onboarding.next": "Volgende →",
    "onboarding.linkAccount": "Account koppelen",
    "onboarding.exploreWithoutAccount": "Verkennen zonder account",
    "onboarding.welcomeTitle": "Welkom bij Matcha & CO",
    "onboarding.welcomeDesc": "Je matcha-winkel met nabestelling in één klik. Maar ook een Mindfulness-tool om elke dag voor je welzijn te zorgen.",
    "onboarding.ritualTitle": "Wat is het Ritueel?",
    "onboarding.ritualDesc": "Een dagelijkse oefening om bewuster te zijn van hoe je je voelt en gezonde gewoonten in je routine in te bouwen.",
    "onboarding.ritualStep1Name": "Emotionele check-in",
    "onboarding.ritualStep1Desc": "Hoe voel je je vandaag?",
    "onboarding.ritualStep2Name": "Recept van de dag",
    "onboarding.ritualStep2Desc": "Een gepersonaliseerd matcha-recept",
    "onboarding.ritualStep3Name": "Meditatie",
    "onboarding.ritualStep3Desc": "Een moment van rust en mindfulness",
    "onboarding.ritualStep4Name": "Matcha",
    "onboarding.ritualStep4Desc": "Log je matcha-moment van de dag",
    "onboarding.ritualStep5Name": "Dagboek",
    "onboarding.ritualStep5Desc": "Reflecteer op je dag",
    "onboarding.pointsTitle": "Matcha Points ⭐",
    "onboarding.pointsDesc": "Verdien punten door je ritueel te voltooien, met aankopen, verwijzingen en reeksen. Wissel ze in voor exclusieve beloningen die niet in de winkel te vinden zijn.",
    "onboarding.streaksTitle": "Reeksen 🔥",
    "onboarding.streaksDesc": "Elke dag dat je je matcha-check-in doet, groeit je reeks. Bereik mijlpalen (5, 10, 30 dagen) voor bonuspunten. Mis je een dag, dan gaat hij terug naar nul!",
    "onboarding.letsGoTitle": "Laten we beginnen!",
    "onboarding.letsGoDesc": "Koppel je e-mail om bestellingen en punten te synchroniseren en de volledige ervaring te ontgrendelen. Of verken eerst.",
    "linkAccount.title": "Koppel je account",
    "linkAccount.subtitle": "Voer je e-mail in en we sturen je een magische link om je apparaat te koppelen.",
    "linkAccount.sendMagicLink": "Magische link versturen",
    "linkAccount.enterCode": "Voer de code in",
    "linkAccount.codeSent": "We hebben een 6-cijferige code gestuurd naar",
    "linkAccount.verifyCode": "Code verifiëren",
    "linkAccount.resendCode": "Code opnieuw versturen",
    "linkAccount.accountLinked": "Account gekoppeld",
    "linkAccount.deviceLinked": "Je apparaat is gekoppeld aan",
    "linkAccount.backToProfile": "Terug naar profiel",
    "linkAccount.sendError": "Fout bij verzenden van de link",
    "linkAccount.codeError": "Ongeldige code",
    "linkAccount.haveReferralCode": "Heb je een verwijzingscode?",
    "linkAccount.validateEmail": "Voer een geldig e-mailadres in",
    "completeProfile.title": "Voltooi je profiel",
    "completeProfile.subtitle": "Om je ervaring te personaliseren hebben we wat gegevens nodig",
    "completeProfile.firstName": "Voornaam *",
    "completeProfile.lastName": "Achternaam *",
    "completeProfile.phone": "Telefoon (optioneel)",
    "completeProfile.save": "Profiel opslaan",
    "completeProfile.error": "Fout bij voltooien van het profiel",
    "completeProfile.firstNamePlaceholder": "Voornaam",
    "completeProfile.lastNamePlaceholder": "Achternaam",
    "suggestedProducts.title": "Misschien vind je dit ook leuk",
    "suggestedProducts.add": "Toevoegen"
  },
  "pl": {
    "tabs.home": "Strona główna",
    "tabs.ritual": "Rytuał",
    "tabs.shop": "Sklep",
    "tabs.garden": "Ogród",
    "tabs.rewards": "Nagrody",
    "common.back": "Wstecz",
    "common.cancel": "Anuluj",
    "common.save": "Zapisz",
    "common.delete": "Usuń",
    "common.retry": "Spróbuj ponownie",
    "common.close": "Zamknij",
    "common.confirm": "Potwierdź",
    "common.loading": "Ładowanie...",
    "common.error": "Błąd",
    "common.ok": "OK",
    "common.seeAll": "Zobacz wszystkie →",
    "common.days": "dni",
    "common.day": "dzień",
    "common.points": "punkty",
    "common.pts": "pkt",
    "common.noResults": "Brak wyników",
    "date.sunday": "Niedziela",
    "date.monday": "Poniedziałek",
    "date.tuesday": "Wtorek",
    "date.wednesday": "Środa",
    "date.thursday": "Czwartek",
    "date.friday": "Piątek",
    "date.saturday": "Sobota",
    "date.january": "stycznia",
    "date.february": "lutego",
    "date.march": "marca",
    "date.april": "kwietnia",
    "date.may": "maja",
    "date.june": "czerwca",
    "date.july": "lipca",
    "date.august": "sierpnia",
    "date.september": "września",
    "date.october": "października",
    "date.november": "listopada",
    "date.december": "grudnia",
    "date.dateFormat": "{{day}}, {{date}} {{month}}",
    "home.reorderTitle": "Powtórz moje ostatnie zamówienie",
    "home.reorderSubtitle": "Zamów ponownie jednym kliknięciem",
    "home.reorderBtn": "Zamów",
    "home.oneClickTitle": "Powtórz zamówienie",
    "home.oneClickBtn": "Zamów",
    "home.oneClickConfirmTitle": "Powtórzyć zamówienie?",
    "home.oneClickConfirmTotal": "Total: {{total}} €",
    "home.oneClickConfirmCard": "Karta ····{{digits}}",
    "home.oneClickConfirmBtn": "Potwierdź",
    "home.oneClickSuccess": "Zamówienie złożone! Otrzymasz email z potwierdzeniem.",
    "home.streakDays": "🔥 {{count}} dni serii",
    "home.wildcardAvailable": "🛡️ 1 dzień łaski dostępny",
    "home.nextMilestone": "⭐ {{days}}d → +{{points}}pkt",
    "home.treesCount_one": "🌳 {{count}} drzewo w twoim ogrodzie",
    "home.treesCount_other": "🌳 {{count}} drzew w twoim ogrodzie",
    "home.yourRitualToday": "Twój dzisiejszy rytuał",
    "home.savedRecipes": "Moje zapisane przepisy",
    "home.matchaFinished": "Twoja matcha się skończyła",
    "home.matchaRunningOut": "Twoja matcha skończy się za ~{{days}} dni",
    "home.dontLoseStreak": "Nie strać swojej serii!",
    "home.oneClick": "1 klik",
    "home.restock": "Uzupełnij",
    "home.orderInProgress": "Zamówienie w toku",
    "home.lastOrder": "Twoje ostatnie zamówienie",
    "home.seeAllOrders": "Zobacz wszystkie zamówienia →",
    "home.dailyRitual": "Twój codzienny rytuał",
    "home.nextStep": "NASTĘPNY KROK",
    "home.ritualBonus": "Ukończ wszystkie 5 dzisiaj i zdobądź +5 pkt bonus",
    "home.ritualCta.start": "Rozpocznij mój rytuał →",
    "home.ritualCta.continue": "Kontynuuj rytuał →",
    "home.ritualCta.completed": "Zobacz podsumowanie →",
    "home.linkAccount": "Połącz swoje konto",
    "home.linkAccountDesc": "Synchronizuj zamówienia i punkty, łącząc swój email",
    "home.stat.streakLabel": "DNI\nZ RZĘDU",
    "home.stat.pointsLabel": "PUNKTY\nZDOBYTE",
    "home.stat.levelLabel": "AKTUALNY\nPOZIOM",
    "home.statModal.streakTitle": "Dni z rzędu",
    "home.statModal.streakBody": "Twoja seria liczy kolejne dni, w których wykonujesz co najmniej jeden krok codziennego rytuału.\n\nUtrzymanie serii odblokowuje bonusy punktowe na etapach 7, 14 i 30 dni.\n\nJeśli opuścisz dzień, masz jeden dzień łaski, który chroni twoją serię.",
    "home.statModal.pointsTitle": "Zdobyte punkty",
    "home.statModal.pointsBody": "Punkty to twoja waluta w Matcha & CO. Zdobywaj je, wykonując codzienny rytuał, ankiety i inne aktywności.\n\nWymieniaj je na ekskluzywne nagrody, takie jak darmowe produkty, zniżki i specjalne prezenty.\n\nTen licznik pokazuje twoje dostępne punkty.",
    "home.statModal.levelTitle": "Aktualny poziom",
    "home.statModal.levelIntro": "Twój poziom odzwierciedla twoje zaangażowanie w Matcha & CO. Awansuj, zdobywając punkty.",
    "home.statModal.levelNeverDrops": "W przeciwieństwie do wymienialnych punktów, twój poziom nigdy nie spada.",
    "home.greetingMorning": "DZIEŃ DOBRY",
    "home.greetingAfternoon": "DZIEŃ DOBRY",
    "home.greetingEvening": "DOBRY WIECZÓR",
    "home.greetingFallback": "Cześć!",
    "home.today": "DZIŚ",
    "home.understood": "Rozumiem",
    "home.rewardsTitle": "NAGRODY",
    "home.rewardsSubtitle": "Ekskluzywne prezenty",
    "home.seeAllRewards": "Zobacz wszystkie prezenty  →",
    "home.recipeOfDay": "PRZEPIS DNIA",
    "home.motivational_0": "Każda filiżanka to krok ku Twojemu zdrowiu 🍵",
    "home.motivational_1": "Twoje ciało Ci dziękuje 🌿",
    "home.motivational_2": "Mały rytuał, ogromna zmiana ✨",
    "home.motivational_3": "Dziś wybrałeś dbanie o siebie 💚",
    "home.motivational_4": "Twoja wytrwałość to Twoja supermoc 🌱",
    "home.motivational_5": "Oddychaj, pij, uśmiechaj się. Powtórz jutro ☀️",
    "home.greetingHello": "Cześć, {{name}}!",
    "home.paymentBannerTitle": "Dodaj kartę i kupuj jednym kliknięciem",
    "home.paymentBannerSubtitle": "Zapisz metodę płatności, aby ułatwić następne zamówienie i zdobądź {{points}} punktów.",
    "home.paymentBannerBtn": "Dodaj",
    "home.paymentMethodBonusSuccess": "Zdobyłeś {{points}} punktów za dodanie metody płatności!",
    "ritual.emotionalCheckin": "Check-in emocjonalny",
    "ritual.recommendedRecipe": "Polecany przepis",
    "ritual.meditation": "Medytacja",
    "ritual.registerMatcha": "Zarejestruj matcha",
    "ritual.journaling": "Dziennik",
    "ritual.howDoYouFeel": "Jak się dziś czujesz?",
    "ritual.chooseMood": "Wybierz emocję, która najlepiej cię opisuje",
    "ritual.whatRecipe": "Jaki rodzaj przepisu ci odpowiada?",
    "ritual.yourState": "Twój stan: {{emoji}} {{label}}",
    "ritual.illusion": "Entuzjazm",
    "ritual.calm": "Spokój",
    "ritual.apathy": "Apatia",
    "ritual.anxiety": "Lęk",
    "ritual.sadness": "Smutek",
    "ritual.allCategories": "Wszystkie",
    "ritual.drinks": "Napoje",
    "ritual.breakfast": "Śniadanie",
    "ritual.desserts": "Desery",
    "ritual.mains": "Dania główne",
    "ritual.snacks": "Przekąski",
    "ritual.doCheckinFirst": "Najpierw zrób check-in emocjonalny, abyśmy mogli polecić ci idealny przepis.",
    "ritual.doCheckinBtn": "Zrób check-in emocjonalny 🫶",
    "ritual.noRecipes": "Brak dostępnych przepisów",
    "ritual.noRecipesDesc": "Brak przepisów dla tego filtra. Spróbuj innej kategorii!",
    "ritual.completeAnyway": "Ukończ mimo wszystko ✓",
    "ritual.basedOnState": "Na podstawie twojego stanu: {{mood}}",
    "ritual.servings": "{{count}} porcji",
    "ritual.ingredients": "Składniki:",
    "ritual.preparation": "Przygotowanie:",
    "ritual.complete": "Ukończ ✓",
    "ritual.guidedMeditation": "Medytacja prowadzona",
    "ritual.minutesSingular": "{{count}} minuta",
    "ritual.minutesPlural": "{{count}} minut",
    "ritual.startMeditation": "▶  Rozpocznij medytację",
    "ritual.meditating": "Medytuję... 🧘",
    "ritual.skip": "Pomiń →",
    "ritual.alreadyDrankMatcha": "Już wypiłem swoją matcha",
    "ritual.whatMatchaToday": "Jaką matchę piłeś dzisiaj?",
    "ritual.selectMatchaType": "Wybierz rodzaj matchy",
    "ritual.matchaType_solo": "Czysta matcha",
    "ritual.matchaType_latte": "Matcha latte",
    "ritual.matchaType_protein": "Matcha protein",
    "ritual.matchaType_collagen": "Matcha kolagen",
    "ritual.matchaType_creatine": "Matcha kreatyna",
    "ritual.matchaType_golden_milk": "Golden milk",
    "ritual.matchaType_iced": "Matcha na zimno",
    "ritual.matchaType_recipe": "W przepisie",
    "ritual.matchaType_other": "Inne",
    "ritual.streakLabel": "🔥 Seria: {{count}} dni",
    "ritual.plantEvolved": "🌱 Twoja roślina się rozwinęła!",
    "ritual.newTree": "🌳 Ukończyłeś drzewo!",
    "ritual.journalingTitle": "Dziennik 📝",
    "ritual.writeHere": "Pisz tutaj...",
    "ritual.ritualComplete": "🎉 Rytuał ukończony!",
    "ritual.yourRitualToday": "Twój dzisiejszy rytuał",
    "ritual.bonusPoints": "+5 pkt bonus. Twoja roślina ci dziękuje 🌱",
    "ritual.completed": "✓ Ukończone",
    "ritual.completeFiveSteps": "✨ Ukończ wszystkie 5 kroków, aby zdobyć +5 pkt bonus",
    "ritual.journalPrompt1": "Co było najlepsze w dzisiejszym dniu?",
    "ritual.journalPrompt2": "Za co jesteś dziś wdzięczny?",
    "ritual.journalPrompt3": "Jak chcesz się jutro czuć?",
    "ritual.journalPrompt4": "Co sprawiło, że się uśmiechnąłeś?",
    "ritual.meditationSubtitle_illusion": "Wzmocnij ten entuzjazm wdzięcznością i wizualizacją",
    "ritual.meditationSubtitle_calm": "Pogłęb swój spokój świadomym oddechem",
    "ritual.meditationSubtitle_apathy": "Odzyskaj energię i połącz się ze sobą na nowo",
    "ritual.meditationSubtitle_anxiety": "Uwolnij napięcie i znajdź swoje centrum",
    "ritual.meditationSubtitle_sadness": "Przytul swoje emocje ze współczuciem i troską",
    "ritual.moodLabel_illusion": "entuzjazm",
    "ritual.moodLabel_calm": "spokój",
    "ritual.moodLabel_apathy": "apatia",
    "ritual.moodLabel_anxiety": "lęk",
    "ritual.moodLabel_sadness": "smutek",
    "ritual.checkin": "Check-in",
    "ritual.recipe": "Przepis",
    "ritual.meditate": "Medytacja",
    "ritual.matcha": "Matcha",
    "ritual.journal": "Dziennik",
    "shop.topSellers": "Bestsellery",
    "shop.buy": "+ Dodaj",
    "shop.all": "Wszystko",
    "shop.couldNotLoadProducts": "Nie udało się załadować produktów",
    "shop.noProductsInCategory": "Brak produktów w tej kategorii",
    "cart.title": "Koszyk ({{count}})",
    "cart.myCart": "Mój koszyk ({{count}})",
    "cart.myCartLabel": "Mój koszyk",
    "cart.viewCartLabel": "Zobacz mój koszyk",
    "cart.empty": "Opróżnij",
    "cart.emptyCart": "Opróżnij koszyk",
    "cart.emptyCartConfirm": "Jesteś pewien?",
    "cart.cartIsEmpty": "Twój koszyk jest pusty",
    "cart.exploreShop": "Przeglądaj sklep i dodaj produkty",
    "cart.addFromShop": "Dodaj produkty ze sklepu",
    "cart.goToShop": "Przejdź do sklepu",
    "cart.total": "Suma",
    "cart.checkout": "Złóż zamówienie",
    "cart.checkoutError": "Nie udało się utworzyć zamówienia. Spróbuj ponownie.",
    "cart.freeShipping": "Darmowa dostawa",
    "cart.subtotal": "Suma częściowa",
    "cart.shipping": "Wysyłka",
    "cart.free": "Bezpłatna",
    "cart.freeShippingAt": "Darmowa wysyłka od {{amount}}",
    "cart.remove": "Usuń",
    "cart.removeConfirm": "Usunąć \"{{title}}\" z koszyka?",
    "cart.clear": "Wyczyść koszyk",
    "cart.clearConfirm": "Czy na pewno?",
    "cart.clearBtn": "Wyczyść",
    "cart.emptyDesc": "Przeglądaj sklep i dodawaj produkty",
    "cart.earnPoints": "⭐ Zdobędziesz {{points}} punktów za ten zakup",
    "cart.shippingAtCheckout": "Obliczane przy kasie",
    "offers.addMore": "Dodaj <bold>{{amount}}€</bold> więcej, aby uzyskać <bold>{{percent}}% zniżki</bold>",
    "offers.maxUnlocked": "<bold>Maksymalna zniżka odblokowana!</bold> 🎉",
    "garden.dayLabel": "Dzień {{day}}",
    "garden.daysToNext": "{{days}} dni do {{name}}",
    "garden.treeComplete": "Drzewo ukończone! 🎉",
    "garden.consecutiveDays": "Dni z rzędu",
    "garden.totalWaterings": "Łączne podlewania",
    "garden.currentLevel": "Aktualny poziom",
    "garden.consecutiveDaysHelp": "Twoja aktualna seria kolejnych dni check-inu matcha. Jeśli opuścisz dzień, resetuje się do zera!",
    "garden.totalWateringsHelp": "Łączna liczba dni, w których wykonałeś check-in matcha. Każdy check-in podlewa twoją roślinę i pomaga jej rosnąć.",
    "garden.currentLevelHelp": "Poziom twojej rośliny. Rośnie w miarę gromadzenia kolejnych dni check-inu. Na maksymalnym poziomie staje się drzewem dla twojego ogrodu.",
    "garden.understood": "Rozumiem",
    "garden.badgesTitle": "Odznaki i osiągnięcia",
    "garden.badge_primer_brote": "Pierwszy Kiełek",
    "garden.badge_racha_5": "Seria 5 dni",
    "garden.badge_racha_10": "Seria 10 dni",
    "garden.badge_racha_30": "Seria 30 dni",
    "garden.badge_primer_arbol": "Pierwsze Drzewo",
    "garden.badgeDesc_primer_brote": "Pierwszy check-in",
    "garden.badgeDesc_racha_5": "5 kolejnych dni",
    "garden.badgeDesc_racha_10": "10 kolejnych dni",
    "garden.badgeDesc_racha_30": "30 kolejnych dni",
    "garden.badgeDesc_primer_arbol": "30 ukończonych dni",
    "rewards.yourPoints": "Twoje punkty",
    "rewards.level": "Poziom: {{current}}",
    "rewards.levelNext": "{{current}} → {{next}}",
    "rewards.availableRewards": "Dostępne nagrody",
    "rewards.exclusiveApp": "Ekskluzywne w aplikacji — niedostępne w sklepie",
    "rewards.comingSoon": "Wkrótce",
    "rewards.comingSoonDesc": "Przygotowujemy dla ciebie ekskluzywne nagrody. Zbieraj dalej punkty!",
    "rewards.merchandise": "Merchandise",
    "rewards.exclusiveProduct": "Produkt ekskluzywny",
    "rewards.experience": "Doświadczenie",
    "rewards.outOfStock": "Wyprzedane",
    "rewards.redeem": "Wymień",
    "rewards.missingPoints": "Brakuje {{count}} pkt",
    "rewards.linkAccountForRewards": "Musisz połączyć swój email, aby wymieniać nagrody.",
    "rewards.insufficientPoints": "Niewystarczające punkty",
    "rewards.insufficientPointsDesc": "Brakuje ci {{count}} punktów, aby wymienić \"{{name}}\". Kontynuuj swój codzienny rytuał!",
    "rewards.redeemConfirm": "Wymień nagrodę",
    "rewards.redeemConfirmDesc": "Chcesz wymienić \"{{name}}\" za {{points}} punktów?",
    "rewards.redeemed": "Nagroda wymieniona! 🎉",
    "rewards.redeemedDesc": "Otrzymasz więcej informacji e-mailem.",
    "rewards.redeemError": "Błąd podczas wymiany",
    "rewards.myRedemptions": "Moje wymiany",
    "rewards.statusPending": "⏳ Oczekuje",
    "rewards.statusProcessing": "📦 Przygotowywane",
    "rewards.statusShipped": "🚚 Wysłane",
    "rewards.statusDelivered": "✅ Dostarczone",
    "rewards.howItWorks": "Jak to działa?",
    "rewards.howStep1": "Ukończ swój codzienny rytuał, aby zdobywać punkty",
    "rewards.howStep2": "Zbieraj punkty z serii, zakupów i polecań",
    "rewards.howStep3": "Wymieniaj punkty na ekskluzywne nagrody",
    "rewards.morePointsNeeded": "{{count}} pkt więcej do {{level}}",
    "rewards.rewardsTitle": "Nagrody",
    "rewards.pointsAvailable": "punktów dostępnych",
    "rewards.howToEarnPoints": "Jak zdobywać punkty?",
    "rewards.earn_purchases": "Zakupy: +1 pkt za każde wydane 1€",
    "rewards.earn_ritualStep": "Każdy krok codziennego Rytuału: +1 pkt",
    "rewards.earn_ritualComplete": "Ukończ codzienny Rytuał: +5 pkt bonus",
    "rewards.earn_referralRegister": "Zaproś znajomych: +50 pkt za rejestrację",
    "rewards.earn_referralPurchase": "Zakup twojego gościa: +150 pkt",
    "rewards.earn_survey": "Wypełnianie ankiet: zmienne punkty",
    "rewards.earn_review": "Napisz opinię o zakupie: +50 pkt",
    "orders.myOrders": "Moje zamówienia",
    "orders.processing": "W trakcie realizacji",
    "orders.delivered": "Dostarczone",
    "orders.inTransit": "W transporcie",
    "orders.shipped": "Wysłane",
    "orders.partiallySent": "Częściowo wysłane",
    "orders.inPreparation": "W przygotowaniu",
    "orders.cancelled": "Anulowano",
    "orders.login": "Zaloguj się",
    "orders.loginDesc": "Połącz swoje konto, aby zobaczyć zamówienia",
    "orders.linkAccount": "Połącz konto",
    "orders.loadingOrders": "Ładowanie zamówień...",
    "orders.loadError": "Błąd ładowania",
    "orders.noOrders": "Brak zamówień",
    "orders.noOrdersDesc": "Nie złożyłeś jeszcze żadnego zamówienia",
    "orders.goToShop": "Przejdź do sklepu",
    "orders.viewDetail": "Zobacz szczegóły",
    "orders.loadMore": "Załaduj więcej zamówień",
    "orders.exception": "Problem",
    "orders.outForDelivery": "W doręczeniu",
    "orders.returned": "Zwrócono",
    "orders.refunded": "Zwrócono",
    "surveys.title": "Nowości",
    "surveys.subtitle": "Odkryj najnowsze wiadomości, ankiety i ekskluzywne treści",
    "surveys.noSurveys": "Brak dostępnych nowości",
    "surveys.noSurveysDesc": "Powiadomimy cię, gdy pojawią się nowości. Kontynuuj swój codzienny rytuał!",
    "surveys.question": "Pytanie {{number}}",
    "surveys.required": "Wymagane",
    "surveys.answered": "{{answered}} z {{total}} odpowiedziane",
    "surveys.writeAnswer": "Napisz swoją odpowiedź...",
    "surveys.completeSurvey": "Ukończ ankietę",
    "surveys.thanks": "Dziękujemy!",
    "surveys.pointsEarned": "Zdobyłeś ⭐ {{points}} punktów",
    "surveys.answersHelp": "Twoje odpowiedzi pomagają nam poprawić doświadczenie matcha 🍵",
    "surveys.surveyNotFound": "Ankieta nie znaleziona",
    "surveys.loadError": "Nie udało się załadować ankiety.",
    "surveys.submitError": "Błąd podczas wysyłania ankiety",
    "surveys.questions_one": "{{count}} pytanie",
    "surveys.questions_other": "{{count}} pytań",
    "surveys.survey": "Ankieta",
    "profile.myProfile": "Mój profil",
    "profile.matchaPoints": "⭐ {{count}} Matcha Points",
    "profile.orders": "Zamówienia",
    "profile.points": "Punkty",
    "profile.streak": "Seria",
    "profile.badges": "Odznaki",
    "profile.shippingAddress": "Adres dostawy",
    "profile.edit": "Edytuj",
    "profile.add": "Dodaj",
    "profile.firstName": "Imię",
    "profile.lastName": "Nazwisko",
    "profile.phone": "Telefon",
    "profile.address": "Adres",
    "profile.addressPlaceholder": "Ulica, numer, piętro...",
    "profile.addressLine2": "Adres (linia 2)",
    "profile.optional": "Opcjonalnie",
    "profile.city": "Miasto",
    "profile.zip": "Kod pocztowy",
    "profile.province": "Województwo",
    "profile.country": "Kraj",
    "profile.invalidPhone": "Nieprawidłowy numer telefonu",
    "profile.addressUpdated": "Adres zaktualizowany",
    "profile.addressSaved": "Twój adres dostawy został zapisany.",
    "profile.saveError": "Błąd zapisu adresu",
    "profile.saving": "Zapisywanie...",
    "profile.saveAddress": "Zapisz adres",
    "profile.addShippingAddress": "Dodaj adres dostawy",
    "profile.inviteFriend": "Zaproś znajomego",
    "profile.inviteReward": "Zdobądź 100 pkt za każdego znajomego, który kupi",
    "profile.shareLink": "Udostępnij link",
    "profile.shareMessage": "Wypróbuj Matcha & CO! Użyj mojego kodu, aby uzyskać zniżkę na pierwsze zamówienie. https://matchaandco.com",
    "profile.notifications": "Powiadomienia",
    "profile.myOrdersMenu": "Moje zamówienia",
    "profile.quickReorder": "Szybkie ponowne zamówienie",
    "profile.helpSupport": "Pomoc i wsparcie",
    "profile.terms": "Regulamin",
    "profile.signOut": "Wyloguj się",
    "profile.signOutConfirm": "Jesteś pewien?",
    "profile.language": "Język",
    "profile.selectLanguage": "Wybierz swój język",
    "profile.selectProvince": "Wybierz prowincję",
    "profile.searchProvince": "Szukaj prowincji...",
    "profile.selectCountry": "Wybierz kraj",
    "profile.referralCodeTitle": "Kod polecający",
    "profile.referralCodePlaceholder": "Wpisz swój kod",
    "profile.referralCodeHint": "Masz kod polecający? Wpisz go, aby zdobyć dodatkowe punkty",
    "profile.applyCode": "Zastosuj kod",
    "profile.referralApplied": "Kod zastosowany pomyślnie",
    "profile.referralConverted": "Polecenie przekonwertowane",
    "profile.referralError": "Nieprawidłowy kod",
    "profile.referralAlready": "Już zastosowałeś kod polecający",
    "profile.referralSelf": "Nie możesz użyć własnego kodu",
    "profile.referralNotFound": "Nie znaleziono kodu",
    "profile.referralExpired": "Ten kod wygasł",
    "profile.referralInvited": "Zaproszeni",
    "profile.referralPointsEarned": "Zdobyte pkt",
    "profile.shareMessageWithLink": "Wypróbuj Matcha & CO! Pobierz aplikację i zdobądź 25 punktów powitalnych 🍵 {{link}}",
    "profile.yourReferralCode": "Twój kod polecający",
    "profile.paymentMethod": "Metoda płatności",
    "profile.paymentMethodHint": "Zapisz metodę płatności, aby kupować jednym kliknięciem",
    "profile.paymentMethodUpdated": "Metoda płatności zaktualizowana",
    "profile.paymentMethodUpdatedDesc": "Twoja metoda płatności została zapisana pomyślnie.",
    "auth.linkAccount": "Połącz swoje konto",
    "orderStatus.processing": "W trakcie realizacji",
    "orderStatus.delivered": "Dostarczone",
    "orderStatus.inTransit": "W transporcie",
    "orderStatus.shipped": "Wysłane",
    "orderStatus.partiallySent": "Częściowo wysłane",
    "language.es": "Español",
    "language.en": "English",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.it": "Italiano",
    "language.nl": "Nederlands",
    "language.de": "Deutsch",
    "language.pl": "Polski",
    "product.notFound": "Produkt nie znaleziony",
    "product.back": "Wstecz",
    "product.variant": "Wariant",
    "product.quantity": "Ilość",
    "product.description": "Opis",
    "product.addToCart": "Dodaj do koszyka",
    "product.addedToCart": "Dodano do koszyka",
    "product.continueShopping": "Kontynuuj zakupy",
    "product.viewCart": "Zobacz koszyk",
    "product.unit_one": "sztuka",
    "product.unit_other": "sztuk",
    "product.ingredients": "Składniki",
    "checkout.confirmOrder": "Potwierdź zamówienie",
    "checkout.cartEmpty": "Twój koszyk jest pusty",
    "checkout.products": "Produkty",
    "checkout.shippingAddress": "Adres dostawy",
    "checkout.changeAddress": "Zmień adres",
    "checkout.addAddress": "Dodaj adres",
    "checkout.couldNotLoadAddress": "Nie udało się załadować adresu",
    "checkout.paymentMethod": "Metoda płatności",
    "checkout.changePayment": "Zmień metodę płatności",
    "checkout.useStandardCheckout": "Użyj standardowej kasy",
    "checkout.couldNotLoadPayment": "Nie udało się załadować metody płatności",
    "checkout.noPaymentMethod": "Brak zapisanej metody płatności",
    "checkout.addPaymentMethod": "Dodaj kartę",
    "checkout.subtotal": "Suma częściowa",
    "checkout.shipping": "Wysyłka",
    "checkout.tax": "Podatek",
    "checkout.free": "Bezpłatna",
    "checkout.total": "Suma",
    "checkout.securePayment": "Bezpieczna płatność",
    "checkout.placeOrder": "Złóż zamówienie",
    "checkout.quantity": "Ilość: {{count}}",
    "checkout.requiredFields": "Pola wymagane",
    "checkout.requiredFieldsDesc": "Wypełnij przynajmniej imię, adres, miasto i kod pocztowy.",
    "checkout.addressError": "Nie udało się zaktualizować adresu. Spróbuj ponownie.",
    "checkout.orderSuccess": "Zamówienie złożone! 🎉",
    "checkout.orderSuccessDesc": "Twoje zamówienie zostało przetworzone. Otrzymasz email potwierdzający.",
    "checkout.orderSuccessBtn": "Świetnie",
    "checkout.orderError": "Nie udało się przetworzyć zamówienia. Spróbuj ponownie.",
    "checkout.unexpectedError": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie.",
    "checkout.checkoutError": "Nie udało się utworzyć zamówienia. Spróbuj ponownie.",
    "checkout.card": "Karta",
    "checkout.freeShipping": "Darmowa dostawa",
    "checkout.freeShippingAt": "Darmowa wysyłka od {{amount}}",
    "checkout.firstName": "Imię *",
    "checkout.lastName": "Nazwisko *",
    "checkout.phone": "Telefon *",
    "checkout.address": "Adres *",
    "checkout.floor": "Piętro / Drzwi",
    "checkout.zip": "Kod pocztowy *",
    "checkout.city": "Miasto *",
    "checkout.optional": "Opcjonalnie",
    "checkout.streetNumber": "Ulica i numer",
    "checkout.urlNotAvailable": "URL kasy niedostępny",
    "checkout.secureCheckout": "Bezpieczna kasa",
    "checkout.loading": "Ładowanie kasy...",
    "checkout.paymentDeclined": "Płatność została odrzucona. Sprawdź swoją kartę i spróbuj ponownie.",
    "checkout.paymentError_INSUFFICIENT_FUNDS": "Niewystarczające środki. Sprawdź saldo swojej karty.",
    "checkout.paymentError_PAYMENT_DECLINED": "Płatność została odrzucona przez Twój bank.",
    "checkout.paymentError_INVALID_PAYMENT_METHOD": "Metoda płatności jest nieprawidłowa. Zaktualizuj ją w swoim profilu.",
    "checkout.paymentError_EXPIRED_PAYMENT_METHOD": "Twoja karta wygasła. Zaktualizuj metodę płatności.",
    "checkout.paymentError_AUTHENTICATION_ERROR": "Wymagana autoryzacja. Spróbuj ponownie.",
    "checkout.paymentError_PAYMENT_PROCESSING": "Płatność jest przetwarzana. Proszę poczekać kilka minut i sprawdzić zamówienia.",
    "checkout.email": "Email",
    "checkout.emailPlaceholder": "twoj@email.com",
    "checkout.continue": "Kontynuuj",
    "checkout.loginForAddress": "Podaj email, aby dodać adres",
    "checkout.loginForPayment": "Podaj email, aby dodać metodę płatności",
    "checkout.emailError": "Nie udało się powiązać emaila. Spróbuj ponownie.",
    "checkout.verifyCode": "Zweryfikuj kod",
    "checkout.invalidCode": "Nieprawidłowy lub wygasły kod. Spróbuj ponownie.",
    "checkout.codeSent": "Kod wysłany na {{email}}",
    "checkout.pickupPoint": "Punkt odbioru",
    "checkout.noServicePoints": "Nie znaleziono punktów odbioru w pobliżu",
    "reorder.repeatOrder": "Powtórz zamówienie",
    "reorder.adjustQuantities": "Dostosuj ilości i potwierdź jednym dotknięciem",
    "reorder.products": "Produkty",
    "reorder.shippingAddress": "Adres dostawy",
    "reorder.loadingAddress": "Ładowanie adresu...",
    "reorder.change": "Zmień",
    "reorder.add": "Dodaj",
    "reorder.total": "Suma",
    "reorder.changesNote": "* Ilości zmienione w stosunku do ostatniego zamówienia",
    "reorder.repeatBtn": "Powtórz zamówienie",
    "reorder.loadingOrder": "Ładowanie zamówienia...",
    "reorder.noPreviousOrder": "Brak poprzedniego zamówienia",
    "reorder.noPreviousOrderDesc": "Nie znaleziono aktywnego kontraktu ponownego zamówienia. Złóż pierwsze zamówienie w sklepie.",
    "reorder.goToShop": "Przejdź do sklepu",
    "reorder.noProducts": "Brak produktów",
    "reorder.noProductsDesc": "Dodaj co najmniej jeden produkt, aby powtórzyć zamówienie.",
    "reorder.orderSuccess": "Zamówienie złożone! 🎉",
    "reorder.orderSuccessDesc": "Twoje zamówienie zostało przetworzone. Otrzymasz email potwierdzający.",
    "reorder.orderSuccessBtn": "Świetnie",
    "reorder.orderError": "Nie udało się przetworzyć zamówienia. Spróbuj ponownie.",
    "reorder.unexpectedError": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie.",
    "reorder.addressError": "Nie udało się zaktualizować adresu.",
    "reorder.requiredFields": "Pola wymagane",
    "reorder.requiredFieldsDesc": "Wypełnij przynajmniej imię, adres, miasto i kod pocztowy.",
    "reorder.product": "Produkt",
    "orderDetail.order": "Zamówienie",
    "orderDetail.orders": "Zamówienia",
    "orderDetail.loadingOrder": "Ładowanie zamówienia...",
    "orderDetail.loadError": "Błąd ładowania",
    "orderDetail.orderNotFound": "Zamówienie nie znalezione",
    "orderDetail.retry": "Spróbuj ponownie",
    "orderDetail.shippingStatus": "Status wysyłki",
    "orderDetail.confirmed": "Zamówienie potwierdzone",
    "orderDetail.confirmedDesc": "Twoje zamówienie zostało przyjęte",
    "orderDetail.preparing": "W przygotowaniu",
    "orderDetail.preparingDesc": "Przygotowujemy Twoją matcha",
    "orderDetail.shipped": "Wysłane",
    "orderDetail.shippedDesc": "W drodze do Ciebie",
    "orderDetail.delivered": "Dostarczone",
    "orderDetail.deliveredDesc": "Ciesz się swoją matcha!",
    "orderDetail.cancelled": "Anulowane",
    "orderDetail.products": "Produkty",
    "orderDetail.quantity": "Ilość: {{count}}",
    "orderDetail.summary": "Podsumowanie",
    "orderDetail.shippingAddress": "Adres dostawy",
    "orderDetail.paymentStatus": "Status płatności",
    "orderDetail.total": "Suma",
    "orderDetail.repeatThisOrder": "Powtórz to zamówienie",
    "orderDetail.repeatConfirm": "Powtórz zamówienie",
    "orderDetail.repeatConfirmDesc": "Chcesz powtórzyć to zamówienie matcha?",
    "orderDetail.repeatSuccess": "Zamówienie złożone! 🎉",
    "orderDetail.repeatSuccessDesc": "Twoja matcha jest w drodze.",
    "orderDetail.repeatError": "Nie udało się przetworzyć ponownego zamówienia",
    "orderDetail.needHelp": "Potrzebujesz pomocy?",
    "orderDetail.needHelpDesc": "Skontaktuj się z obsługą, jeśli masz pytania dotyczące zamówienia",
    "orderDetail.contactSupport": "Skontaktuj się z obsługą",
    "orderDetail.inTransit": "W transporcie",
    "orderDetail.outForDelivery": "W doręczeniu",
    "orderDetail.outForDeliveryDesc": "Twoje zamówienie dotrze dzisiaj!",
    "orderDetail.exception": "Problem",
    "orderDetail.exceptionDesc": "Wystąpił problem z Twoją przesyłką",
    "orderDetail.returned": "Zwrócone",
    "orderDetail.returnedDesc": "Twoja paczka została zwrócona",
    "orderDetail.inTransitDesc": "Twoje zamówienie jest w drodze",
    "orderDetail.trackShipment": "Śledź przesyłkę",
    "orderDetail.trackingEvents": "Historia wysyłki",
    "redeem.rewardNotFound": "Nagroda nie znaleziona",
    "redeem.couldNotLoadReward": "Nie udało się załadować nagrody.",
    "redeem.rewardRedeemed": "Nagroda wymieniona!",
    "redeem.experienceInfo": "Otrzymasz więcej informacji e-mailem.",
    "redeem.physicalInfo": "Wyślemy ją wkrótce na Twój adres.",
    "redeem.pointsSpent": "−{{cost}} punktów • Saldo: ⭐ {{balance}}",
    "redeem.backToRewards": "Wróć do nagród",
    "redeem.cost": "Koszt",
    "redeem.yourBalance": "Twoje saldo",
    "redeem.missingPoints": "Brakuje Ci {{count}} punktów",
    "redeem.addressNeeded": "Wymagany adres",
    "redeem.addressNeededDesc": "Dodaj adres dostawy, aby otrzymać nagrodę.",
    "redeem.noAddressSaved": "Nie masz zapisanego adresu",
    "redeem.addAddress": "Dodaj adres",
    "redeem.changeAddress": "Zmień adres",
    "redeem.confirmRedeem": "Potwierdź wymianę",
    "redeem.redeemError": "Błąd podczas wymiany nagrody",
    "redeem.insufficientPoints": "Niewystarczające punkty",
    "redeem.insufficientPointsDesc": "Brakuje Ci {{count}} punktów, aby wymienić \"{{name}}\".",
    "savedRecipes.title": "Moje zapisane przepisy",
    "savedRecipes.deleteRecipe": "Usuń przepis",
    "savedRecipes.deleteConfirm": "Chcesz usunąć ten przepis z zapisanych?",
    "savedRecipes.noRecipes": "Brak zapisanych przepisów",
    "savedRecipes.noRecipesDesc": "Zapisuj przepisy, które ci się podobają podczas codziennego rytuału, aby je tu znaleźć.",
    "recipeDetail.notFound": "Przepis nie znaleziony",
    "recipeDetail.ingredients": "Składniki",
    "recipeDetail.preparation": "Przygotowanie",
    "recipeDetail.servings": "{{count}} porcji",
    "recipeDetail.viewSource": "Zobacz na matchaandco.com",
    "notifications.title": "Powiadomienia",
    "notifications.profile": "Profil",
    "notifications.disabled": "Powiadomienia wyłączone",
    "notifications.disabledDesc": "Włącz powiadomienia, aby nie przegapić codziennego rytuału",
    "notifications.enable": "Włącz powiadomienia",
    "notifications.enabled": "Gotowe!",
    "notifications.enabledDesc": "Powiadomienia są włączone",
    "notifications.permissionsNeeded": "Wymagane uprawnienia",
    "notifications.permissionsNeededDesc": "Aby otrzymywać powiadomienia, włącz je w ustawieniach urządzenia.",
    "notifications.couldNotLoad": "Nie udało się załadować preferencji",
    "notifications.couldNotSave": "Nie udało się zapisać preferencji",
    "notifications.saving": "Zapisywanie...",
    "notifications.quietHours": "Godziny ciszy",
    "notifications.quietHoursDesc": "Nie otrzymasz powiadomień między {{start}} a {{end}}",
    "notifications.dailyReminder": "Codzienne przypomnienie",
    "notifications.dailyReminderDesc": "Przypominamy o porannym rytuale",
    "notifications.streakWarning": "Ostrzeżenie o serii",
    "notifications.streakWarningDesc": "Ostrzeżenie przed utratą serii",
    "notifications.orderStatus": "Status zamówienia",
    "notifications.orderStatusDesc": "Aktualizacje wysyłki i dostawy",
    "notifications.restockReminder": "Przypomnienie o uzupełnieniu",
    "notifications.restockReminderDesc": "Gdy Twoja matcha się kończy",
    "notifications.rewardsAvailable": "Dostępne nagrody",
    "notifications.rewardsAvailableDesc": "Gdy możesz wymienić punkty",
    "notifications.contentNew": "Nowa treść",
    "notifications.contentNewDesc": "Nowe przepisy i medytacje",
    "notifications.announcements": "Ogłoszenia",
    "notifications.announcementsDesc": "Nowości od Matcha & CO",
    "notifications.subscriptionInfo": "Info o subskrypcji",
    "notifications.subscriptionInfoDesc": "Odnowienia i zmiany",
    "onboarding.skip": "Pomiń",
    "onboarding.next": "Dalej →",
    "onboarding.linkAccount": "Połącz konto",
    "onboarding.exploreWithoutAccount": "Przeglądaj bez konta",
    "onboarding.welcomeTitle": "Witamy w Matcha & CO",
    "onboarding.welcomeDesc": "Twój sklep z matcha z ponownym zamówieniem jednym kliknięciem. Ale także narzędzie Mindfulness do dbania o samopoczucie każdego dnia.",
    "onboarding.ritualTitle": "Czym jest Rytuał?",
    "onboarding.ritualDesc": "Codzienna praktyka, aby być bardziej świadomym tego, jak się czujesz i włączyć dobre nawyki do swojej rutyny.",
    "onboarding.ritualStep1Name": "Check-in emocjonalny",
    "onboarding.ritualStep1Desc": "Jak się dziś czujesz?",
    "onboarding.ritualStep2Name": "Przepis dnia",
    "onboarding.ritualStep2Desc": "Spersonalizowany przepis na matcha",
    "onboarding.ritualStep3Name": "Medytacja",
    "onboarding.ritualStep3Desc": "Chwila spokoju i uważności",
    "onboarding.ritualStep4Name": "Matcha",
    "onboarding.ritualStep4Desc": "Zapisz swój moment matcha dnia",
    "onboarding.ritualStep5Name": "Dziennik",
    "onboarding.ritualStep5Desc": "Zastanów się nad swoim dniem",
    "onboarding.pointsTitle": "Matcha Points ⭐",
    "onboarding.pointsDesc": "Zdobywaj punkty za rytuał, zakupy, polecenia i serie. Wymieniaj je na ekskluzywne nagrody niedostępne w sklepie.",
    "onboarding.streaksTitle": "Serie 🔥",
    "onboarding.streaksDesc": "Każdy dzień z check-inem matcha powiększa twoją serię. Osiągaj kamienie milowe (5, 10, 30 dni) za punkty bonusowe. Opuść dzień, a seria wraca do zera!",
    "onboarding.letsGoTitle": "Zaczynamy!",
    "onboarding.letsGoDesc": "Połącz e-mail, aby zsynchronizować zamówienia, punkty i odblokować pełne doświadczenie. Lub najpierw przeglądaj.",
    "linkAccount.title": "Połącz swoje konto",
    "linkAccount.subtitle": "Wprowadź swój email, a wyślemy ci magiczny link do połączenia urządzenia.",
    "linkAccount.sendMagicLink": "Wyślij magiczny link",
    "linkAccount.enterCode": "Wprowadź kod",
    "linkAccount.codeSent": "Wysłaliśmy 6-cyfrowy kod na",
    "linkAccount.verifyCode": "Zweryfikuj kod",
    "linkAccount.resendCode": "Wyślij kod ponownie",
    "linkAccount.accountLinked": "Konto połączone",
    "linkAccount.deviceLinked": "Twoje urządzenie jest połączone z",
    "linkAccount.backToProfile": "Wróć do profilu",
    "linkAccount.sendError": "Błąd wysyłania linku",
    "linkAccount.codeError": "Nieprawidłowy kod",
    "linkAccount.haveReferralCode": "Masz kod polecający?",
    "linkAccount.validateEmail": "Wpisz prawidłowy e-mail",
    "completeProfile.title": "Uzupełnij swój profil",
    "completeProfile.subtitle": "Aby spersonalizować Twoje doświadczenie, potrzebujemy kilku danych",
    "completeProfile.firstName": "Imię *",
    "completeProfile.lastName": "Nazwisko *",
    "completeProfile.phone": "Telefon (opcjonalnie)",
    "completeProfile.save": "Zapisz profil",
    "completeProfile.error": "Błąd podczas uzupełniania profilu",
    "completeProfile.firstNamePlaceholder": "Imię",
    "completeProfile.lastNamePlaceholder": "Nazwisko",
    "suggestedProducts.title": "Może ci się też spodobać",
    "suggestedProducts.add": "Dodaj"
  }
};